<template>
    <div>
        <div class="right_section">
            <div class="alignment_section d-none" v-if="editable">
                <div
                    class="right_items w-100"
                    :class="{ checkbox_checked: implicitylocation.is_selected }"
                    v-for="(
                        implicitylocation, l_inx
                    ) in getGenderImprintLocations()"
                    :key="l_inx"
                >
                    <div
                        class="images_right"
                        @click="selectImprintLocations(l_inx)"
                    >
                        <img
                            class="direct"
                            :src="implicitylocation.image_path"
                            alt=""
                        />
                        <input
                            type="checkbox"
                            :name="'is_selected_location' + l_inx"
                            :class="{ checked: implicitylocation.is_selected }"
                            :id="'same-address' + l_inx"
                            :checked="implicitylocation.is_selected"
                        />
                    </div>
                    <p>{{ implicitylocation.location }}</p>
                </div>
            </div>
            <div class="colors_qty_details_section" v-if="editable">
                <div class="colors_qty_header">
                    <h2 class="colors_qty_title">Colors And Qty Details</h2>
                    <p class="colors_qty_note">
                        Note: You can add or modify colors from the left panel.
                    </p>
                </div>
                <div class="color-itmes-main">
                    <div
                        class="color_config_section"
                        v-for="(color, colorIndex) in genderGroups[
                            active_gender_index
                        ].colors"
                        :key="color.id || colorIndex"
                    >
                        <div
                            class="color_config_header"
                            @click="toggleColorSection(color.id || colorIndex)"
                        >
                            <div class="color_swatch_name">
                                <img
                                    v-if="color.swatches"
                                    class="color_swatch"
                                    :src="color.swatches"
                                />
                                <div
                                    v-else
                                    class="color_swatch"
                                    :style="
                                        'background: ' +
                                        (color.hash ||
                                            color.color_value ||
                                            '#ccc')
                                    "
                                ></div>
                                <h5 class="color_name_text">
                                    {{ converToCamel(color.color_name) }}
                                </h5>
                            </div>
                            <svg
                                v-if="isColorExpanded(color.id || colorIndex)"
                                width="14"
                                height="8"
                                viewBox="0 0 14 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13 7L7 1L1 7"
                                    stroke="black"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <svg
                                v-else
                                width="14"
                                height="8"
                                viewBox="0 0 14 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 1L7 7L13 1"
                                    stroke="black"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>

                        <div
                            v-if="isColorExpanded(color.id || colorIndex)"
                            class="color_config_content"
                        >
                            <div class="size_qty_section">
                                <div class="size_qty_header">
                                    <h6 class="size_qty_title">Size and Qty</h6>
                                    <button
                                        type="button"
                                        class="delete_color_btn"
                                        :disabled="
                                            !(
                                                genderGroups[
                                                    active_gender_index
                                                ] &&
                                                genderGroups[
                                                    active_gender_index
                                                ].colors &&
                                                genderGroups[
                                                    active_gender_index
                                                ].colors.length > 1
                                            )
                                        "
                                        @click="
                                            deleteColor(color.id || colorIndex)
                                        "
                                    >
                                        <img
                                            src="/maincss/images/icons/delete.svg"
                                            alt="delete"
                                        />
                                    </button>
                                </div>
                                <div class="size_qty_table">
                                    <div class="size_price_row">
                                        <div
                                            class="size_price_item"
                                            v-for="(gendersizes, indx) in color[
                                                'unique_sizes'
                                            ]"
                                            :key="indx"
                                        >
                                            <div class="size_label">
                                                {{ gendersizes.Size.size }}
                                            </div>
                                            <div class="price_label">
                                                {{
                                                    icPriceFormat(
                                                        getSizeCostWithDiscount(
                                                            gendersizes.cost ||
                                                                0
                                                        )
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="size_qty_input_row">
                                        <div
                                            class="size_qty_input_item"
                                            v-for="(gendersizes, indx) in color[
                                                'unique_sizes'
                                            ]"
                                            :key="indx"
                                        >
                                            <input
                                                type="text"
                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                                v-model="gendersizes.quantity"
                                                @change="
                                                    calculatePricing(
                                                        active_gender_index,
                                                        gendersizes,
                                                        $event
                                                    )
                                                "
                                                class="qty_input"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="print_area_config_section"
                                v-if="editable"
                            >
                                <div
                                    class="row left_botom_0 validation-error-text ml-1"
                                    v-if="colorsValidation != ''"
                                >
                                    {{ colorsValidation }}
                                </div>
                                <template
                                    v-for="(
                                        implicitylocation, l_inx
                                    ) in getColorImprintLocations(color)"
                                >
                                    <div
                                        v-if="implicitylocation.is_selected"
                                        :key="l_inx"
                                        class="print_area_item"
                                    >
                                        <div class="print_area_header">
                                            <h6 class="print_area_label">
                                                {{ implicitylocation.location }}
                                            </h6>
                                            <div class="print_area_controls">
                                                <div
                                                    class="form-group mt-0 color_count_select"
                                                >
                                                    <v-select
                                                        width="100%"
                                                        placeholder="Select-colors"
                                                        label="value"
                                                        :reduce="
                                                            (color) => color.id
                                                        "
                                                        :options="
                                                            imprintcityColors
                                                        "
                                                        v-model="
                                                            implicitylocation.no_of_color
                                                        "
                                                        @input="
                                                            selectNumberOfColors(
                                                                implicitylocation,
                                                                $event
                                                            )
                                                        "
                                                        :style="
                                                            disable_imprint_locations
                                                                ? disabled_styles
                                                                : ''
                                                        "
                                                    >
                                                    </v-select>
                                                </div>
                                                <button
                                                    type="button"
                                                    class="add_remove_color_btn"
                                                    @click.stop="
                                                        onCollapaseLocationColors(
                                                            implicitylocation
                                                        )
                                                    "
                                                    v-if="
                                                        implicitylocation.colors &&
                                                        implicitylocation.colors
                                                            .length > 0
                                                    "
                                                >
                                                    <!-- Minus icon when collapsed (collapse = true) -->
                                                    <svg
                                                        v-if="
                                                            implicitylocation.collapse
                                                        "
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                            stroke="#1D6CB5"
                                                            stroke-width="1.3"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                        <path
                                                            d="M8 12H16"
                                                            stroke="#1D6CB5"
                                                            stroke-width="1.3"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                    <!-- Plus icon when expanded (collapse = false or undefined) -->
                                                    <svg
                                                        v-else
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                            stroke="#1D6CB5"
                                                            stroke-width="1.3"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                        <path
                                                            d="M8 12H16"
                                                            stroke="#1D6CB5"
                                                            stroke-width="1.3"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                        <path
                                                            d="M12 8V16"
                                                            stroke="#1D6CB5"
                                                            stroke-width="1.3"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div
                                            :id="`collapseColors${l_inx}`"
                                            :class="
                                                implicitylocation.collapse
                                                    ? 'print_area_content show'
                                                    : 'print_area_content'
                                            "
                                            v-show="implicitylocation.no_of_color"
                                        >
                                            <div
                                                class="thread_color_item"
                                                v-show="
                                                    (implicitylocation.no_of_color >
                                                        0 &&
                                                        implicitylocation.no_of_color !==
                                                            'full_color' &&
                                                        !implicitylocation.is_full_color) ||
                                                    implicitylocation.no_of_color ===
                                                        'full_color' ||
                                                    implicitylocation.is_full_color ===
                                                        true
                                                "
                                                v-for="(
                                                    colors, c_inx
                                                ) in implicitylocation.colors"
                                                :key="c_inx"
                                            >
                                                <label
                                                    class="thread_color_label"
                                                >
                                                    <span
                                                        v-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            1
                                                        "
                                                        >Ink -
                                                        {{ c_inx + 1 }}</span
                                                    >
                                                    <span
                                                        v-else-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            2
                                                        "
                                                        >Thread -
                                                        {{ c_inx + 1 }}</span
                                                    >
                                                    <span
                                                        v-else-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            3
                                                        "
                                                        >Vinyl -
                                                        {{ c_inx + 1 }}</span
                                                    >
                                                    <span
                                                        v-else-if="
                                                            genderGroups[
                                                                active_gender_index
                                                            ]['item']
                                                                .decoration_type ==
                                                            0
                                                        "
                                                    >
                                                        <template
                                                            v-if="
                                                                activeDecorationService &&
                                                                activeDecorationService.name &&
                                                                (activeDecorationService.name
                                                                    .toLowerCase()
                                                                    .includes(
                                                                        'embroidery'
                                                                    ) ||
                                                                    activeDecorationService.name
                                                                        .toLowerCase()
                                                                        .includes(
                                                                            'emb'
                                                                        ))
                                                            "
                                                            >Thread -
                                                            {{
                                                                c_inx + 1
                                                            }}</template
                                                        >
                                                        <template
                                                            v-else-if="
                                                                activeDecorationService &&
                                                                activeDecorationService.name &&
                                                                activeDecorationService.name
                                                                    .toLowerCase()
                                                                    .includes(
                                                                        'print'
                                                                    )
                                                            "
                                                            >Ink -
                                                            {{
                                                                c_inx + 1
                                                            }}</template
                                                        >
                                                        <template v-else
                                                            >Color -
                                                            {{
                                                                c_inx + 1
                                                            }}</template
                                                        >
                                                    </span>
                                                </label>
                                                <div
                                                    class="thread_color_select"
                                                >
                                                    <v-select
                                                        :key="`color-${l_inx}-${c_inx}-${activeColorIndex}`"
                                                        :filter="fuseSearch"
                                                        :options="vendorColors"
                                                        :get-option-label="
                                                            (option) =>
                                                                option.color_name
                                                        "
                                                        :value="
                                                            getLocationColor(
                                                                l_inx,
                                                                c_inx,
                                                                activeColorIndex
                                                            )
                                                        "
                                                        placeholder="Select"
                                                        @input="
                                                            selectVendorColors(
                                                                $event,
                                                                c_inx,
                                                                l_inx,
                                                                activeColorIndex
                                                            )
                                                        "
                                                        :disabled="
                                                            disable_imprint_locations
                                                                ? true
                                                                : false
                                                        "
                                                    >
                                                        <!-- eslint-disable -->
                                                        <template
                                                            #selected-option-container="{
                                                                option,
                                                                deselect,
                                                                multiple,
                                                                disabled
                                                            }"
                                                        >
                                                            <span
                                                                class="vs__selected"
                                                            >
                                                                <cite
                                                                    v-if="
                                                                        option.color_value
                                                                    "
                                                                    class="imprint_color_box color-box-tooltip"
                                                                    v-bind:style="
                                                                        'background:' +
                                                                        option.color_value
                                                                    "
                                                                    :title="
                                                                        option.color_value
                                                                    "
                                                                    :data-hex="
                                                                        option.color_value
                                                                    "
                                                                ></cite>
                                                                <img
                                                                    v-else-if="
                                                                        option.swatch_file
                                                                    "
                                                                    class="imprint_color_box"
                                                                    :src="
                                                                        option.swatch_file
                                                                    "
                                                                    alt=""
                                                                />
                                                                <span
                                                                    v-if="
                                                                        option.color_id ==
                                                                            0 &&
                                                                        (!activeDecorationService ||
                                                                            !activeDecorationService.name ||
                                                                            (!activeDecorationService.name
                                                                                .toLowerCase()
                                                                                .includes(
                                                                                    'print'
                                                                                ) &&
                                                                                !activeDecorationService.name
                                                                                    .toLowerCase()
                                                                                    .includes(
                                                                                        'embroidery'
                                                                                    ) &&
                                                                                !activeDecorationService.name
                                                                                    .toLowerCase()
                                                                                    .includes(
                                                                                        'emb'
                                                                                    )))
                                                                    "
                                                                >
                                                                    {{
                                                                        option.color_value ||
                                                                        option.color_name
                                                                    }}
                                                                </span>
                                                                <span v-else>
                                                                    {{
                                                                        option.color_name
                                                                    }}
                                                                </span>
                                                                <span
                                                                    v-if="
                                                                        option.color_id ==
                                                                            0 &&
                                                                        option.non_standard_fee &&
                                                                        parseFloat(
                                                                            option.non_standard_fee
                                                                        ) > 0
                                                                    "
                                                                    style="
                                                                        margin-top: 1.2px;
                                                                        margin-left: 1px;
                                                                    "
                                                                    >{{
                                                                        icPriceFormat(
                                                                            option.non_standard_fee ||
                                                                                0
                                                                        )
                                                                    }}</span
                                                                >
                                                                <span
                                                                    v-else-if="
                                                                        option.decor_upcharge &&
                                                                        parseFloat(
                                                                            option.decor_upcharge
                                                                        ) > 0
                                                                    "
                                                                    style="
                                                                        margin-top: 1.2px;
                                                                        margin-left: 1px;
                                                                    "
                                                                    >{{
                                                                        icPriceFormat(
                                                                            option.decor_upcharge ||
                                                                                0
                                                                        )
                                                                    }}</span
                                                                >
                                                            </span>
                                                        </template>
                                                        <!-- eslint-enable -->
                                                        <template
                                                            #option="option"
                                                        >
                                                            <span
                                                                v-if="
                                                                    option.color_id ==
                                                                    0
                                                                "
                                                            >
                                                                <cite
                                                                    class="imprint_color_box color-box-tooltip"
                                                                    v-bind:style="
                                                                        'background:' +
                                                                        option.color_value
                                                                    "
                                                                    :title="
                                                                        option.color_value
                                                                    "
                                                                    :data-hex="
                                                                        option.color_value
                                                                    "
                                                                ></cite>
                                                                <span
                                                                    v-if="
                                                                        option.color_id ==
                                                                            0 &&
                                                                        (!activeDecorationService ||
                                                                            !activeDecorationService.name ||
                                                                            (!activeDecorationService.name
                                                                                .toLowerCase()
                                                                                .includes(
                                                                                    'print'
                                                                                ) &&
                                                                                !activeDecorationService.name
                                                                                    .toLowerCase()
                                                                                    .includes(
                                                                                        'embroidery'
                                                                                    ) &&
                                                                                !activeDecorationService.name
                                                                                    .toLowerCase()
                                                                                    .includes(
                                                                                        'emb'
                                                                                    )))
                                                                    "
                                                                >
                                                                    {{
                                                                        option.color_value ||
                                                                        option.color_name
                                                                    }}
                                                                </span>
                                                                <span v-else>
                                                                    {{
                                                                        option.color_name
                                                                    }}
                                                                </span>
                                                            </span>
                                                            <span v-else>
                                                                <cite
                                                                    v-if="
                                                                        option.color_value
                                                                    "
                                                                    class="imprint_color_box color-box-tooltip"
                                                                    v-bind:style="
                                                                        'background:' +
                                                                        option.color_value
                                                                    "
                                                                    :title="
                                                                        option.color_value
                                                                    "
                                                                    :data-hex="
                                                                        option.color_value
                                                                    "
                                                                ></cite>
                                                                <img
                                                                    v-else-if="
                                                                        option.swatch_file
                                                                    "
                                                                    class="imprint_color_box"
                                                                    :src="
                                                                        option.swatch_file
                                                                    "
                                                                    alt=""
                                                                />
                                                                <span
                                                                    v-if="
                                                                        option.color_id ==
                                                                            0 &&
                                                                        (!activeDecorationService ||
                                                                            !activeDecorationService.name ||
                                                                            (!activeDecorationService.name
                                                                                .toLowerCase()
                                                                                .includes(
                                                                                    'print'
                                                                                ) &&
                                                                                !activeDecorationService.name
                                                                                    .toLowerCase()
                                                                                    .includes(
                                                                                        'embroidery'
                                                                                    ) &&
                                                                                !activeDecorationService.name
                                                                                    .toLowerCase()
                                                                                    .includes(
                                                                                        'emb'
                                                                                    )))
                                                                    "
                                                                >
                                                                    {{
                                                                        option.color_value ||
                                                                        option.color_name
                                                                    }}
                                                                </span>
                                                                <span v-else>
                                                                    {{
                                                                        option.color_name
                                                                    }}
                                                                </span>

                                                                <span
                                                                    v-if="
                                                                        option.color_id ==
                                                                            0 &&
                                                                        option.non_standard_fee &&
                                                                        parseFloat(
                                                                            option.non_standard_fee
                                                                        ) > 0
                                                                    "
                                                                    >{{
                                                                        icPriceFormat(
                                                                            option.non_standard_fee ||
                                                                                0
                                                                        )
                                                                    }}</span
                                                                >
                                                                <span
                                                                    v-else-if="
                                                                        option.decor_upcharge &&
                                                                        parseFloat(
                                                                            option.decor_upcharge
                                                                        ) > 0
                                                                    "
                                                                    >{{
                                                                        icPriceFormat(
                                                                            option.decor_upcharge ||
                                                                                0
                                                                        )
                                                                    }}</span
                                                                >
                                                            </span>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="">
                <div
                    v-if="
                        activeDecorationService &&
                        genderGroups[active_gender_index].total_qty > 0
                    "
                >
                    <PCNAPriceBreakdown
                        v-if="activeDecorationService.decoration_type === 0"
                        :key="
                            'pcna_' +
                            activeDecorationService.id +
                            '_' +
                            genderGroups[active_gender_index].total_qty
                        "
                        :quantity="genderGroups[active_gender_index].total_qty"
                        :other-services="mergedOtherServices"
                        :base-cost="currentBreakdown.baseCost"
                        :run-charge="currentBreakdown.runCharge"
                        :run-charge-details="
                            currentBreakdown.runChargeDetails || []
                        "
                        :setup-fee="currentBreakdown.setupFee"
                        :subtotal="currentBreakdown.totalCost"
                        :discount-config="activeProductDiscount"
                        :imprint-locations="
                            getGenderImprintLocationsWithColors()
                        "
                        :service-master-data="
                            activeDecorationService.master_service || {}
                        "
                        :stitch-count="0"
                        :vendor-colors="vendorColors"
                        :color-size-combinations="
                            getColorSizeCombinations(
                                genderGroups[active_gender_index]
                            )
                        "
                        :selected-rush-option-id="selectedRushOptionId"
                        :selected-rush-option-date="selectedRushOptionDate"
                        :vendor-services="vendorServices"
                        :active-service-id="
                            activeDecorationService
                                ? activeDecorationService.id
                                : null
                        "
                        :patch-cost="currentBreakdown.patchCost || 0"
                        :patch-cost-tooltip="patchCostTooltip"
                        :patch-slab-quantity="currentBreakdown.patchSlabQuantity || 0"
                        :patch-cost-details="currentBreakdown.patchCostDetails || []"
                        :patch-cost-warning="patchCostWarning"
                    />

                    <ImprintCityPriceBreakdown
                        v-else
                        :key="
                            'imprint_' +
                            activeDecorationService.id +
                            '_' +
                            genderGroups[active_gender_index].total_qty
                        "
                        :quantity="genderGroups[active_gender_index].total_qty"
                        :design-fee="currentBreakdown.designFee"
                        :discount-config="activeProductDiscount"
                        :other-services="mergedOtherServices"
                        :base-cost="currentBreakdown.baseCost"
                        :run-charge="currentBreakdown.runCharge"
                        :setup-fee="currentBreakdown.setupFee"
                        :total-cost="currentBreakdown.totalCost"
                        :run-charge-details="currentBreakdown.runChargeDetails"
                        :patch-cost="currentBreakdown.patchCost || 0"
                        :patch-cost-tooltip="patchCostTooltip"
                        :patch-slab-quantity="currentBreakdown.patchSlabQuantity || 0"
                        :patch-cost-details="currentBreakdown.patchCostDetails || []"
                        :patch-cost-warning="patchCostWarning"
                        :imprint-locations="getGenderImprintLocations()"
                        :service-master-data="
                            activeDecorationService.master_service || {}
                        "
                        :active-decoration-service="
                            activeDecorationService || null
                        "
                        :decoration-pricing-data="
                            activeDecorationService &&
                            activeDecorationService.price_decoration_bulk &&
                            typeof activeDecorationService.price_decoration_bulk ===
                                'object'
                                ? activeDecorationService.price_decoration_bulk
                                : null
                        "
                        :decoration-type="
                            activeDecorationService.decoration_type || 1
                        "
                        :total-quantity="
                            genderGroups[active_gender_index].total_qty
                        "
                        :vendor-colors="vendorColors"
                        :color-size-combinations="
                            getColorSizeCombinations(
                                genderGroups[active_gender_index]
                            )
                        "
                        :selected-rush-option-id="selectedRushOptionId"
                        :selected-rush-option-date="selectedRushOptionDate"
                        :vendor-services="vendorServices"
                        :active-service-id="
                            activeDecorationService
                                ? activeDecorationService.id
                                : null
                        "
                    />
                </div>
                <!-- <a
                        href="javascript:void(0);"
                        class="dropdown-toggle d-flex align-items-center"
                        data-toggle="modal"
                        data-target="#priceBreakupChargesModal"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <img src="/maincss/images/path.png" class="ml_6 path" />
                    </a> -->
            </div>
        </div>
        <!-- PRICE BREAKUP CHARGES MODAL -->
        <!-- <div
            id="priceBreakupChargesModal"
            class="modal login-form-popup like_design_popup fade h-auto price_backup_modal total-cost-popup"
            tabindex="-1"
            aria-labelledby="art-work"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="header_items">
                            <div>
                                <h5 class="modal-title">Cost</h5>
                            </div>

                            <div class="close_modal">
                                <a
                                    href="#"
                                    class="popup-close art_poup_close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                    ref="popupclose"
                                >
                                    <span aria-hidden="true" v-tooltip="'Close'"
                                        >&times;</span
                                    >
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div
                            class="d-flex align-items-center justify-content-between"
                        >
                            <p class="font-weight-bold">Sub Total:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .subtotal
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_color_fee
                            "
                        >
                            <p class="font-weight-bold">
                                Decoration Colors Fee:
                            </p>
                            <p>
                                {{
                                    genderGroups[active_gender_index]
                                        .total_color_fee
                                        ? icPriceFormat(
                                              genderGroups[active_gender_index]
                                                  .total_color_fee
                                          )
                                        : icPriceFormat(0.0)
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                typeof genderGroups[active_gender_index]
                                    .total_setup_fee === 'number'
                            "
                        >
                            <p class="font-weight-bold">
                                <span
                                    v-if="
                                        genderGroups[active_gender_index].item
                                            .decoration_type == 1
                                    "
                                >
                                    Per Color Setup Fee ({{
                                        genderGroups[active_gender_index]
                                            .total_decoration_colors
                                    }}
                                    *
                                    {{
                                        icPriceFormat(
                                            genderGroups[active_gender_index]
                                                .per_color_setup_cost
                                        )
                                    }}):
                                </span>
                                <span
                                    v-else-if="
                                        genderGroups[active_gender_index].item
                                            .decoration_type == 2
                                    "
                                >
                                    Digitizing Fee:
                                </span>
                                <span
                                    v-else-if="
                                        genderGroups[active_gender_index].item
                                            .decoration_type == 0
                                    "
                                >
                                    Setup Fee:
                                </span>
                                <span v-else> Setup/Other Fee: </span>
                            </p>

                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_setup_fee || 0
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_design_fee
                            "
                        >
                            <p class="font-weight-bold">Design Fee:</p>
                            <p>
                                {{
                                    genderGroups[active_gender_index]
                                        .total_design_fee
                                        ? icPriceFormat(
                                              genderGroups[active_gender_index]
                                                  .total_design_fee
                                          )
                                        : 0.0
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="totalNonStandardFees || (genderGroups[active_gender_index] && genderGroups[active_gender_index].total_non_standard_fees > 0)"
                        >
                            <p
                                class="font-weight-bold"
                                v-if="
                                    genderGroups[active_gender_index]['item']
                                        .decoration_type == 1
                                "
                            >
                                Custom Color Ink Fee (
                                {{ totalNonStandardColors && totalNonStandardColors.length ? totalNonStandardColors.length : 0 }} *
                                {{ icPriceFormat(nonStandardFeePerColor || 0) }} ):
                            </p>
                            <p
                                class="font-weight-bold"
                                v-if="
                                    genderGroups[active_gender_index]['item']
                                        .decoration_type == 2
                                "
                            >
                                Custom Color Thread Fee (
                                {{ totalNonStandardColors && totalNonStandardColors.length ? totalNonStandardColors.length : 0 }} *
                                {{ icPriceFormat(nonStandardFeePerColor || 0) }} ):
                            </p>
                            <p
                                class="font-weight-bold"
                                v-if="
                                    genderGroups[active_gender_index]['item']
                                        .decoration_type == 0 &&
                                    getPCNAFeePerColor() > 0
                                "
                            >
                                <template v-if="activeDecorationService && activeDecorationService.name && (activeDecorationService.name.toLowerCase().includes('embroidery') || activeDecorationService.name.toLowerCase().includes('emb'))">
                                    Custom Color Thread Fee (
                                    {{ getPCNAMixColorCount() }} *
                                    {{ icPriceFormat(getPCNAFeePerColor()) }} ):
                                </template>
                                <template v-else-if="activeDecorationService && activeDecorationService.name && activeDecorationService.name.toLowerCase().includes('print')">
                                    Custom Color Ink Fee (
                                    {{ getPCNAMixColorCount() }} *
                                    {{ icPriceFormat(getPCNAFeePerColor()) }} ):
                                </template>
                            </p>
                            <p>{{ icPriceFormat(totalNonStandardFees || (genderGroups[active_gender_index] && genderGroups[active_gender_index].total_non_standard_fees) || 0) }}</p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_front_number_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Front Number Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_front_number_fees
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_front_name_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Front Name Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_front_name_fees
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_back_name_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Back Name Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_name_fees
                                    )
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index] &&
                                genderGroups[active_gender_index].total_back_number_fees > 0
                            "
                        >
                            <p class="font-weight-bold">Back Number Fee:</p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_number_fees
                                    )
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_front_number_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold">
                                Front Number Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_front_number_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_front_name_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold">
                                Front Name Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_front_name_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_back_name_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold">
                                Back Name Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_name_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>

                        <div
                            class="d-flex align-items-center justify-content-between"
                            v-if="
                                genderGroups[active_gender_index]
                                    .total_back_number_decor_up_fees
                            "
                        >
                            <p class="font-weight-bold w-25">
                                Back Number Decor Up Fee:
                            </p>
                            <p>
                                {{
                                    icPriceFormat(
                                        genderGroups[active_gender_index]
                                            .total_back_number_decor_up_fees
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import PCNAPriceBreakdown from "@/views/frontend/products/components/PCNAPriceBreakdown.vue";
import ImprintCityPriceBreakdown from "@/views/frontend/products/components/ImprintCityPriceBreakdown.vue";
export default {
    name: "ItemDetails",
    components: {
        PCNAPriceBreakdown,
        ImprintCityPriceBreakdown
    },
    props: {
        productId: {
            type: Number
        },
        product: {
            type: Object
        },
        genderGroups: {
            type: Array,
            default: () => []
        },
        decorationColors: {
            type: Array,
            default: () => []
        },
        allDecorationColors: {
            type: Object,
            default: () => {}
        },
        tshirtSides: {
            type: Array
        },
        vendorColors: {
            type: Array,
            default: () => []
        },
        fuseSearch: {
            required: false,
            type: Function
        },
        activeColorIndex: {
            required: true,
            default: () => 0
        },
        saveNewDesigns: {
            required: true,
            type: Function
        },
        addToCart: {
            required: true,
            type: Function
        },
        updatePrintAreas: {
            required: true,
            type: Function
        },
        totalNonStandardFees: {
            type: Number
        },
        nonStandardFeePerColor: {
            type: Number,
            defaullt: 0
        },
        totalNonStandardColors: {
            type: Array,
            default: () => {}
        },
        canvasDesignsStatus: {
            type: Boolean,
            default: false
        },
        colorsValidation: {
            type: String,
            default: ""
        },
        colorsCount: {
            type: Number,
            default: 0
        },
        buildItemId: {
            type: Number,
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        cartQuantity: {
            type: Number,
            default: 0
        },
        useImprintcityTemplate: {
            type: Number,
            required: false,
            default: null
        },
        activeDecorationService: {
            type: Object,
            default: () => null
        },
        otherServices: {
            type: Array,
            default: () => []
        },
        selectedRushOptionId: {
            type: String,
            default: null
        },
        selectedRushOptionDate: {
            type: String,
            default: null
        },
        vendorServices: {
            type: Array,
            default: () => []
        },
        patchCost: {
            type: Number,
            default: 0
        },
        patchCostWarning: {
            type: String,
            default: ""
        },
        patchCostTooltip: {
            type: String,
            default: ""
        },
        patchSlabQuantity: {
            type: Number,
            default: 0
        },
        patchCostDetails: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        activeProductDiscount() {
            // Check if product and discount data exist
            const discount = this.product
                ? this.product.MainNewProductDiscount
                : null;

            // Return null if there's no discount or its status is inactive
            if (!discount || !discount.status) {
                return null;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0); // Compare date part only

            // Check start date
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                if (today < startDate) {
                    return null; // Not started yet
                }
            }

            // Check end date
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                if (today > endDate) {
                    return null; // Expired
                }
            }

            // If all checks pass, discount is active
            return discount;
        },
        // Merge VendorFees with otherServices for price breakdown components
        mergedOtherServices() {
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];
            // Merge VendorFees with otherServices, prioritizing VendorFees
            return [...vendorFees, ...(this.otherServices || [])];
        },
        // Dynamic rush options with delivery dates
        dynamicRushOptions() {
            // Return empty array if no active service
            if (!this.activeDecorationService) {
                return [];
            }

            const activeService = this.activeDecorationService;
            const rushOptions = [];

            // Get rush flags from the service
            let serviceRushFlags = null;
            if (this.product && this.product.decorations) {
                try {
                    // Handle both string and already-parsed decorations
                    let decorations = this.product.decorations;
                    if (typeof decorations === "string") {
                        decorations = JSON.parse(decorations);
                    }

                    if (
                        decorations &&
                        decorations.length > 0 &&
                        decorations[0].decoration_type_list
                    ) {
                        const serviceInList =
                            decorations[0].decoration_type_list.find(
                                (s) => s.id === activeService.id
                            );
                        if (serviceInList) {
                            serviceRushFlags = {
                                rush1:
                                    serviceInList.rush1 === true ||
                                    serviceInList.rush1 === 1,
                                rush3:
                                    serviceInList.rush3 === true ||
                                    serviceInList.rush3 === 1,
                                rush5:
                                    serviceInList.rush5 === true ||
                                    serviceInList.rush5 === 1,
                                rush7:
                                    serviceInList.rush7 === true ||
                                    serviceInList.rush7 === 1,
                                rush_package:
                                    serviceInList.rush_package === true ||
                                    serviceInList.rush_package === 1
                            };
                        }
                    }
                } catch (e) {
                    console.error("Error parsing decorations:", e);
                }
            }

            // If no rush flags found, return empty array
            if (!serviceRushFlags) {
                return [];
            }

            // Find vendor service for pricing
            const vendorService = this.vendorServices.find(
                (vs) => vs.id === activeService.id
            );

            // Base date is today
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Rush 1 Day
            if (serviceRushFlags.rush1) {
                const price = vendorService
                    ? parseFloat(vendorService.rush1 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    1
                );
                rushOptions.push({
                    id: "rush1",
                    label: "Rush 1 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush 3 Days
            if (serviceRushFlags.rush3) {
                const price = vendorService
                    ? parseFloat(vendorService.rush3 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    3
                );
                rushOptions.push({
                    id: "rush3",
                    label: "Rush 3 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush 5 Days
            if (serviceRushFlags.rush5) {
                const price = vendorService
                    ? parseFloat(vendorService.rush5 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    5
                );
                rushOptions.push({
                    id: "rush5",
                    label: "Rush 5 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush 7 Days
            if (serviceRushFlags.rush7) {
                const price = vendorService
                    ? parseFloat(vendorService.rush7 || 0)
                    : 0;
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    7
                );
                rushOptions.push({
                    id: "rush7",
                    label: "Rush 7 Day",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            // Rush Package
            if (serviceRushFlags.rush_package) {
                const price = vendorService
                    ? parseFloat(vendorService.rush_package || 0)
                    : 0;
                const shippingDays = 10; // Default to 10 if not set
                const estimatedDate = this.calculateEstimatedDateWithHolidays(
                    today,
                    shippingDays
                );
                rushOptions.push({
                    id: "rush_package",
                    label: "Rush Package",
                    price: price,
                    shipDate: this.formatRushDateForDisplay(estimatedDate),
                    estimatedDate: estimatedDate
                });
            }

            return rushOptions;
        }
    },
    data() {
        return {
            // Variables for imprint locations and colors by jinendra
            originalTotalCost: 0,
            originalImprintLocations: [],
            imprintcityColors: [],
            default_imprint_colors: [
                {
                    id: 1,
                    value: "1-colors"
                },
                {
                    id: 2,
                    value: "2-colors"
                },
                {
                    id: 3,
                    value: "3-colors"
                },
                {
                    id: 4,
                    value: "4-colors"
                },
                {
                    id: 5,
                    value: "5-colors"
                },
                {
                    id: 6,
                    value: "6-colors"
                }
            ],
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            active_gender_index: 0,
            setup_fee_applied_gender_index: -1,
            setup_fee: 0,
            picked_color: null,
            current_cart_quantity: 0,
            index_prev: 0,
            disable_imprint_locations: false,
            disabled_styles: {
                "pointer-events": "none !important",
                color: "#bfcbd9 !important",
                cursor: "not-allowed !important",
                "background-image": "none !important",
                "background-color": "#eef1f6 !important",
                "border-color": "#d1dbe5 !important"
            },
            markup_tiers: [],
            currentBreakdown: {
                baseCost: 0,
                runCharge: 0,
                setupFee: 0,
                totalCost: 0,
                totalDiscount: 0,
                designFee: 0,
                runChargeDetails: [],
                patchCost: 0,
                patchAdditionalServicesTotal: 0
            },
            page_status: 0, // 0 for beforeMount, 1 for mounted
            colorSectionExpanded: {} // Object to track expanded state for each color by color ID
        };
    },
    watch: {
        // Watch for changes in the active color index prop
        activeColorIndex: {
            handler(newIndex, oldIndex) {
                if (
                    newIndex >= 0 &&
                    this.genderGroups[this.active_gender_index] &&
                    newIndex <
                        this.genderGroups[this.active_gender_index].colors
                            .length
                ) {
                    const selectedColor =
                        this.genderGroups[this.active_gender_index].colors[
                            newIndex
                        ];
                    this.picked_color = selectedColor;

                    // Open the selected color's drawer and close others
                    const colorId = selectedColor.id || newIndex;
                    this.colorSectionExpanded = {};
                    this.$set(this.colorSectionExpanded, colorId, true);

                    this.$nextTick(() => {
                        this.calculatePricing(this.active_gender_index);
                        this.syncNameNumberColorsToImprintLocations();
                    });
                } else {
                    console.warn(
                        "Watcher: Invalid activeColorIndex or gender data:",
                        newIndex
                    );
                    this.picked_color = null; // Reset if index is invalid
                }
            },
            immediate: true
        },
        decorationColors() {
            /* eslint-disable */
            let element = document.getElementById(
                "collapseColors" + this.index_prev
            );
            if (
                this.decorationColors.length > 0 &&
                !element.classList.contains("show")
            ) {
                this.genderGroups[this.active_gender_index].imprint_locations[
                    this.index_prev
                ].collapse = false;
                //console.log("collapseid" + this.index_prev);
                $("#collapseid" + this.index_prev).click();
            }
            /* eslint-enable */
        },
        colorsCount: {
            handler(newCount) {
                let colors = [];
                console.log(
                    "active decoration service",
                    this.activeDecorationService,
                    this.activeDecorationService.is_full_color,
                    this.activeDecorationService.master_service.fee_structure
                );

                // Check if activeDecorationService has is_full_color set to true
                if (
                    this.activeDecorationService &&
                    this.activeDecorationService.is_full_color === true &&
                    this.activeDecorationService.master_service.fee_structure ==
                        2
                ) {
                    // Show only "1-color" and "Full color" options
                    colors.push({
                        id: 1,
                        value: "1-color"
                    });
                    colors.push({
                        id: "full_color",
                        value: "Full color"
                    });
                } else if (newCount > 0) {
                    // Normal case: show all color options from 1 to newCount
                    for (let i = 1; i <= newCount; i++) {
                        colors.push({
                            id: i,
                            value: `${i}-color${i > 1 ? "s" : ""}`
                        });
                    }
                }

                this.imprintcityColors = colors;
            },
            immediate: true
        },
        activeDecorationService: {
            handler(newService, oldService) {
                // Update colors when service changes, especially if is_full_color changes
                if (newService !== oldService) {
                    // Trigger colorsCount watcher to update dropdown options
                    this.$nextTick(() => {
                        this.colorsCount = this.colorsCount; // Trigger watcher
                    });
                }
            },
            deep: true
        },
        patchCost() {
            this.$nextTick(() => {
                this.calculatePricing(this.active_gender_index);
            });
        },
        patchCostWarning() {
            this.$nextTick(() => {
                this.calculatePricing(this.active_gender_index);
            });
        },
        genderGroups: {
            handler: function (val, oldVal) {
                /* eslint-disable */
                if (
                    this.genderGroups[this.active_gender_index].colors.length >
                    3
                ) {
                    let timer = 500;
                    setTimeout(() => {
                        let owl = $(".ink-color-slider").owlCarousel({
                            loop: false,
                            // stagePadding: 0,
                            autoWidth: false,
                            margin: 0,
                            items: 3,
                            autoplay: false,
                            autoplayTimeout: 4000,
                            autoplayHoverPause: false,
                            responsiveClass: true,
                            navigation: false,
                            dots: false
                            // responsive: {
                            // 	0: {
                            // 		items: 6,
                            // 		nav: true
                            // 	},
                            // 	360: {
                            // 		items: 6,
                            // 		nav: true
                            // 	},
                            // 	600: {
                            // 		items: 5,
                            // 		nav: true
                            // 	},
                            // 	767: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true,
                            // 	},
                            // 	1024: {
                            // 		items: 2,
                            // 		nav: true
                            // 		// loop: false
                            // 	},
                            // 	1280: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: false
                            // 	},
                            // 	1366: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true
                            // 	},
                            // 	1440: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true
                            // 	},
                            // 	1441: {
                            // 		items: 6,
                            // 		nav: true
                            // 		// loop: true
                            // 	}
                            // }
                        });
                        $(".play").on("click", function () {
                            owl.trigger("play.owl.autoplay", [1000]);
                        });
                        $(".stop").on("click", function () {
                            owl.trigger("stop.owl.autoplay");
                        });
                        $(".customNextBtn").click(function () {
                            owl.trigger("next.owl.carousel");
                        });
                        // Go to the previous item
                        $(".customPrevBtn").click(function () {
                            // With optional speed parameter
                            // Parameters has to be in square bracket '[]'
                            owl.trigger("prev.owl.carousel", [300]);
                        });
                    }, timer);
                }
                /* eslint-enable */
            },
            deep: true
        },
        buildItemId() {
            this.calculatePricing(this.active_gender_index);
        },
        allDecorationColors: {
            handler(newColors, oldColors) {
                // When design colors change, update full color locations if they exist
                if (
                    newColors &&
                    this.genderGroups &&
                    this.genderGroups[this.active_gender_index]
                ) {
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations.forEach((location, index) => {
                        // Check if this location has design colors
                        if (location.location) {
                            const locationKey =
                                this.getLocationKeyForDecorationColors(
                                    location.location
                                );
                            if (locationKey && newColors[locationKey]) {
                                let decorationColors =
                                    newColors[locationKey] || [];

                                // If full color service and more than 1 color, set to full_color
                                if (
                                    this.activeDecorationService &&
                                    this.activeDecorationService
                                        .is_full_color === true
                                ) {
                                    if (decorationColors.length > 1) {
                                        // Set to full color if more than 1 color
                                        location.no_of_color = "full_color";
                                        location.is_full_color = true;
                                        location.full_color_count =
                                            decorationColors.length;
                                        this.extractDesignColorsForLocation(
                                            location,
                                            index
                                        );
                                    } else if (decorationColors.length === 1) {
                                        // If only 1 color, set to 1
                                        location.no_of_color = 1;
                                        location.is_full_color = false;
                                        this.extractDesignColorsForLocation(
                                            location,
                                            index
                                        );
                                    }
                                } else if (
                                    location.is_full_color === true ||
                                    location.no_of_color === "full_color"
                                ) {
                                    // Already in full color mode, just update colors
                                    this.extractDesignColorsForLocation(
                                        location,
                                        index
                                    );
                                } else if (
                                    decorationColors &&
                                    decorationColors.length > 0
                                ) {
                                    // Merge clipart colors with name/number so total count includes all (e.g. 4 colors)
                                    this.extractDesignColorsForLocation(
                                        location,
                                        index
                                    );
                                }
                            }
                        }
                    });
                }
            },
            deep: true
        }
    },
    beforeMount() {
        this.picked_color = this.getActiveColorData();

        // Initialize expanded state for the active color
        if (this.picked_color) {
            const colorId = this.picked_color.id || this.activeColorIndex;
            this.$set(this.colorSectionExpanded, colorId, true);
        }

        /* eslint-disable */
        // Don't set collapse = true initially, let it be closed (undefined/false) so plus icon shows
        // The first visible item will be opened by other logic if needed

        /* eslint-enable */
        this.getAllMarkupTiers(
            this.product.decoration_type,
            this.product.decoration_price_template
        );
    },
    mounted() {
        /* eslint-disable */
        let pathSegments = this.$route.path.split("/");
        let lastSegment = pathSegments.filter(Boolean).pop(); // Removes empty strings
        if (lastSegment == "build") {
            this.page_status = 1;
        }
        if (this.page_status == 0) {
            let firstIndex = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex((location) => {
                return location.is_selected;
            });
            // Same as view switch: open the first selected location's dropdown so behaviour is consistent
            if (firstIndex !== -1) {
                this.$nextTick(() => {
                    this.updateAccordianFlip(firstIndex);
                });
            }
            this.page_status = 1;
        }
        /* eslint-enable */
        this.$nextTick(() => {
            this.syncNameNumberColorsToImprintLocations();
        });
        let vendorColor = this.vendorColors.find(
            (vendorColor) => vendorColor.color_value == "#GGGGGG"
        );
        /* eslint-disable */
        if (typeof vendorColor == "undefined")
            this.vendorColors.push({
                color_id: 0,
                color_name: "Mix Color",
                color_pms: "Non Standard",
                decor_upcharge: 0,
                color_value: "#GGGGGG",
                swatches: "",
                category: "Non Standard",
                shades: []
            });
        this.prepareDecorationPrices();

        // Initialize full color locations with design colors if available
        this.genderGroups[this.active_gender_index].imprint_locations.forEach(
            (location, index) => {
                if (
                    location.is_full_color === true ||
                    location.no_of_color === "full_color"
                ) {
                    // Initialize full_color_count if not set
                    if (!location.full_color_count) {
                        location.full_color_count = 1;
                    }
                    // Extract colors from design if available
                    this.extractDesignColorsForLocation(location, index);
                }
            }
        );

        if (this.genderGroups[this.active_gender_index].colors.length > 3) {
            let timer = 1000;
            setTimeout(() => {
                let owl = $(".ink-color-slider").owlCarousel({
                    loop: false,
                    // stagePadding: 0,
                    autoWidth: false,
                    margin: 0,
                    items: 3,
                    autoplay: false,
                    autoplayTimeout: 4000,
                    autoplayHoverPause: false,
                    responsiveClass: true,
                    navigation: false,
                    dots: false
                    // responsive: {
                    // 	0: {
                    // 		items: 6,
                    // 		nav: true
                    // 	},
                    // 	360: {
                    // 		items: 6,
                    // 		nav: true
                    // 	},
                    // 	600: {
                    // 		items: 5,
                    // 		nav: true
                    // 	},
                    // 	767: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true,
                    // 	},
                    // 	1024: {
                    // 		items: 2,
                    // 		nav: true
                    // 		// loop: false
                    // 	},
                    // 	1280: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: false
                    // 	},
                    // 	1366: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true
                    // 	},
                    // 	1440: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true
                    // 	},
                    // 	1441: {
                    // 		items: 6,
                    // 		nav: true
                    // 		// loop: true
                    // 	}
                    // }
                });
                $(".play").on("click", function () {
                    owl.trigger("play.owl.autoplay", [1000]);
                });
                $(".stop").on("click", function () {
                    owl.trigger("stop.owl.autoplay");
                });
                $(".customNextBtn").click(function () {
                    owl.trigger("next.owl.carousel");
                });
                // Go to the previous item
                $(".customPrevBtn").click(function () {
                    // With optional speed parameter
                    // Parameters has to be in square bracket '[]'
                    owl.trigger("prev.owl.carousel", [300]);
                });
            }, timer);
        }
        /* eslint-enable */
        this.calcImprintLocationByGender();
        // storing the color, no.of color and total cost for reset BY jinendra
        this.originalImprintLocations = this.genderGroups[
            this.active_gender_index
        ].imprint_locations.map((loc) => ({
            no_of_color: loc.no_of_color,
            is_selected: loc.is_selected
        }));
        this.originalTotalCost =
            this.genderGroups[this.active_gender_index].total_cost;
    },
    methods: {
        // Normalize location key to match allDecorationColors keys (left, right, front, back)
        // This handles cases like "left sleeve" -> "left", "right sleeve" -> "right"
        getLocationKeyForDecorationColors(location) {
            if (!location) return null;
            const locLower = location.toLowerCase().trim();

            // Extract base location from compound names
            if (locLower.includes("left")) {
                return "left";
            } else if (locLower.includes("right")) {
                return "right";
            } else if (locLower.includes("front")) {
                return "front";
            } else if (locLower.includes("back")) {
                return "back";
            }

            // Return as-is if no match
            return locLower;
        },

        // Prepare color-size combinations array for price breakdown
        getColorSizeCombinations(gender) {
            if (!gender || !gender.colors || !Array.isArray(gender.colors)) {
                return [];
            }

            const combinations = [];

            gender.colors.forEach((color) => {
                if (!color.unique_sizes || !Array.isArray(color.unique_sizes)) {
                    return;
                }

                color.unique_sizes.forEach((size) => {
                    // Only include sizes with quantity > 0
                    if (size.quantity && parseInt(size.quantity) > 0) {
                        // Extract only size abbreviation (XS, S, M, L, XL, etc.)
                        let sizeAbbr = "N/A";
                        if (size.Size && size.Size.size) {
                            sizeAbbr = size.Size.size;
                        } else if (size.size) {
                            // If size contains full product name, extract last word (size abbreviation)
                            const sizeParts = size.size.trim().split(/\s+/);
                            sizeAbbr = sizeParts[sizeParts.length - 1];
                        } else if (size.name) {
                            // If name contains full product name, extract last word (size abbreviation)
                            const nameParts = size.name.trim().split(/\s+/);
                            sizeAbbr = nameParts[nameParts.length - 1];
                        }

                        // Get color value and ensure it has # prefix
                        // Try multiple possible property names: color_value, hex, hash
                        let colorValue =
                            color.color_value || color.hex || color.hash || "";
                        if (colorValue && !colorValue.startsWith("#")) {
                            colorValue = "#" + colorValue;
                        }
                        if (!colorValue) {
                            colorValue = "#cccccc";
                        }

                        combinations.push({
                            color_id: color.id || color.color_id,
                            color_name:
                                color.name || color.color_name || "Color",
                            color_value: colorValue,
                            hex: colorValue,
                            size: sizeAbbr,
                            quantity: parseInt(size.quantity) || 0,
                            cost: parseFloat(size.cost) || 0,
                            total_cost: parseFloat(size.total_cost) || 0
                        });
                    }
                });
            });

            return combinations;
        },
        // New function to reset imprint colors and costs by jinendra
        resetImprintColors() {
            const gender = this.genderGroups[this.active_gender_index];
            if (!gender || !this.originalImprintLocations.length) return;

            let activeImprintLocation = null;

            gender.imprint_locations.forEach((imprintLocation, index) => {
                const original = this.originalImprintLocations[index];
                if (!original) return;

                // Empty the color array
                imprintLocation.colors = Array(original.no_of_color).fill({
                    color: null
                });

                // Restore number of color boxes and selection state
                imprintLocation.no_of_color = original.no_of_color;
                imprintLocation.is_selected = original.is_selected;

                // Check if the front side is selected
                if (
                    imprintLocation.location === "Front" &&
                    imprintLocation.is_selected
                ) {
                    activeImprintLocation = imprintLocation;
                }
            });

            // If the front side is not selected, find the first selected imprint location
            if (!activeImprintLocation) {
                activeImprintLocation = gender.imprint_locations.find(
                    (loc) => loc.is_selected
                );
            }

            // Same for variations
            gender.colors.forEach((fabricColor) => {
                if (!fabricColor.imprint_locations) return;

                fabricColor.imprint_locations.forEach((loc, index) => {
                    const original = this.originalImprintLocations[index];
                    if (!original) return;

                    loc.colors = Array(original.no_of_color).fill({
                        color: null
                    });
                    loc.no_of_color = original.no_of_color;
                    loc.is_selected = original.is_selected;
                });
            });

            // Update the active imprint location to display
            if (activeImprintLocation) {
                this.updatePrintAreas(
                    gender.imprint_locations.indexOf(activeImprintLocation)
                );
            }

            gender.total_cost = this.originalTotalCost;
            this.$forceUpdate();
        },
        updateAccordianFlip(index) {
            // When print area view switches, open this area's collapse and close others
            const locations =
                this.genderGroups[this.active_gender_index].imprint_locations;
            if (!locations || index < 0 || index >= locations.length) {
                return;
            }
            if (this.index_prev === index) {
                // Already on this section; ensure it's expanded
                const current = locations[index];
                if (current && current.collapse !== true) {
                    this.$set(current, "collapse", true);
                    this.genderGroups[this.active_gender_index].colors.forEach(
                        (color) => {
                            if (
                                color.imprint_locations &&
                                color.imprint_locations[index]
                            ) {
                                this.$set(
                                    color.imprint_locations[index],
                                    "collapse",
                                    true
                                );
                            }
                        }
                    );
                    this.index_prev = index;
                    this.$forceUpdate();
                }
                return;
            }
            // Close all locations
            locations.forEach((location_obj) => {
                this.$set(location_obj, "collapse", false);
            });
            this.genderGroups[this.active_gender_index].colors.forEach(
                (color) => {
                    if (
                        color.imprint_locations &&
                        Array.isArray(color.imprint_locations)
                    ) {
                        color.imprint_locations.forEach((location_obj) => {
                            this.$set(location_obj, "collapse", false);
                        });
                    }
                }
            );
            // Open the selected location
            this.$set(locations[index], "collapse", true);
            this.genderGroups[this.active_gender_index].colors.forEach(
                (color) => {
                    if (
                        color.imprint_locations &&
                        color.imprint_locations[index]
                    ) {
                        this.$set(
                            color.imprint_locations[index],
                            "collapse",
                            true
                        );
                    }
                }
            );
            this.index_prev = index;
            this.$forceUpdate();
        },
        getSelectedColorImprintLocations() {
            return this.genderGroups[this.active_gender_index].colors[
                this.activeColorIndex
            ].imprint_locations;
        },

        getLocationColor(
            imprintLocationIndex,
            imprintColorIndex,
            fabricColorIndex
        ) {
            return this.genderGroups[this.active_gender_index].colors[
                fabricColorIndex
            ].imprint_locations[imprintLocationIndex].colors[imprintColorIndex]
                .color;
        },

        getGenderImprintLocations() {
            // Return original locations array for template binding
            // For decoration type 2, merge no_of_color from color's imprint_locations
            // to ensure breakdown shows detailed Addl Color information
            const locations =
                this.genderGroups[this.active_gender_index].imprint_locations;

            // For decoration type 2, merge no_of_color from color's imprint_locations
            const decorationType =
                (this.activeDecorationService &&
                    this.activeDecorationService.decoration_type) ||
                (this.activeDecorationService &&
                    this.activeDecorationService.master_service &&
                    this.activeDecorationService.master_service
                        .decoration_type);

            if (
                decorationType === 2 &&
                this.genderGroups[this.active_gender_index].colors &&
                this.genderGroups[this.active_gender_index].colors.length > 0
            ) {
                // Get first color's imprint_locations to merge no_of_color
                const colorIndex =
                    this.activeColorIndex >= 0 ? this.activeColorIndex : 0;
                const colorData =
                    this.genderGroups[this.active_gender_index].colors[
                        colorIndex
                    ];

                if (
                    colorData &&
                    colorData.imprint_locations &&
                    Array.isArray(colorData.imprint_locations)
                ) {
                    return locations.map((location, index) => {
                        const locationCopy = { ...location };
                        // Merge no_of_color from color's imprint_locations if available
                        if (
                            colorData.imprint_locations[index] &&
                            colorData.imprint_locations[index].no_of_color !==
                                undefined
                        ) {
                            locationCopy.no_of_color =
                                colorData.imprint_locations[index].no_of_color;
                            locationCopy.is_full_color =
                                colorData.imprint_locations[
                                    index
                                ].is_full_color;
                            locationCopy.is_full_color_selected =
                                colorData.imprint_locations[
                                    index
                                ].is_full_color_selected;
                            locationCopy.full_color_value =
                                colorData.imprint_locations[
                                    index
                                ].full_color_value;
                        }
                        return locationCopy;
                    });
                }
            }

            return locations;
        },

        getColorImprintLocations(color) {
            // Return imprint locations for a specific color
            // If color has its own imprint_locations, use those; otherwise use gender's locations
            if (
                color &&
                color.imprint_locations &&
                Array.isArray(color.imprint_locations)
            ) {
                return color.imprint_locations;
            }
            // Fallback to gender's imprint_locations
            return (
                this.genderGroups[this.active_gender_index].imprint_locations ||
                []
            );
        },

        /** Resolve name/number settings to vendor color object. Returns null if no color info. */
        resolveSettingsToVendorColor(settings) {
            if (
                !settings ||
                (!settings.colorId &&
                    settings.color_id == null &&
                    !settings.fontColor)
            ) {
                return null;
            }
            const colorId =
                settings.colorId != null ? settings.colorId : settings.color_id;
            const fontColor = settings.fontColor;
            const colorName = settings.colorName || "Selected";

            let colorObj = null;
            if (
                colorId != null &&
                this.vendorColors &&
                Array.isArray(this.vendorColors)
            ) {
                colorObj = this.vendorColors.find(
                    (vc) =>
                        (vc.id !== undefined && vc.id === colorId) ||
                        (vc.color_id !== undefined && vc.color_id === colorId)
                );
            }
            if (!colorObj && fontColor) {
                colorObj = {
                    color_id: colorId != null ? colorId : 0,
                    id: colorId != null ? colorId : 0,
                    color_name: colorName,
                    color_value:
                        fontColor.indexOf("#") === 0
                            ? fontColor
                            : "#" + fontColor,
                    non_standard_fee: 0,
                    decor_upcharge: 0
                };
            }
            return colorObj;
        },

        /** Get name/number color objects for a fabric color and location (0, 1 or 2 items). Only includes color if that option (Add Name / Add Number) is checked. */
        getNameNumberColorSlots(fabricColor, locationKey) {
            if (!fabricColor || !fabricColor.view_settings || !locationKey) {
                return [];
            }
            const vs = fabricColor.view_settings[locationKey];
            if (!vs) return [];
            const selected =
                fabricColor.selected_name_number &&
                fabricColor.selected_name_number[locationKey];
            const nameEnabled = selected && selected.name === true;
            const numberEnabled = selected && selected.number === true;

            const nameObj = nameEnabled
                ? this.resolveSettingsToVendorColor(vs.nameSettings)
                : null;
            const numObj = numberEnabled
                ? this.resolveSettingsToVendorColor(vs.numberSettings)
                : null;
            const same =
                nameObj &&
                numObj &&
                ((nameObj.color_id !== undefined &&
                    numObj.color_id !== undefined &&
                    nameObj.color_id === numObj.color_id) ||
                    (nameObj.id !== undefined &&
                        numObj.id !== undefined &&
                        nameObj.id === numObj.id) ||
                    (nameObj.color_value &&
                        numObj.color_value &&
                        String(nameObj.color_value).toLowerCase().trim() ===
                            String(numObj.color_value).toLowerCase().trim()));
            const out = [];
            if (nameObj) out.push(nameObj);
            if (numObj && !same) out.push(numObj);
            return out;
        },

        /** Sync name/number colors into location color dropdowns. Replace list so unused colors (e.g. Acorn) are removed. */
        syncNameNumberColorsToImprintLocations() {
            if (
                !this.genderGroups ||
                !this.genderGroups[this.active_gender_index] ||
                this.activeColorIndex == null ||
                this.activeColorIndex < 0
            ) {
                return;
            }
            const gender = this.genderGroups[this.active_gender_index];
            const activeColor =
                gender.colors && gender.colors[this.activeColorIndex];
            if (
                !activeColor ||
                !activeColor.view_settings ||
                !activeColor.imprint_locations
            ) {
                return;
            }
            const imprintLocations = gender.imprint_locations;
            if (!imprintLocations || !Array.isArray(imprintLocations)) return;

            const isSameColor = (a, b) =>
                a &&
                b &&
                (a.color_id === b.color_id ||
                    (a.id !== undefined &&
                        b.id !== undefined &&
                        a.id === b.id) ||
                    (a.color_value &&
                        b.color_value &&
                        String(a.color_value).toLowerCase().trim() ===
                            String(b.color_value).toLowerCase().trim()));

            imprintLocations.forEach((location, locationIndex) => {
                if (!location || !location.location) return;
                const locationKey = this.getLocationKeyForDecorationColors(
                    location.location
                );
                if (!locationKey) return;

                const nameNumberSlots = this.getNameNumberColorSlots(
                    activeColor,
                    locationKey
                );
                const designSlots =
                    this.getDesignColorSlotsForLocationKey(locationKey);
                const merged = nameNumberSlots.map((c) => ({
                    color: c,
                    color_cost: 0.0,
                    cost_cost: 0.0,
                    cost_sum_added: false
                }));
                designSlots.forEach((slot) => {
                    const c = slot.color;
                    if (!nameNumberSlots.some((nn) => isSameColor(c, nn))) {
                        merged.push(JSON.parse(JSON.stringify(slot)));
                    }
                });
                const finalList = merged.length > 0 ? merged : designSlots;

                const colorImprintLoc =
                    activeColor.imprint_locations[locationIndex];
                if (!colorImprintLoc) return;

                colorImprintLoc.colors =
                    finalList.length > 0
                        ? JSON.parse(JSON.stringify(finalList))
                        : [];
                const serviceIsFullColor =
                    this.activeDecorationService &&
                    this.activeDecorationService.is_full_color === true;
                const hasMultipleColors = finalList.length > 1;

                if (finalList.length > 0) {
                    if (serviceIsFullColor && hasMultipleColors) {
                        colorImprintLoc.no_of_color = "full_color";
                        colorImprintLoc.is_full_color = true;
                        colorImprintLoc.full_color_count = finalList.length;
                    } else {
                        // Same color for name & number (1 color): show 1 color, not Full color
                        colorImprintLoc.no_of_color = finalList.length;
                        colorImprintLoc.is_full_color = false;
                        colorImprintLoc.full_color_count = finalList.length;
                    }
                }
                const genderLoc =
                    this.genderGroups[this.active_gender_index]
                        .imprint_locations[locationIndex];
                if (genderLoc) {
                    genderLoc.colors = JSON.parse(
                        JSON.stringify(colorImprintLoc.colors)
                    );
                    if (finalList.length > 0) {
                        if (serviceIsFullColor && hasMultipleColors) {
                            genderLoc.no_of_color = "full_color";
                            genderLoc.is_full_color = true;
                            genderLoc.full_color_count = finalList.length;
                        } else {
                            // Same color for name & number (1 color): sync to 1 color
                            genderLoc.no_of_color = finalList.length;
                            genderLoc.is_full_color = false;
                            genderLoc.full_color_count = finalList.length;
                        }
                    }
                }
            });

            this.$forceUpdate();
        },

        /** Sync name/number colors to imprint_locations for ALL product colors (used after set design so every color shows dropdowns). */
        syncNameNumberColorsForAllColors() {
            if (
                !this.genderGroups ||
                !this.genderGroups[this.active_gender_index] ||
                !this.genderGroups[this.active_gender_index].colors
            ) {
                return;
            }
            const gender = this.genderGroups[this.active_gender_index];
            const imprintLocations = gender.imprint_locations;
            if (!imprintLocations || !Array.isArray(imprintLocations)) return;

            const isSameColor = (a, b) =>
                a &&
                b &&
                (a.color_id === b.color_id ||
                    (a.id !== undefined &&
                        b.id !== undefined &&
                        a.id === b.id) ||
                    (a.color_value &&
                        b.color_value &&
                        String(a.color_value).toLowerCase().trim() ===
                            String(b.color_value).toLowerCase().trim()));

            gender.colors.forEach((activeColor) => {
                if (
                    !activeColor ||
                    !activeColor.view_settings ||
                    !activeColor.imprint_locations
                ) {
                    return;
                }
                imprintLocations.forEach((location, locationIndex) => {
                    if (!location || !location.location) return;
                    const locationKey = this.getLocationKeyForDecorationColors(
                        location.location
                    );
                    if (!locationKey) return;

                    const nameNumberSlots = this.getNameNumberColorSlots(
                        activeColor,
                        locationKey
                    );
                    const designSlots =
                        this.getDesignColorSlotsForLocationKey(locationKey);
                    const merged = nameNumberSlots.map((c) => ({
                        color: c,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    }));
                    designSlots.forEach((slot) => {
                        const c = slot.color;
                        if (!nameNumberSlots.some((nn) => isSameColor(c, nn))) {
                            merged.push(JSON.parse(JSON.stringify(slot)));
                        }
                    });
                    const finalList = merged.length > 0 ? merged : designSlots;

                    const colorImprintLoc =
                        activeColor.imprint_locations[locationIndex];
                    if (!colorImprintLoc) return;

                    colorImprintLoc.colors =
                        finalList.length > 0
                            ? JSON.parse(JSON.stringify(finalList))
                            : [];
                    const serviceIsFullColor =
                        this.activeDecorationService &&
                        this.activeDecorationService.is_full_color === true;
                    const hasMultipleColors = finalList.length > 1;

                    if (finalList.length > 0) {
                        if (serviceIsFullColor && hasMultipleColors) {
                            colorImprintLoc.no_of_color = "full_color";
                            colorImprintLoc.is_full_color = true;
                            colorImprintLoc.full_color_count = finalList.length;
                        } else {
                            colorImprintLoc.no_of_color = finalList.length;
                            colorImprintLoc.is_full_color = false;
                            colorImprintLoc.full_color_count = finalList.length;
                        }
                    }
                });
            });

            if (
                gender.imprint_locations &&
                gender.imprint_locations.length > 0 &&
                gender.colors[0] &&
                gender.colors[0].imprint_locations
            ) {
                gender.imprint_locations.forEach((genderLoc, locationIndex) => {
                    if (gender.colors[0].imprint_locations[locationIndex]) {
                        genderLoc.colors = JSON.parse(
                            JSON.stringify(
                                gender.colors[0].imprint_locations[
                                    locationIndex
                                ].colors
                            )
                        );
                        const no =
                            gender.colors[0].imprint_locations[locationIndex]
                                .no_of_color;
                        if (no !== undefined && no !== null) {
                            genderLoc.no_of_color = no;
                            genderLoc.is_full_color =
                                gender.colors[0].imprint_locations[
                                    locationIndex
                                ].is_full_color;
                            genderLoc.full_color_count =
                                gender.colors[0].imprint_locations[
                                    locationIndex
                                ].full_color_count;
                        }
                    }
                });
            }
            this.$forceUpdate();
        },

        /** Build design (clipart) color slots for a location from allDecorationColors. */
        getDesignColorSlotsForLocationKey(locationKey) {
            const out = [];
            if (
                !this.allDecorationColors ||
                !locationKey ||
                !this.vendorColors ||
                !Array.isArray(this.vendorColors)
            ) {
                return out;
            }
            const decorationColors =
                this.allDecorationColors[locationKey] || [];
            if (
                !decorationColors ||
                !Array.isArray(decorationColors) ||
                decorationColors.length === 0
            ) {
                return out;
            }
            decorationColors.forEach((colorHex) => {
                const vendorColor = this.vendorColors.find(
                    (vc) =>
                        vc.color_value &&
                        vc.color_value.toLowerCase() ===
                            String(colorHex).toLowerCase()
                );
                if (vendorColor) {
                    out.push({
                        color: vendorColor,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                } else {
                    let nonStandardFee = 0;
                    const decorationType =
                        this.activeDecorationService &&
                        this.activeDecorationService.master_service
                            ? this.activeDecorationService.master_service
                                  .decoration_type
                            : this.activeDecorationService &&
                              this.activeDecorationService.decoration_type
                            ? this.activeDecorationService.decoration_type
                            : 1;
                    const serviceName = this.activeDecorationService
                        ? (
                              this.activeDecorationService.name || ""
                          ).toLowerCase()
                        : "";
                    const fee = this.getColorMixFeeFromVendorServices(
                        decorationType,
                        serviceName
                    );
                    if (fee !== null && fee > 0) nonStandardFee = fee;
                    out.push({
                        color: {
                            color_id: 0,
                            color_name: "Mix Color",
                            color_pms: "Non Standard",
                            non_standard_fee: nonStandardFee,
                            decor_upcharge: 0,
                            color_value: colorHex || "#GGGGGG",
                            swatches: "",
                            category: "Non Standard",
                            shades: []
                        },
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
            });
            return out;
        },

        // Separate method for PCNA breakdown that includes colors
        getGenderImprintLocationsWithColors() {
            // For PCNA breakdown, we need to include colors from colors' imprint_locations
            // to ensure non_standard_fee is properly available
            const locations =
                this.genderGroups[this.active_gender_index].imprint_locations;

            // Get colors from the first available color's imprint_locations (all colors should have same structure)
            if (
                this.genderGroups[this.active_gender_index].colors &&
                this.genderGroups[this.active_gender_index].colors.length > 0
            ) {
                // Try to get colors from active color first, otherwise use first color
                const colorIndex =
                    this.activeColorIndex >= 0 ? this.activeColorIndex : 0;
                const colorData =
                    this.genderGroups[this.active_gender_index].colors[
                        colorIndex
                    ];

                if (
                    colorData &&
                    colorData.imprint_locations &&
                    Array.isArray(colorData.imprint_locations)
                ) {
                    // Create a new array with merged colors data
                    return locations.map((location, index) => {
                        const locationCopy = { ...location };
                        // Get colors from color's imprint_locations if available
                        if (
                            colorData.imprint_locations[index] &&
                            colorData.imprint_locations[index].colors &&
                            Array.isArray(
                                colorData.imprint_locations[index].colors
                            )
                        ) {
                            locationCopy.colors =
                                colorData.imprint_locations[index].colors;
                        }
                        return locationCopy;
                    });
                }
            }

            return locations;
        },

        getActiveColorData() {
            return this.genderGroups[this.active_gender_index].colors[
                this.activeColorIndex
            ];
        },

        getColorTotalCost() {
            return this.icPriceFormat(
                this.genderGroups[this.active_gender_index].colors[
                    this.activeColorIndex
                ].total_cost_gender_wise
            );
        },

        getColorTotalQuantity() {
            return this.genderGroups[this.active_gender_index].colors[
                this.activeColorIndex
            ].total_qty_gender_wise;
        },

        getPCNAMixColorCount() {
            // For PCNA, get mix color count from totalNonStandardColors prop or calculate from allDecorationColors
            if (
                this.totalNonStandardColors &&
                Array.isArray(this.totalNonStandardColors) &&
                this.totalNonStandardColors.length > 0
            ) {
                return this.totalNonStandardColors.length;
            }

            // Fallback: calculate from allDecorationColors (non-standard colors not in vendorColors)
            if (
                this.allDecorationColors &&
                this.vendorColors &&
                Array.isArray(this.vendorColors)
            ) {
                let allColors = [];
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes && Array.isArray(colorHexCodes)) {
                        allColors = allColors.concat(colorHexCodes);
                    }
                }

                // Filter non-standard colors (colors not in vendorColors)
                if (allColors.length > 0) {
                    const nonStandardColors = allColors.filter((hexCode) => {
                        if (!hexCode) return false;
                        const hex =
                            typeof hexCode === "string"
                                ? hexCode.toLowerCase()
                                : hexCode.hex
                                ? hexCode.hex.toLowerCase()
                                : "";
                        const vendorColor = this.vendorColors.find(
                            (color) =>
                                color.color_value &&
                                color.color_value.toLowerCase() === hex
                        );
                        return !vendorColor; // Non-standard if not found in vendor colors
                    });
                    // Remove duplicates
                    const uniqueColors = [...new Set(nonStandardColors)];
                    return uniqueColors.length;
                }
            }

            return 0;
        },

        getPCNAFeePerColor() {
            // Try to get fee per color from props first (this comes from VendorFees with rollup_fee_id)
            if (
                this.nonStandardFeePerColor &&
                parseFloat(this.nonStandardFeePerColor) > 0
            ) {
                return parseFloat(this.nonStandardFeePerColor);
            }

            // No fallback - only use VendorFees with rollup_fee_id
            return 0;
        },

        // Get Custom Color Fee from VendorFees (using ecomm_display for matching)
        getColorMixFeeFromVendorServices(decorationType, serviceName) {
            // Use VendorFees from product data instead of otherServices prop
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Determine which service to use based on decoration type or service name
            let targetService = null;

            if (decorationType == 1) {
                // Screen Print - use Custom Ink Mix Fee (only if rollup_fee_id exists)
                targetService = vendorFees.find(
                    (service) =>
                        service.rollup_fee_id &&
                        (service.type === "custom_ink_mix" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("ink mix fee")))
                );
            } else if (decorationType == 2) {
                // Embroidery - use Thread Fee (only if rollup_fee_id exists)
                targetService = vendorFees.find(
                    (service) =>
                        service.rollup_fee_id &&
                        (service.type === "thread_fee" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("thread mix fee")))
                );
            } else {
                // For PCNA (decoration_type 0), check service name for "print" or "embroidery"
                const serviceNameLower = serviceName
                    ? serviceName.toLowerCase()
                    : "";
                const isEmbroidery =
                    serviceNameLower.includes("embroidery") ||
                    serviceNameLower.includes("emb");
                const isPrint = serviceNameLower.includes("print");

                if (isEmbroidery) {
                    // Embroidery service = Thread Mix Fee (only if rollup_fee_id exists)
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee")))
                    );
                } else if (isPrint) {
                    // Print service = Ink Mix Fee (only if rollup_fee_id exists)
                    targetService = vendorFees.find(
                        (service) =>
                            service.rollup_fee_id &&
                            (service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee")))
                    );
                }
                // If neither embroidery nor print, targetService remains null (no fee)
            }

            if (targetService && targetService.retail_cost) {
                return parseFloat(targetService.retail_cost) || 0;
            }

            return null;
        },

        // Get Name Fee from VendorFees (using ecomm_display for matching)
        getNameFeeFromVendorServices() {
            // Use VendorFees from product data instead of otherServices prop
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Find by type first, then fallback to ecomm_display matching
            const nameService = vendorFees.find(
                (service) =>
                    service.type === "name" ||
                    (service.ecomm_display &&
                        service.ecomm_display.toLowerCase().includes("name"))
            );

            if (nameService && nameService.retail_cost) {
                return parseFloat(nameService.retail_cost) || 0;
            }

            return null;
        },

        // Get Number Fee from VendorFees (using ecomm_display for matching)
        getNumberFeeFromVendorServices() {
            // Use VendorFees from product data instead of otherServices prop
            const vendorFees =
                this.product && this.product.VendorFees
                    ? this.product.VendorFees
                    : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Find by type first, then fallback to ecomm_display matching
            const numberService = vendorFees.find(
                (service) =>
                    service.type === "number" ||
                    (service.ecomm_display &&
                        service.ecomm_display.toLowerCase().includes("number"))
            );

            if (numberService && numberService.retail_cost) {
                return parseFloat(numberService.retail_cost) || 0;
            }

            return null;
        },

        // Get unique non-standard color count for design studio
        getUniqueNonStandardColorCount() {
            if (
                !this.allDecorationColors ||
                !this.vendorColors ||
                !Array.isArray(this.vendorColors)
            ) {
                return 0;
            }

            let allColors = [];
            for (const [flip, colorHexCodes] of Object.entries(
                this.allDecorationColors
            )) {
                if (colorHexCodes && Array.isArray(colorHexCodes)) {
                    allColors = allColors.concat(colorHexCodes);
                }
            }

            if (allColors.length === 0) {
                return 0;
            }

            // Filter non-standard colors (colors not in vendorColors)
            const nonStandardColors = allColors.filter((hexCode) => {
                if (!hexCode) return false;
                const hex =
                    typeof hexCode === "string"
                        ? hexCode.toLowerCase()
                        : hexCode.hex
                        ? hexCode.hex.toLowerCase()
                        : "";
                const vendorColor = this.vendorColors.find(
                    (color) =>
                        color.color_value &&
                        color.color_value.toLowerCase() === hex
                );
                return !vendorColor; // Non-standard if not found in vendor colors
            });

            // Remove duplicates and return count
            const uniqueColors = [...new Set(nonStandardColors)];
            return uniqueColors.length;
        },

        // Check which imprint locations have decorations (for name/number fee display)
        hasFrontOrBackDecoration(genderIndex) {
            if (
                !this.genderGroups[genderIndex] ||
                !this.genderGroups[genderIndex].imprint_locations
            ) {
                return {
                    hasFront: false,
                    hasBack: false,
                    hasLeft: false,
                    hasRight: false
                };
            }

            const imprintLocations =
                this.genderGroups[genderIndex].imprint_locations;
            const hasFront = imprintLocations.some(
                (loc) =>
                    loc.is_selected &&
                    loc.location &&
                    loc.location.toLowerCase() === "front"
            );
            const hasBack = imprintLocations.some(
                (loc) =>
                    loc.is_selected &&
                    loc.location &&
                    loc.location.toLowerCase() === "back"
            );
            const hasLeft = imprintLocations.some(
                (loc) =>
                    loc.is_selected &&
                    loc.location &&
                    loc.location.toLowerCase().includes("left")
            );
            const hasRight = imprintLocations.some(
                (loc) =>
                    loc.is_selected &&
                    loc.location &&
                    loc.location.toLowerCase().includes("right")
            );

            return { hasFront, hasBack, hasLeft, hasRight };
        },

        // Count names and numbers from name_and_number_json for all colors in gender
        countNamesAndNumbers(genderIndex) {
            if (
                !this.genderGroups[genderIndex] ||
                !this.genderGroups[genderIndex].colors
            ) {
                return { nameCount: 0, numberCount: 0 };
            }

            let nameCount = 0;
            let numberCount = 0;

            this.genderGroups[genderIndex].colors.forEach((color) => {
                if (
                    color.name_and_number_json &&
                    Array.isArray(color.name_and_number_json)
                ) {
                    color.name_and_number_json.forEach((nn) => {
                        if (nn.name && nn.name.trim() !== "") {
                            nameCount++;
                        }
                        if (nn.number && nn.number.toString().trim() !== "") {
                            numberCount++;
                        }
                    });
                }
            });

            return { nameCount, numberCount };
        },

        // Count names and numbers per location (front, back, left, right) - separate counts for run charge breakdown
        // Use active color only: count from name/number state per location, not product quantity.
        // Exclude placeholders: "YOUR NAME", "ENTER NAME", "00" are not counted as real entries.
        countNamesAndNumbersByLocation(genderIndex) {
            if (
                !this.genderGroups[genderIndex] ||
                !this.genderGroups[genderIndex].colors
            ) {
                return {
                    frontNameCount: 0,
                    backNameCount: 0,
                    frontNumberCount: 0,
                    backNumberCount: 0,
                    leftNameCount: 0,
                    leftNumberCount: 0,
                    rightNameCount: 0,
                    rightNumberCount: 0
                };
            }
            // Use pre-computed counts from JSON when set (e.g. after setDesign/API restore) so Run Charge shows correct totals, not product quantity
            const displayCounts = this.genderGroups[genderIndex].name_number_display_counts;
            if (displayCounts && typeof displayCounts === "object") {
                return {
                    frontNameCount: displayCounts.frontNameCount || 0,
                    backNameCount: displayCounts.backNameCount || 0,
                    frontNumberCount: displayCounts.frontNumberCount || 0,
                    backNumberCount: displayCounts.backNumberCount || 0,
                    leftNameCount: displayCounts.leftNameCount || 0,
                    leftNumberCount: displayCounts.leftNumberCount || 0,
                    rightNameCount: displayCounts.rightNameCount || 0,
                    rightNumberCount: displayCounts.rightNumberCount || 0
                };
            }

            // Count = name/number entries only per location, never product quantity
            const isRealName = (val) => {
                if (!val || typeof val !== "string") return false;
                const t = val.trim();
                if (t === "") return false;
                const u = t.toUpperCase();
                if (u === "YOUR NAME" || u === "ENTER NAME") return false;
                // Exclude numeric-only (e.g. "12") - that's jersey number/quantity, not a name
                if (/^\d+$/.test(t)) return false;
                return true;
            };
            const isRealNumber = (val) => {
                if (val === null || val === undefined) return false;
                const t = val.toString().trim();
                return t !== "" && t !== "00";
            };

            let frontNameCount = 0;
            let backNameCount = 0;
            let frontNumberCount = 0;
            let backNumberCount = 0;
            let leftNameCount = 0;
            let leftNumberCount = 0;
            let rightNameCount = 0;
            let rightNumberCount = 0;

            // Use active color's name/number data only; count = names/numbers added, not product quantity
            const colors = this.genderGroups[genderIndex].colors;
            const activeIdx =
                this.activeColorIndex != null && this.activeColorIndex >= 0
                    ? this.activeColorIndex
                    : 0;
            const color = colors[activeIdx] || colors[0];
            if (!color) {
                return {
                    frontNameCount,
                    backNameCount,
                    frontNumberCount,
                    backNumberCount,
                    leftNameCount,
                    leftNumberCount,
                    rightNameCount,
                    rightNumberCount
                };
            }

            const nnJson = color.name_and_number_json;
            const snn = color.selected_name_number || {};
            if (!nnJson) {
                return {
                    frontNameCount,
                    backNameCount,
                    frontNumberCount,
                    backNumberCount,
                    leftNameCount,
                    leftNumberCount,
                    rightNameCount,
                    rightNumberCount
                };
            }

            // Object format: { front: [], back: [], left: [], right: [] } - each view separate
            if (typeof nnJson === "object" && !Array.isArray(nnJson)) {
                const views = [
                    { key: "front", nameKey: "name", numberKey: "number" },
                    { key: "back", nameKey: "name", numberKey: "number" },
                    { key: "left", nameKey: "name", numberKey: "number" },
                    { key: "right", nameKey: "name", numberKey: "number" }
                ];
                views.forEach((view) => {
                    const arr = nnJson[view.key];
                    if (!Array.isArray(arr)) return;
                    const viewSel = snn[view.key] || {};
                    let nameCount = 0;
                    let numberCount = 0;
                    arr.forEach((nn) => {
                        if (isRealName(nn.name) && viewSel.name === true)
                            nameCount++;
                        if (isRealNumber(nn.number) && viewSel.number === true)
                            numberCount++;
                    });
                    if (view.key === "front") {
                        frontNameCount = nameCount;
                        frontNumberCount = numberCount;
                    } else if (view.key === "back") {
                        backNameCount = nameCount;
                        backNumberCount = numberCount;
                    } else if (view.key === "left") {
                        leftNameCount = nameCount;
                        leftNumberCount = numberCount;
                    } else if (view.key === "right") {
                        rightNameCount = nameCount;
                        rightNumberCount = numberCount;
                    }
                });
            } else if (Array.isArray(nnJson) && nnJson.length > 0) {
                // Array format (legacy) - no left/right
                let legacyFrontName = 0;
                let legacyBackName = 0;
                let legacyFrontNumber = 0;
                let legacyBackNumber = 0;
                nnJson.forEach((nn) => {
                    if (isRealName(nn.name)) {
                        if ((snn.front || {}).name === true) legacyFrontName++;
                        if ((snn.back || {}).name === true) legacyBackName++;
                    }
                    if (isRealNumber(nn.number)) {
                        if ((snn.front || {}).number === true)
                            legacyFrontNumber++;
                        if ((snn.back || {}).number === true)
                            legacyBackNumber++;
                    }
                });
                frontNameCount = legacyFrontName;
                backNameCount = legacyBackName;
                frontNumberCount = legacyFrontNumber;
                backNumberCount = legacyBackNumber;
            }

            var computedCounts = {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount,
                leftNameCount,
                leftNumberCount,
                rightNameCount,
                rightNumberCount
            };
            // Cache on gender group so Run Charge shows correct counts even when Names & Numbers panel is closed
            if (this.genderGroups[genderIndex] && this.$set) {
                this.$set(this.genderGroups[genderIndex], "name_number_display_counts", { ...computedCounts });
            }
            return computedCounts;
        },

        selectImprintLocations(index) {
            // if (this.disable_imprint_locations) {
            //     return;
            // }
            // IMPORTANT: Use original array, not getGenderImprintLocations() which returns copy for decoration type 2
            let imprint_locations =
                this.genderGroups[this.active_gender_index].imprint_locations;
            let no_of_location = 0;
            let previous_index = "";
            imprint_locations.forEach((location, key) => {
                if (location.is_selected) {
                    no_of_location++;
                    previous_index = key;
                }
            });
            // Maintain only on selection in imprint locations
            if (no_of_location == 1 && previous_index == index) {
                return true;
            }

            // Get the new selection state before toggling
            const newSelectionState = !imprint_locations[index].is_selected;

            // Update main imprint_locations array
            if (imprint_locations[index].is_selected) {
                imprint_locations[index].no_of_color = null;
                imprint_locations[index].colors = [];
            }
            imprint_locations[index].is_selected = newSelectionState;

            // Update all colors' imprint_locations arrays
            let selectedColors =
                this.genderGroups[this.active_gender_index].colors;
            selectedColors.forEach((color) => {
                // Use the new selection state consistently
                if (newSelectionState) {
                    // If selecting, clear colors if they exist
                    if (
                        color.imprint_locations[index].colors &&
                        color.imprint_locations[index].colors.length > 0
                    ) {
                        color.imprint_locations[index].no_of_color = null;
                        color.imprint_locations[index].colors = [];
                    }
                } else {
                    // If deselecting, clear colors
                    color.imprint_locations[index].no_of_color = null;
                    color.imprint_locations[index].colors = [];
                }
                color.imprint_locations[index].is_selected = newSelectionState;
            });

            this.updatePrintAreas(index);
            this.calculatePricing(this.active_gender_index);
            setTimeout(() => {
                /* eslint-disable */
                $("#collapseid" + index).click();
                /* eslint-enable */
            }, 1000);
            this.$forceUpdate();
        },

        selectNumberOfColors(location, count) {
            let locationIndex = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex(
                (locat) => locat.location == location.location
            );

            // Handle "Full color" selection
            if (count === "full_color" || count === "Full color") {
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].no_of_color = "full_color";
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].is_full_color = true;

                // Initialize with default color count of 1 for full color
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].full_color_count = 1;

                // Extract colors from design if available
                let designColors = [];
                if (this.allDecorationColors && location.location) {
                    let locationKey = this.getLocationKeyForDecorationColors(
                        location.location
                    );
                    let decorationColors = locationKey
                        ? this.allDecorationColors[locationKey] || []
                        : [];

                    if (
                        decorationColors &&
                        Array.isArray(decorationColors) &&
                        decorationColors.length > 0
                    ) {
                        decorationColors.forEach((colorHex) => {
                            // Find vendor color or create non-standard color
                            let vendorColor = this.vendorColors.find(
                                (vc) =>
                                    vc.color_value &&
                                    vc.color_value.toLowerCase() ===
                                        colorHex.toLowerCase()
                            );

                            if (vendorColor) {
                                designColors.push({
                                    color: vendorColor,
                                    color_cost: 0.0,
                                    cost_cost: 0.0,
                                    cost_sum_added: false
                                });
                            } else {
                                // Non-standard color
                                designColors.push({
                                    color: {
                                        color_id: 0,
                                        color_name: "Mix Color",
                                        color_pms: "Non Standard",
                                        decor_upcharge: 0,
                                        color_value: colorHex || "#GGGGGG",
                                        swatches: "",
                                        category: "Non Standard",
                                        shades: []
                                    },
                                    color_cost: 0.0,
                                    cost_cost: 0.0,
                                    cost_sum_added: false
                                });
                            }
                        });
                    }
                }

                // If design colors found, use them; otherwise initialize with 1 empty slot
                if (designColors.length > 0) {
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations[locationIndex].colors = designColors;
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations[locationIndex].full_color_count =
                        designColors.length;
                } else {
                    // Initialize with 1 empty color slot
                    this.genderGroups[
                        this.active_gender_index
                    ].imprint_locations[locationIndex].colors = [
                        {
                            color: null,
                            color_cost: 0.0,
                            cost_cost: 0.0,
                            cost_sum_added: false
                        }
                    ];
                }

                let selectedColors =
                    this.genderGroups[this.active_gender_index].colors;
                selectedColors.forEach((color) => {
                    // Copy colors structure to all fabric colors
                    if (designColors.length > 0) {
                        color.imprint_locations[locationIndex].colors =
                            JSON.parse(JSON.stringify(designColors));
                    } else {
                        color.imprint_locations[locationIndex].colors = [
                            {
                                color: null,
                                color_cost: 0.0,
                                cost_cost: 0.0,
                                cost_sum_added: false
                            }
                        ];
                    }
                    color.imprint_locations[locationIndex].no_of_color =
                        "full_color";
                    color.imprint_locations[locationIndex].is_full_color = true;
                    color.imprint_locations[locationIndex].full_color_count =
                        this.genderGroups[this.active_gender_index]
                            .imprint_locations[locationIndex]
                            .full_color_count || 1;
                });
            } else {
                // Normal color count selection
                let no_of_colors = parseInt(count) || 0;
                let colors = [];
                for (let i = 0; i < no_of_colors; i++) {
                    colors.push({
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
                /* eslint-disable */
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors = colors;
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].no_of_color = parseInt(count) || null;
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].is_full_color = false;

                let selectedColors =
                    this.genderGroups[this.active_gender_index].colors;
                selectedColors.forEach((color) => {
                    color.imprint_locations[locationIndex].colors = colors;
                    color.imprint_locations[locationIndex].no_of_color =
                        parseInt(count) || null;
                    color.imprint_locations[
                        locationIndex
                    ].is_full_color = false;
                });
            }

            // Auto-expand the color panel when a color count is selected
            if (count) {
                this.$set(
                    this.genderGroups[this.active_gender_index]
                        .imprint_locations[locationIndex],
                    "collapse",
                    true
                );
                this.genderGroups[this.active_gender_index].colors.forEach(
                    (color) => {
                        if (
                            color.imprint_locations &&
                            Array.isArray(color.imprint_locations) &&
                            color.imprint_locations[locationIndex]
                        ) {
                            this.$set(
                                color.imprint_locations[locationIndex],
                                "collapse",
                                true
                            );
                        }
                    }
                );
            }

            this.calculatePricing(this.active_gender_index);
            if (this.genderGroups[this.active_gender_index].colors.length > 3) {
                let timer = 1000;
                setTimeout(() => {
                    let owl = $(".ink-color-slider").owlCarousel({
                        loop: false,
                        autoWidth: false,
                        margin: 0,
                        items: 3,
                        autoplay: false,
                        autoplayTimeout: 4000,
                        autoplayHoverPause: false,
                        responsiveClass: true,
                        navigation: false,
                        dots: false
                    });
                    $(".play").on("click", function () {
                        owl.trigger("play.owl.autoplay", [1000]);
                    });
                    $(".stop").on("click", function () {
                        owl.trigger("stop.owl.autoplay");
                    });
                    $(".customNextBtn").click(function () {
                        owl.trigger("next.owl.carousel");
                    });
                    // Go to the previous item
                    $(".customPrevBtn").click(function () {
                        // With optional speed parameter
                        // Parameters has to be in square bracket '[]'
                        owl.trigger("prev.owl.carousel", [300]);
                    });
                }, timer);
            }
            /* eslint-enable */
        },

        selectVendorColors(
            imprintColorObj,
            imprintColorIndex,
            imprintLocationIndex,
            fabricColorIndex
        ) {
            let fabricColors =
                this.genderGroups[this.active_gender_index].colors;
            let fabricColor = fabricColors[fabricColorIndex];
            let imprint_color =
                fabricColor.imprint_locations[imprintLocationIndex].colors[
                    imprintColorIndex
                ];
            if (imprintColorObj) {
                // Create a copy of the color object to avoid mutating the original
                let colorObj = { ...imprintColorObj };

                // If it's a custom color (color_id == 0), set non_standard_fee based on decoration type
                if (colorObj.color_id == 0) {
                    let nonStandardFee = 0;
                    const decorationType =
                        this.activeDecorationService &&
                        this.activeDecorationService.master_service
                            ? this.activeDecorationService.master_service
                                  .decoration_type
                            : this.activeDecorationService &&
                              this.activeDecorationService.decoration_type
                            ? this.activeDecorationService.decoration_type
                            : null;
                    const serviceName = this.activeDecorationService
                        ? (
                              this.activeDecorationService.name || ""
                          ).toLowerCase()
                        : "";

                    if (decorationType == 0) {
                        // PCNA - Get fee per color for PCNA
                        let feePerColor = this.getPCNAFeePerColor();
                        if (feePerColor > 0) {
                            nonStandardFee = feePerColor;
                        }
                    } else if (decorationType == 1 || decorationType == 2) {
                        // Print or Embroidery - Get from VendorServices
                        let colorMixFeePerColor =
                            this.getColorMixFeeFromVendorServices(
                                decorationType,
                                serviceName
                            );
                        if (
                            colorMixFeePerColor !== null &&
                            colorMixFeePerColor > 0
                        ) {
                            nonStandardFee = colorMixFeePerColor;
                        }
                    }

                    if (nonStandardFee > 0) {
                        colorObj.non_standard_fee = nonStandardFee;
                    }
                }

                imprint_color.color = colorObj;
                imprint_color.decor_upcharge = {
                    cost_added: true,
                    color_id: colorObj.color_id,
                    color_cost: 0,
                    cost_cost: 0
                };
            } else {
                imprint_color.color = null;
                imprint_color.decor_upcharge = null;
            }

            // Trigger pricing calculation to update display
            this.calculatePricing(this.active_gender_index);
        },

        updateFullColorCount(location, count) {
            let locationIndex = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex(
                (locat) => locat.location == location.location
            );

            let colorCount = parseInt(count) || 1;
            if (colorCount < 1) colorCount = 1;

            // Update full_color_count
            this.genderGroups[this.active_gender_index].imprint_locations[
                locationIndex
            ].full_color_count = colorCount;

            // Adjust colors array based on new count
            let currentColors =
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors || [];

            if (colorCount > currentColors.length) {
                // Add more empty color slots
                for (let i = currentColors.length; i < colorCount; i++) {
                    currentColors.push({
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
            } else if (colorCount < currentColors.length) {
                // Remove extra color slots
                currentColors = currentColors.slice(0, colorCount);
            }

            this.genderGroups[this.active_gender_index].imprint_locations[
                locationIndex
            ].colors = currentColors;

            // Update for all fabric colors
            let selectedColors =
                this.genderGroups[this.active_gender_index].colors;
            selectedColors.forEach((color) => {
                // Adjust colors array for this fabric color
                let fabricColors =
                    color.imprint_locations[locationIndex].colors || [];

                if (colorCount > fabricColors.length) {
                    for (let i = fabricColors.length; i < colorCount; i++) {
                        fabricColors.push({
                            color: null,
                            color_cost: 0.0,
                            cost_cost: 0.0,
                            cost_sum_added: false
                        });
                    }
                } else if (colorCount < fabricColors.length) {
                    fabricColors = fabricColors.slice(0, colorCount);
                }

                color.imprint_locations[locationIndex].colors = fabricColors;
                color.imprint_locations[locationIndex].full_color_count =
                    colorCount;
            });

            this.$forceUpdate();
        },

        extractDesignColorsForLocation(location, locationIndex) {
            // Extract colors from design (clipart/shapes) for this location
            let designColors = [];
            const locationKey = location.location
                ? this.getLocationKeyForDecorationColors(location.location)
                : null;

            if (this.allDecorationColors && location.location && locationKey) {
                let decorationColors =
                    this.allDecorationColors[locationKey] || [];

                if (
                    decorationColors &&
                    Array.isArray(decorationColors) &&
                    decorationColors.length > 0
                ) {
                    decorationColors.forEach((colorHex) => {
                        // Find vendor color or create non-standard color
                        let vendorColor = this.vendorColors.find(
                            (vc) =>
                                vc.color_value &&
                                vc.color_value.toLowerCase() ===
                                    colorHex.toLowerCase()
                        );

                        if (vendorColor) {
                            designColors.push({
                                color: vendorColor,
                                color_cost: 0.0,
                                cost_cost: 0.0,
                                cost_sum_added: false
                            });
                        } else {
                            // Non-standard color - get non_standard_fee
                            let nonStandardFee = 0;
                            const decorationType =
                                this.activeDecorationService &&
                                this.activeDecorationService.master_service
                                    ? this.activeDecorationService
                                          .master_service.decoration_type
                                    : this.activeDecorationService &&
                                      this.activeDecorationService
                                          .decoration_type
                                    ? this.activeDecorationService
                                          .decoration_type
                                    : 1;
                            const serviceName = this.activeDecorationService
                                ? (
                                      this.activeDecorationService.name || ""
                                  ).toLowerCase()
                                : "";

                            // Get custom color fee from VendorServices
                            let colorMixFeePerColor =
                                this.getColorMixFeeFromVendorServices(
                                    decorationType,
                                    serviceName
                                );
                            if (
                                colorMixFeePerColor !== null &&
                                colorMixFeePerColor > 0
                            ) {
                                nonStandardFee = colorMixFeePerColor;
                            }

                            designColors.push({
                                color: {
                                    color_id: 0,
                                    color_name: "Mix Color",
                                    color_pms: "Non Standard",
                                    non_standard_fee: nonStandardFee,
                                    decor_upcharge: 0,
                                    color_value: colorHex || "#GGGGGG",
                                    swatches: "",
                                    category: "Non Standard",
                                    shades: []
                                },
                                color_cost: 0.0,
                                cost_cost: 0.0,
                                cost_sum_added: false
                            });
                        }
                    });
                }
            }

            // Merge ALL name/number colors with design colors per fabric color so name/number colors are never removed when clipart is added
            const selectedColors =
                this.genderGroups[this.active_gender_index].colors;
            const activeColor =
                selectedColors[
                    this.activeColorIndex >= 0 ? this.activeColorIndex : 0
                ];

            const isSameColor = (a, b) =>
                a &&
                b &&
                (a.color_id === b.color_id ||
                    (a.color_value &&
                        b.color_value &&
                        String(a.color_value).toLowerCase().trim() ===
                            String(b.color_value).toLowerCase().trim()));

            const serviceIsFullColor =
                this.activeDecorationService &&
                this.activeDecorationService.is_full_color === true;

            selectedColors.forEach((fabricColor) => {
                const nameNumberObjs = this.getNameNumberColorSlots(
                    fabricColor,
                    locationKey
                );
                const mergedList = nameNumberObjs.map((c) => ({
                    color: c,
                    color_cost: 0.0,
                    cost_cost: 0.0,
                    cost_sum_added: false
                }));
                designColors.forEach((slot) => {
                    const c = slot.color;
                    if (!nameNumberObjs.some((nn) => isSameColor(c, nn))) {
                        mergedList.push(JSON.parse(JSON.stringify(slot)));
                    }
                });
                const finalList =
                    mergedList.length > 0 ? mergedList : designColors;
                const totalMerged = finalList.length;
                fabricColor.imprint_locations[locationIndex].colors =
                    totalMerged > 0
                        ? JSON.parse(JSON.stringify(finalList))
                        : [];
                fabricColor.imprint_locations[locationIndex].full_color_count =
                    totalMerged;
                // Sync 1 color vs Full color from actual name/number + design count
                if (totalMerged > 0) {
                    if (serviceIsFullColor && totalMerged > 1) {
                        fabricColor.imprint_locations[
                            locationIndex
                        ].no_of_color = "full_color";
                        fabricColor.imprint_locations[
                            locationIndex
                        ].is_full_color = true;
                    } else {
                        fabricColor.imprint_locations[
                            locationIndex
                        ].no_of_color = totalMerged;
                        fabricColor.imprint_locations[
                            locationIndex
                        ].is_full_color = false;
                    }
                }
            });

            // Update gender's imprint_locations from active color so structure matches
            if (activeColor && activeColor.imprint_locations[locationIndex]) {
                const activeColors =
                    activeColor.imprint_locations[locationIndex].colors || [];
                const totalCount = activeColors.length;
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors = JSON.parse(JSON.stringify(activeColors));
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].full_color_count =
                    activeColor.imprint_locations[locationIndex]
                        .full_color_count || totalCount;
                // Sync 1 color vs Full color from actual count (name/number same color → 1 color)
                if (totalCount > 0) {
                    if (serviceIsFullColor && totalCount > 1) {
                        this.genderGroups[
                            this.active_gender_index
                        ].imprint_locations[locationIndex].no_of_color =
                            "full_color";
                        this.genderGroups[
                            this.active_gender_index
                        ].imprint_locations[locationIndex].is_full_color = true;
                    } else {
                        this.genderGroups[
                            this.active_gender_index
                        ].imprint_locations[locationIndex].no_of_color =
                            totalCount;
                        this.genderGroups[
                            this.active_gender_index
                        ].imprint_locations[
                            locationIndex
                        ].is_full_color = false;
                    }
                }
            } else if (designColors.length > 0) {
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].colors = JSON.parse(JSON.stringify(designColors));
                this.genderGroups[this.active_gender_index].imprint_locations[
                    locationIndex
                ].full_color_count = designColors.length;
            }

            this.$forceUpdate();
        },

        calcImprintLocationByGender(masterServicePricing = null) {
            if (!this.activeDecorationService) {
                console.error(
                    "calcImprintLocationByGender: activeDecorationService is missing."
                );
                return { total_colors: 0, totalCalculatedDecorationFee: 0 };
            }

            let total_gender_quantity = this.getTotalItemQuantity(
                this.genderGroups[this.active_gender_index] // Ensure active_gender_index is correct
            );

            let imprint_locations = this.getGenderImprintLocations(); // Ensure this returns the correct locations array for the active gender/color

            let initalLocationIndex = 0; // Tracks 1st, 2nd, etc., SELECTED location
            let decoration_type = this.activeDecorationService.decoration_type;
            let total_colors = 0; // Total colors across selected locations
            let totalCalculatedDecorationFee = 0; // Total run charge

            // Reset fees for all locations first to avoid stale data
            imprint_locations.forEach((location) => {
                location.decoration_fee = 0;
                location.total_decoration_fee = 0;
                location.total_decor_upcharge = 0;
                if (location.colors && Array.isArray(location.colors)) {
                    location.colors.forEach(
                        (color) => (color.total_decor_upcharge = 0)
                    );
                }
            });

            if (decoration_type == 0) {
                //PCNA RUN CHARGE LOGIC
                // If masterServicePricing is not provided, try to get it from activeDecorationService
                if (!masterServicePricing) {
                    if (this.activeDecorationService.master_service) {
                        masterServicePricing =
                            this.activeDecorationService.master_service;
                    } else {
                        console.error(
                            "calcImprintLocationByGender: masterServicePricing is required for decoration_type 0 and could not be found in activeDecorationService.master_service."
                        );
                        return {
                            total_colors: 0,
                            totalCalculatedDecorationFee: 0
                        };
                    }
                }

                imprint_locations.forEach((location, loc_idx) => {
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from VendorDecorationService for run charge
                            const fullColorValue = parseFloat(
                                masterServicePricing.full_color || 0
                            );
                            let calculatedFeePerItem = 0;

                            if (initalLocationIndex === 0) {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(
                                        masterServicePricing.location_1st || 0
                                    );
                            } else {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(
                                        masterServicePricing.additional_location ||
                                            0
                                    );
                            }

                            location.decoration_fee = calculatedFeePerItem;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;

                            if (total_gender_quantity > 0) {
                                location.total_decoration_fee =
                                    calculatedFeePerItem *
                                    total_gender_quantity;
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee;
                            }

                            total_colors += 1; // Count as 1 for full color
                        } else {
                            const color_count =
                                parseInt(location.no_of_color) || 0;
                            total_colors += color_count;

                            if (color_count > 0 && total_gender_quantity > 0) {
                                let calculatedFeePerItem = 0;
                                // Safely parse fees, default to 0
                                const location1stFee = parseFloat(
                                    masterServicePricing.location_1st || 0
                                );
                                const additionalLocationFee = parseFloat(
                                    masterServicePricing.additional_location ||
                                        0
                                );
                                const costPerColor1st = parseFloat(
                                    masterServicePricing.cost_per_color_1st || 0
                                );
                                const costPerColor2ndOrMore = parseFloat(
                                    masterServicePricing.cost_per_color_2ndormore ||
                                        0
                                );

                                if (initalLocationIndex === 0) {
                                    // First selected location
                                    calculatedFeePerItem =
                                        location1stFee +
                                        color_count * costPerColor1st;
                                } else {
                                    // Additional selected location - admin formula: 1st color = cost_per_color_1st, addl = cost_per_color_2ndormore
                                    calculatedFeePerItem =
                                        additionalLocationFee +
                                        costPerColor1st +
                                        (color_count - 1) *
                                            costPerColor2ndOrMore;
                                }

                                location.decoration_fee = calculatedFeePerItem; // Store per-item fee
                                location.total_decoration_fee =
                                    calculatedFeePerItem *
                                    total_gender_quantity; // Calculate total for this location
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee; // Accumulate
                            } else {
                                location.decoration_fee = 0;
                                location.total_decoration_fee = 0;
                            }
                            location.is_full_color_selected = false;
                        }
                        initalLocationIndex++; // IMPORTANT: Increment *only* for selected locations
                    }
                });
            } else if (decoration_type == 1) {
                imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from decoration service JSON for run charge
                            const fullColorValue = parseFloat(
                                this.activeDecorationService.full_color || 0
                            );
                            let calculatedFeePerItem = 0;

                            if (initalLocationIndex == 0) {
                                // First location - full color value only (no location fee for first location in old logic)
                                calculatedFeePerItem = fullColorValue;
                            } else {
                                // Additional locations - need to get location fee from template
                                let decoration_price = this.getDecorationPrice(
                                    0,
                                    initalLocationIndex
                                );
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(decoration_price || 0);
                            }

                            location.decoration_fee = calculatedFeePerItem;
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_gender_quantity;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;
                            totalCalculatedDecorationFee +=
                                location.total_decoration_fee;
                            total_colors += 1; // Count as 1 for full color
                        } else {
                            let no_of_colors =
                                parseInt(location.no_of_color) || 0;
                            total_colors += no_of_colors;
                            location.total_decor_upcharge = 0;
                            location.colors.forEach((color) => {
                                /* ... upcharge logic ... */
                            });

                            let additional_run_charge_for_location = 0;
                            if (no_of_colors > 0) {
                                let decoration_price_last_color =
                                    this.getDecorationPrice(
                                        no_of_colors - 1,
                                        undefined,
                                        initalLocationIndex > 0
                                    );
                                let decoration_price_first_color =
                                    this.getDecorationPrice(
                                        0,
                                        undefined,
                                        initalLocationIndex > 0
                                    );
                                let additional_color_cost = parseFloat(
                                    (
                                        decoration_price_last_color -
                                        decoration_price_first_color
                                    ).toFixed(2)
                                );

                                if (initalLocationIndex > 0) {
                                    additional_run_charge_for_location =
                                        parseFloat(
                                            (
                                                decoration_price_last_color *
                                                total_gender_quantity
                                            ).toFixed(2)
                                        );
                                } else if (
                                    initalLocationIndex == 0 &&
                                    no_of_colors > 1
                                ) {
                                    additional_run_charge_for_location =
                                        parseFloat(
                                            (
                                                additional_color_cost *
                                                total_gender_quantity
                                            ).toFixed(2)
                                        );
                                }
                            }
                            location.decoration_fee =
                                additional_run_charge_for_location /
                                    total_gender_quantity || 0;
                            location.total_decoration_fee =
                                additional_run_charge_for_location;
                            totalCalculatedDecorationFee = parseFloat(
                                (
                                    totalCalculatedDecorationFee +
                                    additional_run_charge_for_location +
                                    location.total_decor_upcharge
                                ).toFixed(2)
                            );
                            location.is_full_color_selected = false;
                            initalLocationIndex++;
                        }
                    }
                });
            } else if (decoration_type == 2) {
                // Embroidery Logic
                imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from decoration service JSON for run charge
                            const fullColorValue = parseFloat(
                                this.activeDecorationService.full_color || 0
                            );
                            let calculatedFeePerItem = 0;

                            if (initalLocationIndex == 0) {
                                // First location - full color value only (no location fee for first location in old logic)
                                calculatedFeePerItem = fullColorValue;
                            } else {
                                // Additional locations - need to get location fee from template
                                let decoration_price = this.getDecorationPrice(
                                    0,
                                    initalLocationIndex
                                );
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(decoration_price || 0);
                            }

                            location.decoration_fee = calculatedFeePerItem;
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_gender_quantity;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;
                            totalCalculatedDecorationFee +=
                                location.total_decoration_fee;
                            total_colors += 1; // Count as 1 for full color
                        } else {
                            let no_of_colors =
                                parseInt(location.no_of_color) || 0;
                            total_colors += no_of_colors;
                            location.total_decor_upcharge = 0;
                            location.colors.forEach((color) => {
                                /* ... upcharge logic ... */
                            });

                            if (initalLocationIndex == 0) {
                                location.decoration_fee = 0;
                                location.total_decoration_fee = 0;
                            } else {
                                let decoration_price = this.getDecorationPrice(
                                    0,
                                    initalLocationIndex
                                );
                                location.decoration_fee =
                                    parseFloat(decoration_price);
                                location.total_decoration_fee =
                                    parseFloat(location.decoration_fee) *
                                    total_gender_quantity;
                            }
                            location.is_full_color_selected = false;
                            totalCalculatedDecorationFee +=
                                location.total_decoration_fee || 0;
                            totalCalculatedDecorationFee +=
                                location.total_decor_upcharge || 0;
                        }
                        initalLocationIndex++;
                    }
                });
            }
            return { total_colors, totalCalculatedDecorationFee };
        },

        prepareDecorationPrices() {
            let gender = this.genderGroups[this.active_gender_index];
            let price_decoration_bulk = gender.item.price_decoration_bulk;
            // this.imprintcityColors = JSON.parse(
            //     JSON.stringify(this.default_imprint_colors)
            // );
            if (gender.item.decoration_type == 1) {
                let noOfColorsCount = price_decoration_bulk.no_of_colors;
                if (
                    gender.item.PrintTemplate &&
                    gender.item.PrintTemplate.discount_enable
                ) {
                    price_decoration_bulk.print_location1.forEach((row) => {
                        for (let i = 1; i < noOfColorsCount; i++) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }
                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk.print_location1;
                this.decoration_price_template_values =
                    price_decoration_bulk.print_location1;
                this.decoration_price_template_location2 =
                    price_decoration_bulk.print_location2;

                // Added Number of colors for Imprint Locations
                noOfColorsCount = this.colorsCount;
                this.imprintcityColors = [];

                // Check if activeDecorationService has is_full_color set to true
                if (
                    this.activeDecorationService &&
                    this.activeDecorationService.is_full_color === true
                ) {
                    // Show only "1-color" and "Full color" options
                    this.imprintcityColors.push({
                        id: 1,
                        value: "1-color"
                    });
                    this.imprintcityColors.push({
                        id: "full_color",
                        value: "Full color"
                    });
                } else if (noOfColorsCount) {
                    if (noOfColorsCount !== undefined && noOfColorsCount > 0) {
                        for (
                            let noOfColor = 1;
                            noOfColor <= noOfColorsCount;
                            noOfColor++
                        ) {
                            this.imprintcityColors.push({
                                id: parseInt(noOfColor),
                                value: noOfColor + "-colors"
                            });
                        }
                    }
                }
            } else if (gender.item.decoration_type == 2) {
                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk;
                this.decoration_price_template_values = price_decoration_bulk;
            }
        },

        onCollapaseLocationColors(location) {
            /* eslint-disable */
            let index = this.genderGroups[
                this.active_gender_index
            ].imprint_locations.findIndex(
                (location_obj) => location_obj.location == location.location
            );

            if (index === -1) {
                return;
            }

            if (this.index_prev != index) {
                // Close all locations in gender's imprint_locations
                this.genderGroups[
                    this.active_gender_index
                ].imprint_locations.forEach((location_obj) => {
                    this.$set(location_obj, "collapse", false);
                });

                // Also close all locations in each color's imprint_locations
                this.genderGroups[this.active_gender_index].colors.forEach(
                    (color) => {
                        if (
                            color.imprint_locations &&
                            Array.isArray(color.imprint_locations)
                        ) {
                            color.imprint_locations.forEach((location_obj) => {
                                this.$set(location_obj, "collapse", false);
                            });
                        }
                    }
                );
            }

            const currentLocation =
                this.genderGroups[this.active_gender_index].imprint_locations[
                    index
                ];
            const currentCollapseState = currentLocation.collapse === true;
            const newCollapseState = !currentCollapseState;

            // Update gender's imprint_locations
            this.$set(currentLocation, "collapse", newCollapseState);

            // Also update in all color's imprint_locations to keep them in sync
            this.genderGroups[this.active_gender_index].colors.forEach(
                (color) => {
                    if (
                        color.imprint_locations &&
                        Array.isArray(color.imprint_locations) &&
                        color.imprint_locations[index]
                    ) {
                        this.$set(
                            color.imprint_locations[index],
                            "collapse",
                            newCollapseState
                        );
                    }
                }
            );

            this.index_prev = index;
            this.$forceUpdate();
            /* eslint-enable */
        },
        isColorExpanded(colorId) {
            // Check if a specific color's drawer is expanded
            return this.colorSectionExpanded[colorId] === true;
        },
        toggleColorSection(colorId) {
            // Toggle the expanded state for a specific color
            // Close all other colors when opening one
            if (!this.isColorExpanded(colorId)) {
                // Close all colors first
                this.colorSectionExpanded = {};
                // Then open the selected color
                this.$set(this.colorSectionExpanded, colorId, true);
            } else {
                // Close the selected color
                this.$set(this.colorSectionExpanded, colorId, false);
            }
        },
        deleteColor(colorId) {
            // Do not allow deleting the last remaining color
            const group = this.genderGroups[this.active_gender_index];
            const colors = group && group.colors ? group.colors : [];
            if (colors.length <= 1) {
                this.$toast.error(
                    "At least one color is required. Cannot delete the last color.",
                    { position: "top-right" }
                );
                return;
            }
            if (
                colorId !== undefined &&
                colorId !== null &&
                this.genderGroups[this.active_gender_index]
            ) {
                // Find color by id or by index
                let colorIndex = -1;
                if (
                    typeof colorId === "number" &&
                    colorId <
                        this.genderGroups[this.active_gender_index].colors
                            .length
                ) {
                    // If colorId is a number and within bounds, treat it as index
                    colorIndex = colorId;
                } else {
                    // Otherwise, find by id
                    colorIndex = this.genderGroups[
                        this.active_gender_index
                    ].colors.findIndex((color) => color.id === colorId);
                }

                if (colorIndex !== -1) {
                    const colorsArray =
                        this.genderGroups[this.active_gender_index].colors;
                    const newColors = colorsArray.filter(
                        (_, idx) => idx !== colorIndex
                    );
                    this.$delete(this.colorSectionExpanded, colorId);
                    if (newColors.length > 0) {
                        const firstColor = newColors[0];
                        const firstColorId = firstColor.id || 0;
                        this.$set(
                            this.colorSectionExpanded,
                            firstColorId,
                            true
                        );
                        this.picked_color = firstColor;
                    } else {
                        this.picked_color = null;
                    }
                    this.$emit("color-deleted", {
                        genderIndex: this.active_gender_index,
                        colors: newColors
                    });
                    this.$nextTick(() => {
                        this.calculatePricing(this.active_gender_index);
                    });
                }
            }
        },

        getTotalItemQuantity(gender_element) {
            let total_quantity = 0;
            if (
                gender_element &&
                gender_element.colors &&
                Array.isArray(gender_element.colors)
            ) {
                gender_element.colors.forEach((color) => {
                    if (
                        color.unique_sizes &&
                        Array.isArray(color.unique_sizes)
                    ) {
                        color.unique_sizes.forEach((size) => {
                            if (size.quantity && parseInt(size.quantity) > 0) {
                                total_quantity += parseInt(size.quantity);
                            }
                        });
                    }
                });
            }
            return total_quantity;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        // Get size cost with discount applied if activeProductDiscount exists
        getSizeCostWithDiscount(originalCost) {
            if (!originalCost || originalCost <= 0) {
                return originalCost;
            }

            const activeDiscount = this.activeProductDiscount;
            if (!activeDiscount || !activeDiscount.status) {
                return originalCost;
            }

            const discountType = activeDiscount.discount_type;
            const discountValue = parseFloat(
                activeDiscount.discount_value || 0
            );

            if (discountType === "Percent") {
                return parseFloat(
                    (originalCost * (1 - discountValue / 100)).toFixed(2)
                );
            } else {
                // Fixed amount discount
                return parseFloat(
                    Math.max(0, originalCost - discountValue).toFixed(2)
                );
            }
        },

        getDecorationPrice(
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;
            if (
                this.active_gender_index < 0 ||
                this.active_gender_index >= this.genderGroups.length
            ) {
                return 0;
            }
            let genderGroup = this.genderGroups[this.active_gender_index];
            if (
                !genderGroup ||
                !genderGroup.item ||
                !this.activeDecorationService
            ) {
                return 0;
            }

            let total_qty_gender_wise =
                this.getTotalItemQuantity(genderGroup) + this.cartQuantity;

            let productData = genderGroup.item; // Keep for fallback? Or rely solely on activeService?
            let price_decoration_bulk_data =
                this.activeDecorationService.price_decoration_bulk; // Use data from active service

            // Decoration type comes from active service now
            let decoration_type = this.activeDecorationService.decoration_type;

            if (!price_decoration_bulk_data) {
                return 0;
            }

            // PCNA (decoration_type == 0) uses master_service pricing, not price_decoration_bulk
            if (decoration_type == 0) {
                return 0;
            }

            if (decoration_type == 1) {
                // Print
                let decoration_data;
                // Check structure within activeService's bulk price data
                if (
                    !price_decoration_bulk_data ||
                    !price_decoration_bulk_data.print_location1 ||
                    !price_decoration_bulk_data.print_location2
                ) {
                    console.error(
                        "Print price data structure missing in activeService.price_decoration_bulk:",
                        price_decoration_bulk_data
                    );
                    return 0;
                }

                decoration_data = !additional
                    ? price_decoration_bulk_data.print_location1
                    : price_decoration_bulk_data.print_location2;

                if (Array.isArray(decoration_data)) {
                    let foundPrice = false;
                    for (let i = decoration_data.length - 1; i >= 0; i--) {
                        const element = decoration_data[i];
                        if (
                            element &&
                            element.quantity !== undefined &&
                            element[`colour${colorIndex + 1}`] !== undefined
                        ) {
                            if (
                                parseInt(element.quantity) <=
                                parseInt(total_qty_gender_wise)
                            ) {
                                qty_wise_color_price =
                                    element[`colour${colorIndex + 1}`];
                                foundPrice = true;
                                break;
                            }
                        } else {
                            console.warn(
                                "Skipping malformed print price tier:",
                                element
                            );
                        }
                    }
                    if (
                        !foundPrice &&
                        decoration_data.length > 0 &&
                        decoration_data[0] &&
                        decoration_data[0][`colour${colorIndex + 1}`] !==
                            undefined
                    ) {
                        qty_wise_color_price =
                            decoration_data[0][`colour${colorIndex + 1}`];
                    } else if (!foundPrice) {
                        qty_wise_color_price = 0;
                    }
                } else {
                    return 0;
                }
            } else if (decoration_type == 2) {
                // Embroidery
                // Assuming price_decoration_bulk is the array of tiers directly for embroidery
                let decoration_data = price_decoration_bulk_data;
                if (Array.isArray(decoration_data)) {
                    let foundPrice = false;
                    for (let i = decoration_data.length - 1; i >= 0; i--) {
                        const element = decoration_data[i];
                        if (element && element.quantity1 !== undefined) {
                            // Check embroidery quantity key
                            if (
                                parseInt(element.quantity1) <=
                                parseInt(total_qty_gender_wise)
                            ) {
                                if (
                                    locationIndex !== undefined &&
                                    locationIndex > 0
                                ) {
                                    // Get price for additional location
                                    qty_wise_color_price =
                                        element[
                                            `location${locationIndex + 1}`
                                        ] !== undefined
                                            ? element[
                                                  `location${locationIndex + 1}`
                                              ]
                                            : element["cost"] !== undefined
                                            ? element["cost"]
                                            : 0; // Fallback to base cost
                                } else {
                                    // Get base cost for first location
                                    qty_wise_color_price =
                                        element["cost"] !== undefined
                                            ? element["cost"]
                                            : 0;
                                }
                                foundPrice = true;
                                break;
                            }
                        } else {
                            console.warn(
                                "Skipping malformed embroidery price tier:",
                                element
                            );
                        }
                    }
                    // Fallback to first tier
                    if (
                        !foundPrice &&
                        decoration_data.length > 0 &&
                        decoration_data[0]
                    ) {
                        const firstElement = decoration_data[0];
                        if (locationIndex !== undefined && locationIndex > 0) {
                            qty_wise_color_price =
                                firstElement[`location${locationIndex + 1}`] !==
                                undefined
                                    ? firstElement[
                                          `location${locationIndex + 1}`
                                      ]
                                    : firstElement["cost"] !== undefined
                                    ? firstElement["cost"]
                                    : 0;
                        } else {
                            qty_wise_color_price =
                                firstElement["cost"] !== undefined
                                    ? firstElement["cost"]
                                    : 0;
                        }
                    } else if (!foundPrice) {
                        qty_wise_color_price = 0;
                    }
                } else {
                    return 0;
                }
            } else {
                return 0;
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(additional = false) {
            let discount = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.genderGroups[this.active_gender_index]
            );
            let productData = this.genderGroups[this.active_gender_index].item;

            // PCNA (decoration_type == 0) doesn't use this discount structure
            if (productData.decoration_type == 0) {
                return 0;
            }

            if (productData.decoration_type == 1) {
                let decoration_data;

                if (!productData.price_decoration_bulk) {
                    return 0;
                }

                if (!additional) {
                    decoration_data =
                        productData.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        productData.price_decoration_bulk.print_location2;
                }

                if (!decoration_data || !Array.isArray(decoration_data)) {
                    return 0;
                }

                let total_group_quantity = parseInt(total_qty_gender_wise);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            } else if (productData.decoration_type == 2) {
                if (!productData.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data = productData.price_decoration_bulk;
                if (!decoration_data || !Array.isArray(decoration_data)) {
                    return 0;
                }
                let total_group_quantity = parseInt(total_qty_gender_wise);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        // Inside ItemDetails.vue methods
        calculatePricing(index, size, event = null) {
            const _this = this;

            //Check active service
            if (!_this.activeDecorationService) {
                console.error(
                    "calculatePricing: activeDecorationService is missing."
                );
                _this.$toast.error(`Decoration service not selected.`, {
                    position: "top-right",
                    queue: true
                });
                return;
            }

            //Get decoration_type from active service
            const decorationType =
                _this.activeDecorationService.decoration_type;

            //Call relevant pricing function based on decoration_type
            switch (decorationType) {
                case 0: // PCNA Type
                    if (typeof _this.calculatePCNAPricing === "function") {
                        _this.calculatePCNAPricing(index); // Call the dedicated PCNA function
                    } else {
                        console.error(
                            "calculatePCNAPricing function is not defined"
                        );
                    }
                    break;
                case 1: // Print
                    if (typeof _this.calculatePrintPricing === "function") {
                        _this.calculatePrintPricing(index);
                    } else {
                        console.error(
                            "calculatePrintPricing function is not defined"
                        );
                    }
                    break;
                case 2: // Embroidery
                    if (
                        typeof _this.calculateEmbroideryPricing === "function"
                    ) {
                        _this.calculateEmbroideryPricing(index);
                    } else {
                        console.error(
                            "calculateEmbroideryPricing function is not defined"
                        );
                    }
                    break;
                // Add other cases like case 3: if needed
                default:
                    console.warn(
                        `calculatePricing: Unknown decoration type: ${decorationType}`
                    );
                    _this.$toast.error(
                        `Unsupported decoration type: ${decorationType}`,
                        { position: "top-right", queue: true }
                    );
            }

            // Emit event after calculation (if needed)
            this.$emit("updateNameAndNumbers");
        },

        /**
         * Sum of Patch-related services (rollup_fee_id = 9, same as service_id 9 for Patch).
         * Only included in total when patch is present; same pattern as Run Charge rollup.
         * @param {number} [quantity] - Optional quantity (defaults to active gender total_qty)
         */
        getPatchAdditionalServicesTotal(quantity) {
            const services = this.mergedOtherServices || [];
            const qty =
                quantity != null
                    ? quantity
                    : this.genderGroups && this.genderGroups[this.active_gender_index]
                        ? parseInt(this.genderGroups[this.active_gender_index].total_qty, 10) || 0
                        : 0;
            let total = 0;
            services.forEach((service) => {
                const rollup = service.rollup_service || {};
                const feeId =
                    rollup.rollup_fee_id != null
                        ? rollup.rollup_fee_id
                        : service.rollup_fee_id;
                if (feeId !== 9) return;
                const cost = parseFloat(service.retail_cost) || 0;
                const isPerItem =
                    service.fee_structure === "Per Item" ||
                    (rollup.fee_structure_name === "Per Item");
                total += isPerItem ? cost * qty : cost;
            });
            return parseFloat(total.toFixed(2));
        },
        /**
         * Update only patch-related fields in currentBreakdown and recompute total.
         * Keeps existing Run Charge, Setup, Design etc. intact (persists position/values).
         * Call this when only patch list changes (add/remove patch) instead of full calculatePricing.
         */
        updatePatchInBreakdown() {
            const patchCostVal = parseFloat(this.patchCost) || 0;
            const prevPatchCost = parseFloat(this.currentBreakdown.patchCost) || 0;
            const prevPatchAdditional =
                parseFloat(this.currentBreakdown.patchAdditionalServicesTotal) || 0;
            const totalWithoutPatch =
                parseFloat(this.currentBreakdown.totalCost) -
                prevPatchCost -
                prevPatchAdditional;
            const newPatchAdditional = this.getPatchAdditionalServicesTotal();
            const newTotalCost = parseFloat(
                (
                    totalWithoutPatch +
                    patchCostVal +
                    newPatchAdditional
                ).toFixed(2)
            );
            this.currentBreakdown = {
                ...this.currentBreakdown,
                patchCost: patchCostVal,
                patchSlabQuantity: this.patchSlabQuantity || 0,
                patchCostDetails: Array.isArray(this.patchCostDetails)
                    ? this.patchCostDetails
                    : [],
                patchAdditionalServicesTotal: newPatchAdditional,
                totalCost: newTotalCost
            };
            this.$nextTick(() => this.$forceUpdate());
        },

        calculatePCNAPricing(index) {
            //Validations
            if (
                index === undefined ||
                index < 0 ||
                !this.genderGroups ||
                index >= this.genderGroups.length ||
                !this.activeDecorationService ||
                !this.activeDecorationService.price_decoration_bulk ||
                !this.activeDecorationService.master_service
            ) {
                console.error(
                    "PCNA Pricing ERROR: Invalid index, data, or missing activeDecorationService/price_decoration_bulk/master_service:",
                    index,
                    this.activeDecorationService
                );
                this.$toast.error(
                    "Error: Missing required data for calculation.",
                    { position: "top-right" }
                );
                return;
            }

            let gender_element = this.genderGroups[index];
            const priceData =
                this.activeDecorationService.price_decoration_bulk;
            const masterServicePricing =
                this.activeDecorationService.master_service;

            //Reset Gender Totals
            gender_element.total_qty = 0;
            gender_element.subtotal = 0; // Base cost of items
            gender_element.total_cost = 0; // Final total
            gender_element.total_discount_value = 0; // Promotional discount
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0; // Run charges
            gender_element.total_setup_fee = 0; // Setup fee
            gender_element.total_decoration_colors = 0; // Reset total colors count
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_left_name_fees = 0;
            gender_element.total_left_number_fees = 0;
            gender_element.total_right_name_fees = 0;
            gender_element.total_right_number_fees = 0;
            gender_element.total_front_number_decor_up_fees = 0;
            gender_element.total_front_name_decor_up_fees = 0;
            gender_element.total_back_name_decor_up_fees = 0;
            gender_element.total_back_number_decor_up_fees = 0;
            gender_element.total_left_name_decor_up_fees = 0;
            gender_element.total_left_number_decor_up_fees = 0;
            gender_element.total_right_name_decor_up_fees = 0;
            gender_element.total_right_number_decor_up_fees = 0;
            gender_element.total_non_standard_fees = 0;

            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);

            //Find Pricing Tier for Base Item Cost
            let found_tier = null;
            if (Array.isArray(priceData) && priceData.length > 0) {
                // Iterate backwards to find the highest applicable tier
                for (let i = priceData.length - 1; i >= 0; i--) {
                    const tier = priceData[i];
                    if (
                        tier &&
                        tier.quantity !== undefined &&
                        parseInt(tier.quantity) <= total_group_quantity
                    ) {
                        found_tier = tier;
                        break;
                    }
                }
                // If quantity is below the lowest tier, use the first tier
                if (!found_tier) {
                    found_tier = priceData[0];
                }
            }

            if (
                !found_tier ||
                found_tier.retail_cost === undefined ||
                found_tier.retail_cost === null
            ) {
                console.error(
                    " -> PCNA Pricing ERROR: Could not determine valid pricing tier or retail_cost missing.",
                    found_tier
                );
                this.$toast.error("Error determining base item price.", {
                    position: "top-right"
                });
                return;
            }
            let tier_retail_cost = parseFloat(found_tier.retail_cost);

            //Calculate Subtotal (Base Item Costs) and aggregate name/number fees
            gender_element.colors.forEach((color) => {
                color.total_qty_gender_wise = 0;
                color.subtotal = 0;
                color.total_cost_gender_wise = 0; // Reset color specific cost

                // Update non_standard_fee for custom colors in PCNA case
                if (
                    color.imprint_locations &&
                    Array.isArray(color.imprint_locations)
                ) {
                    color.imprint_locations.forEach((location) => {
                        if (location.colors && Array.isArray(location.colors)) {
                            location.colors.forEach((colorObj) => {
                                if (
                                    colorObj.color &&
                                    colorObj.color.color_id == 0
                                ) {
                                    // It's a custom color, set non_standard_fee if not already set
                                    if (
                                        !colorObj.color.non_standard_fee ||
                                        colorObj.color.non_standard_fee === 0
                                    ) {
                                        let feePerColor =
                                            this.getPCNAFeePerColor();
                                        if (feePerColor > 0) {
                                            colorObj.color.non_standard_fee =
                                                feePerColor;
                                        }
                                    }
                                }
                            });
                        }
                    });
                }

                color.unique_sizes.forEach((size) => {
                    size.cost = tier_retail_cost; // Apply tier cost
                    // Reset others just in case
                    size.markup_price = 0;
                    size.ink_price = 0;
                    size.single_location_price = 0;
                    size.decoration_discount_percentage = 0;

                    const quantity = parseInt(size.quantity || 0);
                    size.total_cost = quantity > 0 ? size.cost * quantity : 0; // Base cost for this size * qty

                    if (quantity > 0) {
                        color.total_qty_gender_wise += quantity;
                        color.subtotal += size.total_cost; // Add base cost to color's subtotal
                    }
                });
                color.total_cost_gender_wise = color.subtotal; // Color total starts as its subtotal

                // Aggregate design fee from colors
                gender_element.total_design_fee += parseFloat(
                    color.total_design_fee || 0
                );
                // Note: Name and number fees are now calculated from VendorOtherServices below

                // Aggregate name and number decor up fees from colors (for PCNA)
                gender_element.total_front_number_decor_up_fees += parseFloat(
                    color.front_number_decor_up_fees || 0
                );
                gender_element.total_front_name_decor_up_fees += parseFloat(
                    color.front_name_decor_up_fees || 0
                );
                gender_element.total_back_name_decor_up_fees += parseFloat(
                    color.back_name_decor_up_fees || 0
                );
                gender_element.total_back_number_decor_up_fees += parseFloat(
                    color.back_number_decor_up_fees || 0
                );
                gender_element.total_left_name_decor_up_fees += parseFloat(
                    color.left_name_decor_up_fees || 0
                );
                gender_element.total_left_number_decor_up_fees += parseFloat(
                    color.left_number_decor_up_fees || 0
                );
                gender_element.total_right_name_decor_up_fees += parseFloat(
                    color.right_name_decor_up_fees || 0
                );
                gender_element.total_right_number_decor_up_fees += parseFloat(
                    color.right_number_decor_up_fees || 0
                );

                // Aggregate up
                gender_element.total_qty += color.total_qty_gender_wise;
                gender_element.subtotal += color.subtotal; // Add color's base cost subtotal to gender's base cost subtotal
            });

            const runChargeResult =
                this.calcImprintLocationByGender(masterServicePricing);
            let locationRunCharge = parseFloat(
                runChargeResult.totalCalculatedDecorationFee || 0
            ); // Store run charges
            gender_element.total_decoration_colors =
                runChargeResult.total_colors; // Store total colors used

            // Initialize detailsForRunCharge array for tooltip breakdown
            let detailsForRunCharge = [];

            // Add location run charge to total_color_fee and details
            if (locationRunCharge > 0) {
                gender_element.total_color_fee += locationRunCharge;
                detailsForRunCharge.push({
                    name: "Location(s) Run Charge",
                    value: parseFloat(locationRunCharge.toFixed(2))
                });
            }

            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        // Multiply by quantity if it's 'Per Item'
                        return total + cost * total_group_quantity;
                    } else {
                        // Otherwise, just add the flat fee
                        return total + cost;
                    }
                },
                0
            );

            // Calculate Setup Fee
            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;
            // Only calculate if quantity > 0 AND colors are selected
            if (
                total_group_quantity > 0 &&
                gender_element.total_decoration_colors > 0
            ) {
                const feeStructure = masterServicePricing.fee_structure; // e.g., "1" or "2"
                const setupFeeColor1 = parseFloat(
                    masterServicePricing.setup_fee_color1 || 0
                );
                const setupFeeMulticolor = parseFloat(
                    masterServicePricing.setup_fee_multicolor || 0
                );

                if (feeStructure == "1") {
                    // Per Color
                    this.setup_fee =
                        setupFeeColor1 * gender_element.total_decoration_colors;
                } else if (feeStructure == "2") {
                    // Tiered
                    if (gender_element.total_decoration_colors === 1) {
                        this.setup_fee = setupFeeColor1;
                    } else if (gender_element.total_decoration_colors > 1) {
                        this.setup_fee = setupFeeMulticolor;
                    }
                } else {
                    console.warn(
                        " -> PCNA Pricing WARNING: Unknown setup fee structure:",
                        feeStructure
                    );
                }
                gender_element.total_setup_fee = this.setup_fee;
                if (this.setup_fee > 0) {
                    this.setup_fee_applied_gender_index = index; // Track which gender got the fee
                }
            } else {
                gender_element.total_setup_fee = 0; // No setup fee if no quantity or no colors selected
            }

            // Vendor Color Upcharges - Specialty Colors (stock = true AND upcharge > 0)
            let vendorColorUpcharge = 0;
            let customColorUpcharge = 0;
            if (this.allDecorationColors && total_group_quantity > 0) {
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes) {
                        colorHexCodes.forEach((hexCode) => {
                            if (!hexCode) return;
                            const vendorColor = this.vendorColors.find(
                                (color) =>
                                    color.color_value &&
                                    color.color_value.toLowerCase() ===
                                        (typeof hexCode === "string"
                                            ? hexCode.toLowerCase()
                                            : hexCode.hex
                                            ? hexCode.hex.toLowerCase()
                                            : "")
                            );
                            if (vendorColor && vendorColor.decor_upcharge) {
                                const upcharge = parseFloat(
                                    vendorColor.decor_upcharge || 0
                                );
                                const stock =
                                    vendorColor.stock === true ||
                                    vendorColor.stock === 1;

                                if (upcharge > 0) {
                                    if (stock) {
                                        // Specialty Color: stock = true AND upcharge > 0
                                        vendorColorUpcharge +=
                                            upcharge *
                                            parseInt(total_group_quantity);
                                    } else {
                                        // Custom Color: stock = false AND upcharge > 0
                                        customColorUpcharge +=
                                            upcharge *
                                            parseInt(total_group_quantity);
                                    }
                                }
                            }
                        });
                    }
                }
            }
            if (vendorColorUpcharge > 0) {
                vendorColorUpcharge = parseFloat(
                    vendorColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += vendorColorUpcharge;
                detailsForRunCharge.push({
                    name: "Specialty Color",
                    value: vendorColorUpcharge
                });
            }

            // Custom Colors (stock = false AND upcharge > 0)
            if (customColorUpcharge > 0) {
                customColorUpcharge = parseFloat(
                    customColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += customColorUpcharge;
                detailsForRunCharge.push({
                    name: "Custom Color",
                    value: customColorUpcharge
                });
            }

            // Mix Color Fee calculation - Get from VendorOtherServices
            const activeService = this.activeDecorationService;
            const serviceName = activeService
                ? (activeService.name || "").toLowerCase()
                : "";
            const decorationType =
                activeService && activeService.master_service
                    ? activeService.master_service.decoration_type
                    : null;

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decorationType,
                serviceName
            );

            // Get unique non-standard color count
            let uniqueNonStandardColorCount =
                this.getUniqueNonStandardColorCount();

            // Calculate mix fee: unique non-standard color count × fee per color (NO quantity multiplication)
            let calculatedMixFee = 0;
            if (
                colorMixFeePerColor !== null &&
                uniqueNonStandardColorCount > 0
            ) {
                calculatedMixFee =
                    uniqueNonStandardColorCount * colorMixFeePerColor;
            }

            gender_element.total_non_standard_fees = calculatedMixFee;
            if (gender_element.total_non_standard_fees > 0) {
                // Ensure mix fee is properly added to total_color_fee
                const mixFeeToAdd = parseFloat(
                    gender_element.total_non_standard_fees.toFixed(2)
                );
                gender_element.total_color_fee += mixFeeToAdd;

                // Get mix color count and unit price for display
                let mixColorCount = uniqueNonStandardColorCount;
                let feePerColor = colorMixFeePerColor || 0;

                // Determine mix fee label based on decoration type or service name
                const isEmbroideryService = serviceName.includes("embroidery");
                const mixFeeLabel =
                    decorationType == 2 || isEmbroideryService
                        ? "Custom Color Thread Fee"
                        : "Custom Color Ink Fee";

                detailsForRunCharge.push({
                    name: mixFeeLabel,
                    value: mixFeeToAdd,
                    mixColorCount: mixColorCount,
                    unitPrice: feePerColor,
                    quantity: total_group_quantity
                });
            }

            // Name and Number Fees - Get from VendorOtherServices
            // Only apply if front/back has decorations, calculate based on actual name/number count per location
            const nameFeePerItem = this.getNameFeeFromVendorServices();
            const numberFeePerItem = this.getNumberFeeFromVendorServices();

            // Initialize fees to 0
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_left_name_fees = 0;
            gender_element.total_left_number_fees = 0;
            gender_element.total_right_name_fees = 0;
            gender_element.total_right_number_fees = 0;

            // Initialize color-level fees to 0
            gender_element.colors.forEach((color) => {
                color.front_number_fees = 0;
                color.front_name_fees = 0;
                color.back_name_fees = 0;
                color.back_number_fees = 0;
                color.left_name_fees = 0;
                color.left_number_fees = 0;
                color.right_name_fees = 0;
                color.right_number_fees = 0;
            });

            // Count actual names and numbers per location (front, back, left, right) - separate counts
            const {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount,
                leftNameCount,
                leftNumberCount,
                rightNameCount,
                rightNumberCount
            } = this.countNamesAndNumbersByLocation(this.active_gender_index);

            // Check which imprint locations have decorations
            const { hasFront, hasBack, hasLeft, hasRight } =
                this.hasFrontOrBackDecoration(this.active_gender_index);

            // Only calculate fees if there are actual names/numbers added (count > 0)
            if (
                frontNameCount > 0 ||
                backNameCount > 0 ||
                frontNumberCount > 0 ||
                backNumberCount > 0 ||
                leftNameCount > 0 ||
                leftNumberCount > 0 ||
                rightNameCount > 0 ||
                rightNumberCount > 0
            ) {
                // Front name fee
                if (nameFeePerItem !== null && frontNameCount > 0 && hasFront) {
                    gender_element.total_front_name_fees =
                        frontNameCount * nameFeePerItem;
                    if (gender_element.total_front_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_front_name_fees;
                        detailsForRunCharge.push({
                            name: "Front Name Fee",
                            value: parseFloat(
                                gender_element.total_front_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: frontNameCount
                        });
                    }
                }

                // Back name fee
                if (nameFeePerItem !== null && backNameCount > 0 && hasBack) {
                    gender_element.total_back_name_fees =
                        backNameCount * nameFeePerItem;
                    if (gender_element.total_back_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_back_name_fees;
                        detailsForRunCharge.push({
                            name: "Back Name Fee",
                            value: parseFloat(
                                gender_element.total_back_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: backNameCount
                        });
                    }
                }

                // Left name fee - separate row in run charge breakdown
                if (nameFeePerItem !== null && leftNameCount > 0 && hasLeft) {
                    gender_element.total_left_name_fees =
                        leftNameCount * nameFeePerItem;
                    if (gender_element.total_left_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_left_name_fees;
                        detailsForRunCharge.push({
                            name: "Left Name Fee",
                            value: parseFloat(
                                gender_element.total_left_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: leftNameCount
                        });
                    }
                }

                // Right name fee - separate row in run charge breakdown
                if (nameFeePerItem !== null && rightNameCount > 0 && hasRight) {
                    gender_element.total_right_name_fees =
                        rightNameCount * nameFeePerItem;
                    if (gender_element.total_right_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_right_name_fees;
                        detailsForRunCharge.push({
                            name: "Right Name Fee",
                            value: parseFloat(
                                gender_element.total_right_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: rightNameCount
                        });
                    }
                }

                // Calculate number fees per location (front, back, left, right)
                if (numberFeePerItem !== null) {
                    // Front number fee
                    if (frontNumberCount > 0 && hasFront) {
                        gender_element.total_front_number_fees =
                            frontNumberCount * numberFeePerItem;
                        if (gender_element.total_front_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_front_number_fees;
                            detailsForRunCharge.push({
                                name: "Front Number Fee",
                                value: parseFloat(
                                    gender_element.total_front_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: frontNumberCount
                            });
                        }
                    }

                    // Back number fee - only if numbers are added for back
                    if (backNumberCount > 0 && hasBack) {
                        gender_element.total_back_number_fees =
                            backNumberCount * numberFeePerItem;
                        if (gender_element.total_back_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_back_number_fees;
                            detailsForRunCharge.push({
                                name: "Back Number Fee",
                                value: parseFloat(
                                    gender_element.total_back_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: backNumberCount
                            });
                        }
                        // Update color.back_number_fees for each color individually
                        gender_element.colors.forEach((color) => {
                            if (
                                color.name_and_number_json &&
                                Array.isArray(color.name_and_number_json)
                            ) {
                                const nameAndNumbers =
                                    color.name_and_number_json.filter(
                                        (nn) =>
                                            nn.number !== null &&
                                            nn.number !== undefined &&
                                            nn.number.toString().trim() !== ""
                                    );
                                const selectedNameNumber =
                                    color.selected_name_number || {};
                                const backSelected =
                                    selectedNameNumber.back || {};
                                if (backSelected.number === true) {
                                    const colorBackNumberCount =
                                        nameAndNumbers.length;
                                    color.back_number_fees =
                                        colorBackNumberCount * numberFeePerItem;
                                }
                            }
                        });
                    }

                    // Left number fee - separate row in run charge breakdown
                    if (leftNumberCount > 0 && hasLeft) {
                        gender_element.total_left_number_fees =
                            leftNumberCount * numberFeePerItem;
                        if (gender_element.total_left_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_left_number_fees;
                            detailsForRunCharge.push({
                                name: "Left Number Fee",
                                value: parseFloat(
                                    gender_element.total_left_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: leftNumberCount
                            });
                        }
                    }

                    // Right number fee - separate row in run charge breakdown
                    if (rightNumberCount > 0 && hasRight) {
                        gender_element.total_right_number_fees =
                            rightNumberCount * numberFeePerItem;
                        if (gender_element.total_right_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_right_number_fees;
                            detailsForRunCharge.push({
                                name: "Right Number Fee",
                                value: parseFloat(
                                    gender_element.total_right_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: rightNumberCount
                            });
                        }
                    }
                }
                // Update color.front_number_fees and color.back_name_fees for each color individually
                gender_element.colors.forEach((color) => {
                    if (
                        color.name_and_number_json &&
                        Array.isArray(color.name_and_number_json)
                    ) {
                        // Front number fees
                        if (
                            numberFeePerItem !== null &&
                            frontNumberCount > 0 &&
                            hasFront
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.number !== null &&
                                        nn.number !== undefined &&
                                        nn.number.toString().trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.number === true) {
                                const colorFrontNumberCount =
                                    nameAndNumbers.length;
                                color.front_number_fees =
                                    colorFrontNumberCount * numberFeePerItem;
                            }
                        }
                        // Front name fees
                        if (
                            nameFeePerItem !== null &&
                            frontNameCount > 0 &&
                            hasFront
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.name &&
                                        typeof nn.name === "string" &&
                                        nn.name.trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.name === true) {
                                const colorFrontNameCount =
                                    nameAndNumbers.length;
                                color.front_name_fees =
                                    colorFrontNameCount * nameFeePerItem;
                            }
                        }
                        // Back name fees
                        if (
                            nameFeePerItem !== null &&
                            backNameCount > 0 &&
                            hasBack
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.name &&
                                        typeof nn.name === "string" &&
                                        nn.name.trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.name === true) {
                                const colorBackNameCount =
                                    nameAndNumbers.length;
                                color.back_name_fees =
                                    colorBackNameCount * nameFeePerItem;
                            }
                        }
                    } else if (
                        color.name_and_number_json &&
                        typeof color.name_and_number_json === "object"
                    ) {
                        const nnJson = color.name_and_number_json;
                        const selectedNameNumber =
                            color.selected_name_number || {};
                        // Front name (object format)
                        if (
                            nameFeePerItem !== null &&
                            frontNameCount > 0 &&
                            hasFront &&
                            nnJson.front &&
                            Array.isArray(nnJson.front)
                        ) {
                            const frontNames = nnJson.front.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.name === true) {
                                color.front_name_fees =
                                    frontNames.length * nameFeePerItem;
                            }
                        }
                        // Front number (object format)
                        if (
                            numberFeePerItem !== null &&
                            frontNumberCount > 0 &&
                            hasFront &&
                            nnJson.front &&
                            Array.isArray(nnJson.front)
                        ) {
                            const frontNumbers = nnJson.front.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.number === true) {
                                color.front_number_fees =
                                    frontNumbers.length * numberFeePerItem;
                            }
                        }
                        // Back name (object format)
                        if (
                            nameFeePerItem !== null &&
                            backNameCount > 0 &&
                            hasBack &&
                            nnJson.back &&
                            Array.isArray(nnJson.back)
                        ) {
                            const backNames = nnJson.back.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.name === true) {
                                color.back_name_fees =
                                    backNames.length * nameFeePerItem;
                            }
                        }
                        // Back number (object format)
                        if (
                            numberFeePerItem !== null &&
                            backNumberCount > 0 &&
                            hasBack &&
                            nnJson.back &&
                            Array.isArray(nnJson.back)
                        ) {
                            const backNumbers = nnJson.back.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.number === true) {
                                color.back_number_fees =
                                    backNumbers.length * numberFeePerItem;
                            }
                        }
                        if (
                            nameFeePerItem !== null &&
                            leftNameCount > 0 &&
                            hasLeft &&
                            nnJson.left &&
                            Array.isArray(nnJson.left)
                        ) {
                            const leftNames = nnJson.left.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const leftSelected = selectedNameNumber.left || {};
                            if (leftSelected.name === true) {
                                color.left_name_fees =
                                    leftNames.length * nameFeePerItem;
                            }
                        }
                        if (
                            numberFeePerItem !== null &&
                            leftNumberCount > 0 &&
                            hasLeft &&
                            nnJson.left &&
                            Array.isArray(nnJson.left)
                        ) {
                            const leftNumbers = nnJson.left.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const leftSelected = selectedNameNumber.left || {};
                            if (leftSelected.number === true) {
                                color.left_number_fees =
                                    leftNumbers.length * numberFeePerItem;
                            }
                        }
                        if (
                            nameFeePerItem !== null &&
                            rightNameCount > 0 &&
                            hasRight &&
                            nnJson.right &&
                            Array.isArray(nnJson.right)
                        ) {
                            const rightNames = nnJson.right.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const rightSelected =
                                selectedNameNumber.right || {};
                            if (rightSelected.name === true) {
                                color.right_name_fees =
                                    rightNames.length * nameFeePerItem;
                            }
                        }
                        if (
                            numberFeePerItem !== null &&
                            rightNumberCount > 0 &&
                            hasRight &&
                            nnJson.right &&
                            Array.isArray(nnJson.right)
                        ) {
                            const rightNumbers = nnJson.right.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const rightSelected =
                                selectedNameNumber.right || {};
                            if (rightSelected.number === true) {
                                color.right_number_fees =
                                    rightNumbers.length * numberFeePerItem;
                            }
                        }
                    }
                });
            } else {
                // Reset fees to 0 if no names/numbers
                gender_element.colors.forEach((color) => {
                    color.front_number_fees = 0;
                    color.front_name_fees = 0;
                    color.back_name_fees = 0;
                    color.back_number_fees = 0;
                    color.left_name_fees = 0;
                    color.left_number_fees = 0;
                    color.right_name_fees = 0;
                    color.right_number_fees = 0;
                });
            }

            // Front Number Decor Up Fee
            if (gender_element.total_front_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_number_decor_up_fees;

                // Get quantity from Front Number Fee (number of front numbers)
                const frontNumberFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("front number fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantity = frontNumberFee
                    ? parseFloat(frontNumberFee.quantity || 0)
                    : frontNumberCount;

                // Calculate unit price: total decor up fee divided by quantity
                const unitPrice =
                    quantity > 0
                        ? parseFloat(
                              (
                                  gender_element.total_front_number_decor_up_fees /
                                  quantity
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_front_number_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Front Number Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_front_number_decor_up_fees.toFixed(
                            2
                        )
                    ),
                    unitPrice: unitPrice,
                    quantity: quantity
                });
            }

            // Front Name Decor Up Fee
            if (gender_element.total_front_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_name_decor_up_fees;

                const frontNameFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("front name fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantityFn = frontNameFee
                    ? parseFloat(frontNameFee.quantity || 0)
                    : frontNameCount;
                const unitPriceFn =
                    quantityFn > 0
                        ? parseFloat(
                              (
                                  gender_element.total_front_name_decor_up_fees /
                                  quantityFn
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_front_name_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Front Name Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_front_name_decor_up_fees.toFixed(2)
                    ),
                    unitPrice: unitPriceFn,
                    quantity: quantityFn
                });
            }

            // Back Name Decor Up Fee
            if (gender_element.total_back_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_name_decor_up_fees;

                // Get quantity from Back Name Fee (number of back names)
                const backNameFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("back name fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantity = backNameFee
                    ? parseFloat(backNameFee.quantity || 0)
                    : backNameCount;

                // Calculate unit price: total decor up fee divided by quantity
                const unitPrice =
                    quantity > 0
                        ? parseFloat(
                              (
                                  gender_element.total_back_name_decor_up_fees /
                                  quantity
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_back_name_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Back Name Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_back_name_decor_up_fees.toFixed(2)
                    ),
                    unitPrice: unitPrice,
                    quantity: quantity
                });
            }

            // Back Number Decor Up Fee
            if (gender_element.total_back_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_number_decor_up_fees;

                // Get quantity from Back Number Fee (number of back numbers)
                const backNumberFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("back number fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const quantity = backNumberFee
                    ? parseFloat(backNumberFee.quantity || 0)
                    : backNumberCount;

                // Calculate unit price: total decor up fee divided by quantity
                const unitPrice =
                    quantity > 0
                        ? parseFloat(
                              (
                                  gender_element.total_back_number_decor_up_fees /
                                  quantity
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_back_number_decor_up_fees.toFixed(
                                  2
                              )
                          );

                detailsForRunCharge.push({
                    name: "Back Number Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_back_number_decor_up_fees.toFixed(
                            2
                        )
                    ),
                    unitPrice: unitPrice,
                    quantity: quantity
                });
            }

            // Left Name Decor Up Fee
            if (gender_element.total_left_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_left_name_decor_up_fees;
                const leftNameFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("left name fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const qtyLeftName = leftNameFee
                    ? parseFloat(leftNameFee.quantity || 0)
                    : leftNameCount;
                const unitLeftName =
                    qtyLeftName > 0
                        ? parseFloat(
                              (
                                  gender_element.total_left_name_decor_up_fees /
                                  qtyLeftName
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_left_name_decor_up_fees.toFixed(
                                  2
                              )
                          );
                detailsForRunCharge.push({
                    name: "Left Name Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_left_name_decor_up_fees.toFixed(2)
                    ),
                    unitPrice: unitLeftName,
                    quantity: qtyLeftName
                });
            }

            // Left Number Decor Up Fee
            if (gender_element.total_left_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_left_number_decor_up_fees;
                const leftNumberFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("left number fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const qtyLeftNum = leftNumberFee
                    ? parseFloat(leftNumberFee.quantity || 0)
                    : leftNumberCount;
                const unitLeftNum =
                    qtyLeftNum > 0
                        ? parseFloat(
                              (
                                  gender_element.total_left_number_decor_up_fees /
                                  qtyLeftNum
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_left_number_decor_up_fees.toFixed(
                                  2
                              )
                          );
                detailsForRunCharge.push({
                    name: "Left Number Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_left_number_decor_up_fees.toFixed(
                            2
                        )
                    ),
                    unitPrice: unitLeftNum,
                    quantity: qtyLeftNum
                });
            }

            // Right Name Decor Up Fee
            if (gender_element.total_right_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_right_name_decor_up_fees;
                const rightNameFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("right name fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const qtyRightName = rightNameFee
                    ? parseFloat(rightNameFee.quantity || 0)
                    : rightNameCount;
                const unitRightName =
                    qtyRightName > 0
                        ? parseFloat(
                              (
                                  gender_element.total_right_name_decor_up_fees /
                                  qtyRightName
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_right_name_decor_up_fees.toFixed(
                                  2
                              )
                          );
                detailsForRunCharge.push({
                    name: "Right Name Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_right_name_decor_up_fees.toFixed(2)
                    ),
                    unitPrice: unitRightName,
                    quantity: qtyRightName
                });
            }

            // Right Number Decor Up Fee
            if (gender_element.total_right_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_right_number_decor_up_fees;
                const rightNumberFee = detailsForRunCharge.find(
                    (d) =>
                        d.name &&
                        d.name.toLowerCase().includes("right number fee") &&
                        !d.name.toLowerCase().includes("decor up")
                );
                const qtyRightNum = rightNumberFee
                    ? parseFloat(rightNumberFee.quantity || 0)
                    : rightNumberCount;
                const unitRightNum =
                    qtyRightNum > 0
                        ? parseFloat(
                              (
                                  gender_element.total_right_number_decor_up_fees /
                                  qtyRightNum
                              ).toFixed(2)
                          )
                        : parseFloat(
                              gender_element.total_right_number_decor_up_fees.toFixed(
                                  2
                              )
                          );
                detailsForRunCharge.push({
                    name: "Right Number Decor Up Fee",
                    value: parseFloat(
                        gender_element.total_right_number_decor_up_fees.toFixed(
                            2
                        )
                    ),
                    unitPrice: unitRightNum,
                    quantity: qtyRightNum
                });
            }

            // Final Total Run Charge (round to 2 decimal places)
            gender_element.total_color_fee = parseFloat(
                gender_element.total_color_fee.toFixed(2)
            );

            // Total = BaseItemCosts + RunCharges + SetupFee + Patch Cost + Patch Additional Services (rollup_fee_id = 9)
            const patchCostVal = parseFloat(this.patchCost) || 0;
            const patchAdditionalTotal =
                patchCostVal > 0
                    ? this.getPatchAdditionalServicesTotal(
                          parseInt(gender_element.total_qty, 10) || 0
                      )
                    : 0;
            const preDiscountTotal =
                gender_element.subtotal +
                gender_element.total_color_fee +
                gender_element.total_setup_fee +
                otherServicesTotal +
                patchCostVal +
                patchAdditionalTotal;

            // Discount calculation removed - no longer applying overall discount
            gender_element.total_discount_value = 0;

            // Total cost is now the pre-discount total (no discount applied)
            gender_element.total_cost = preDiscountTotal;

            //Update picked_color for display in size table
            if (
                this.activeColorIndex >= 0 &&
                this.activeColorIndex < gender_element.colors.length
            ) {
                this.picked_color =
                    gender_element.colors[this.activeColorIndex];
            } else {
                this.picked_color = null; // Should not happen if logic is correct
            }

            // Update Breakdown Object for PriceBreakdown Component
            // Create new array reference to ensure Vue reactivity detects the change
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: gender_element.total_setup_fee,
                totalCost: gender_element.total_cost,
                totalDiscount: 0,
                designFee: gender_element.total_design_fee, // Usually 0 for PCNA
                runChargeDetails: [...detailsForRunCharge], // Create new array reference for reactivity
                patchCost: patchCostVal,
                patchSlabQuantity: this.patchSlabQuantity || 0,
                patchCostDetails: Array.isArray(this.patchCostDetails) ? this.patchCostDetails : [],
                patchAdditionalServicesTotal: patchAdditionalTotal
            };

            // Force update to ensure PCNAPriceBreakdown component reflects name/number fee changes
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },

        calculatePrintPricing(index) {
            const activeService = this.activeDecorationService;
            if (!activeService) {
                this.$toast.error(
                    "Error: Active decoration service is missing.",
                    {
                        position: "top-right"
                    }
                );
                return;
            }
            if (
                !this.genderGroups ||
                index === undefined ||
                !this.genderGroups[index]
            ) {
                this.$toast.error("Error: Product data not loaded correctly.", {
                    position: "top-right"
                });
                return;
            }
            let gender_element = this.genderGroups[index];
            if (!this.product) {
                this.$toast.error(
                    "Error: Base product information is missing.",
                    {
                        position: "top-right"
                    }
                );
                return;
            }

            gender_element.total_qty = 0;
            gender_element.subtotal = 0;
            gender_element.total_cost = 0;
            gender_element.total_discount_value = 0;
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_setup_fee = 0;
            gender_element.total_decoration_colors = 0;
            gender_element.per_color_setup_cost = 0;
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_left_name_fees = 0;
            gender_element.total_left_number_fees = 0;
            gender_element.total_right_name_fees = 0;
            gender_element.total_right_number_fees = 0;
            gender_element.total_front_number_decor_up_fees = 0;
            gender_element.total_front_name_decor_up_fees = 0;
            gender_element.total_back_name_decor_up_fees = 0;
            gender_element.total_back_number_decor_up_fees = 0;
            gender_element.total_left_name_decor_up_fees = 0;
            gender_element.total_left_number_decor_up_fees = 0;
            gender_element.total_right_name_decor_up_fees = 0;
            gender_element.total_right_number_decor_up_fees = 0;
            gender_element.total_non_standard_fees = 0;
            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;

            let detailsForRunCharge = [];

            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            let base_decoration_price = parseFloat(
                this.getDecorationPrice(0) || 0
            );
            let decoration_discount_percentage = parseFloat(
                this.getDecorationDiscount() || 0
            );
            let decoration_discount_amount = parseFloat(
                (
                    (base_decoration_price * decoration_discount_percentage) /
                    100
                ).toFixed(2)
            );
            let discounted_base_decoration_price = parseFloat(
                (base_decoration_price - decoration_discount_amount).toFixed(2)
            );

            if (gender_element.colors && gender_element.colors.length > 0) {
                gender_element.colors.forEach((selected_color_obj) => {
                    selected_color_obj.total_qty_gender_wise = 0;
                    selected_color_obj.subtotal = 0;
                    selected_color_obj.total_cost_gender_wise = 0;

                    selected_color_obj.unique_sizes.forEach((size) => {
                        let base_price = parseFloat(
                            size.price_base || this.product.price_base || 0
                        );
                        let markup_percentage = parseFloat(
                            activeService.markup_percentage ||
                                this.product.price_markup_percentage ||
                                0
                        );
                        let mark_up_cost = parseFloat(
                            ((base_price * markup_percentage) / 100).toFixed(2)
                        );
                        let color_category_price = parseFloat(
                            this.getDarkLightFees(selected_color_obj) || 0
                        );
                        size.markup_price = mark_up_cost;
                        size.single_location_price = base_decoration_price;
                        size.decoration_discount_percentage =
                            decoration_discount_percentage;
                        size.ink_price = color_category_price;
                        size.cost = parseFloat(
                            (
                                base_price +
                                mark_up_cost +
                                color_category_price +
                                discounted_base_decoration_price
                            ).toFixed(2)
                        );
                        const quantity = parseInt(size.quantity || 0);
                        size.total_cost =
                            quantity > 0
                                ? parseFloat((size.cost * quantity).toFixed(2))
                                : 0;
                        if (quantity > 0) {
                            selected_color_obj.subtotal = parseFloat(
                                (
                                    selected_color_obj.subtotal +
                                    size.total_cost
                                ).toFixed(2)
                            );
                            selected_color_obj.total_qty_gender_wise +=
                                quantity;
                        }
                    });

                    gender_element.total_design_fee += parseFloat(
                        selected_color_obj.total_design_fee || 0
                    );
                    // Note: Name and number fees are now calculated from VendorOtherServices below
                    gender_element.total_front_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.front_number_decor_up_fees || 0
                        );
                    gender_element.total_front_name_decor_up_fees += parseFloat(
                        selected_color_obj.front_name_decor_up_fees || 0
                    );
                    gender_element.total_back_name_decor_up_fees += parseFloat(
                        selected_color_obj.back_name_decor_up_fees || 0
                    );
                    gender_element.total_back_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.back_number_decor_up_fees || 0
                        );
                    gender_element.total_left_name_decor_up_fees += parseFloat(
                        selected_color_obj.left_name_decor_up_fees || 0
                    );
                    gender_element.total_left_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.left_number_decor_up_fees || 0
                        );
                    gender_element.total_right_name_decor_up_fees += parseFloat(
                        selected_color_obj.right_name_decor_up_fees || 0
                    );
                    gender_element.total_right_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.right_number_decor_up_fees || 0
                        );

                    gender_element.subtotal = parseFloat(
                        (
                            gender_element.subtotal +
                            selected_color_obj.subtotal
                        ).toFixed(2)
                    );
                    gender_element.total_qty +=
                        selected_color_obj.total_qty_gender_wise;
                });
            }

            // Location Run Charges
            const runChargeResult = this.calcImprintLocationByGender();
            let locationRunCharge = parseFloat(
                parseFloat(
                    runChargeResult.totalCalculatedDecorationFee || 0
                ).toFixed(2)
            );
            gender_element.total_color_fee += locationRunCharge;
            gender_element.total_decoration_colors =
                runChargeResult.total_colors;
            if (locationRunCharge > 0) {
                detailsForRunCharge.push({
                    name: "Location(s) Run Charge",
                    value: locationRunCharge
                });
            }

            // Vendor Color Upcharges - Specialty Colors (stock = true AND upcharge > 0)
            let vendorColorUpcharge = 0;
            let customColorUpcharge = 0;
            if (this.allDecorationColors && total_group_quantity > 0) {
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes) {
                        colorHexCodes.forEach((hexCode) => {
                            if (!hexCode) return;
                            const vendorColor = this.vendorColors.find(
                                (color) =>
                                    color.color_value.toLowerCase() ===
                                    (typeof hexCode === "string"
                                        ? hexCode.toLowerCase()
                                        : hexCode.hex.toLowerCase())
                            );
                            if (vendorColor && vendorColor.decor_upcharge) {
                                const upcharge = parseFloat(
                                    vendorColor.decor_upcharge || 0
                                );
                                const stock =
                                    vendorColor.stock === true ||
                                    vendorColor.stock === 1;

                                if (upcharge > 0) {
                                    if (stock) {
                                        // Specialty Color: stock = true AND upcharge > 0
                                        vendorColorUpcharge +=
                                            upcharge *
                                            parseInt(total_group_quantity);
                                    } else {
                                        // Custom Color: stock = false AND upcharge > 0
                                        customColorUpcharge +=
                                            upcharge *
                                            parseInt(total_group_quantity);
                                    }
                                }
                            }
                        });
                    }
                }
            }
            if (vendorColorUpcharge > 0) {
                vendorColorUpcharge = parseFloat(
                    vendorColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += vendorColorUpcharge;
                detailsForRunCharge.push({
                    name: "Specialty Color",
                    value: vendorColorUpcharge
                });
            }

            // Custom Colors (stock = false AND upcharge > 0)
            if (customColorUpcharge > 0) {
                customColorUpcharge = parseFloat(
                    customColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += customColorUpcharge;
                detailsForRunCharge.push({
                    name: "Custom Color",
                    value: customColorUpcharge
                });
            }

            // Custom Color Fee - Get from VendorOtherServices
            const serviceName = activeService
                ? (activeService.name || "").toLowerCase()
                : "";
            const decorationType =
                activeService && activeService.master_service
                    ? activeService.master_service.decoration_type
                    : 1; // Default to 1 (Screen Print) for calculatePrintPricing

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decorationType,
                serviceName
            );

            // Get unique non-standard color count
            let uniqueNonStandardColorCount =
                this.getUniqueNonStandardColorCount();

            // Calculate mix fee: unique non-standard color count × fee per color (NO quantity multiplication)
            let calculatedMixFee = 0;
            if (
                colorMixFeePerColor !== null &&
                uniqueNonStandardColorCount > 0
            ) {
                calculatedMixFee =
                    uniqueNonStandardColorCount * colorMixFeePerColor;
            }

            gender_element.total_non_standard_fees = calculatedMixFee;
            if (gender_element.total_non_standard_fees > 0) {
                const mixFeeToAdd = parseFloat(
                    gender_element.total_non_standard_fees.toFixed(2)
                );
                gender_element.total_color_fee += mixFeeToAdd;

                detailsForRunCharge.push({
                    name: "Custom Color Ink Fee",
                    value: mixFeeToAdd,
                    mixColorCount: uniqueNonStandardColorCount,
                    unitPrice: colorMixFeePerColor || 0,
                    quantity: total_group_quantity
                });
            }

            // Name and Number Fees - Get from VendorOtherServices
            // Only apply if front/back has decorations, calculate based on actual name/number count per location
            const nameFeePerItem = this.getNameFeeFromVendorServices();
            const numberFeePerItem = this.getNumberFeeFromVendorServices();

            // Initialize fees to 0
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;

            // Initialize color-level fees to 0
            gender_element.colors.forEach((color) => {
                color.front_number_fees = 0;
                color.front_name_fees = 0;
                color.back_name_fees = 0;
                color.back_number_fees = 0;
                color.left_name_fees = 0;
                color.left_number_fees = 0;
                color.right_name_fees = 0;
                color.right_number_fees = 0;
            });

            // Count actual names and numbers per location (front, back, left, right) based on selected_name_number
            const {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount,
                leftNameCount,
                leftNumberCount,
                rightNameCount,
                rightNumberCount
            } = this.countNamesAndNumbersByLocation(this.active_gender_index);

            // Check if front, back, left or right has decorations
            const { hasFront, hasBack, hasLeft, hasRight } =
                this.hasFrontOrBackDecoration(this.active_gender_index);

            // Only calculate fees if there are actual names/numbers added (count > 0), not just when decoration is added
            if (
                frontNameCount > 0 ||
                backNameCount > 0 ||
                frontNumberCount > 0 ||
                backNumberCount > 0 ||
                leftNameCount > 0 ||
                leftNumberCount > 0 ||
                rightNameCount > 0 ||
                rightNumberCount > 0
            ) {
                // Front name fee
                if (nameFeePerItem !== null && frontNameCount > 0 && hasFront) {
                    gender_element.total_front_name_fees =
                        frontNameCount * nameFeePerItem;
                    if (gender_element.total_front_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_front_name_fees;
                        detailsForRunCharge.push({
                            name: "Front Name Fee",
                            value: parseFloat(
                                gender_element.total_front_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: frontNameCount
                        });
                    }
                }

                // Back name fee
                if (nameFeePerItem !== null && backNameCount > 0 && hasBack) {
                    gender_element.total_back_name_fees =
                        backNameCount * nameFeePerItem;
                    if (gender_element.total_back_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_back_name_fees;
                        detailsForRunCharge.push({
                            name: "Back Name Fee",
                            value: parseFloat(
                                gender_element.total_back_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: backNameCount
                        });
                    }
                    // Update color.back_name_fees for each color individually
                    gender_element.colors.forEach((color) => {
                        if (
                            color.name_and_number_json &&
                            Array.isArray(color.name_and_number_json)
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.name &&
                                        typeof nn.name === "string" &&
                                        nn.name.trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.name === true) {
                                const colorBackNameCount =
                                    nameAndNumbers.length;
                                color.back_name_fees =
                                    colorBackNameCount * nameFeePerItem;
                            }
                        }
                    });
                }

                // Left name fee - separate row in run charge breakdown
                if (nameFeePerItem !== null && leftNameCount > 0 && hasLeft) {
                    gender_element.total_left_name_fees =
                        leftNameCount * nameFeePerItem;
                    if (gender_element.total_left_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_left_name_fees;
                        detailsForRunCharge.push({
                            name: "Left Name Fee",
                            value: parseFloat(
                                gender_element.total_left_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: leftNameCount
                        });
                    }
                }

                // Right name fee - separate row in run charge breakdown
                if (nameFeePerItem !== null && rightNameCount > 0 && hasRight) {
                    gender_element.total_right_name_fees =
                        rightNameCount * nameFeePerItem;
                    if (gender_element.total_right_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_right_name_fees;
                        detailsForRunCharge.push({
                            name: "Right Name Fee",
                            value: parseFloat(
                                gender_element.total_right_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: rightNameCount
                        });
                    }
                }

                // Calculate number fees per location (front, back, left, right)
                if (numberFeePerItem !== null) {
                    // Front number fee
                    if (frontNumberCount > 0 && hasFront) {
                        gender_element.total_front_number_fees =
                            frontNumberCount * numberFeePerItem;
                        if (gender_element.total_front_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_front_number_fees;
                            detailsForRunCharge.push({
                                name: "Front Number Fee",
                                value: parseFloat(
                                    gender_element.total_front_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: frontNumberCount
                            });
                        }
                        // Update color.front_number_fees for each color individually
                        gender_element.colors.forEach((color) => {
                            if (
                                color.name_and_number_json &&
                                Array.isArray(color.name_and_number_json)
                            ) {
                                const nameAndNumbers =
                                    color.name_and_number_json.filter(
                                        (nn) =>
                                            nn.number !== null &&
                                            nn.number !== undefined &&
                                            nn.number.toString().trim() !== ""
                                    );
                                const selectedNameNumber =
                                    color.selected_name_number || {};
                                const frontSelected =
                                    selectedNameNumber.front || {};
                                if (frontSelected.number === true) {
                                    const colorFrontNumberCount =
                                        nameAndNumbers.length;
                                    color.front_number_fees =
                                        colorFrontNumberCount *
                                        numberFeePerItem;
                                }
                            }
                        });
                    }

                    // Back number fee - only if numbers are added for back
                    if (backNumberCount > 0 && hasBack) {
                        gender_element.total_back_number_fees =
                            backNumberCount * numberFeePerItem;
                        if (gender_element.total_back_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_back_number_fees;
                            detailsForRunCharge.push({
                                name: "Back Number Fee",
                                value: parseFloat(
                                    gender_element.total_back_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: backNumberCount
                            });
                        }
                        // Update color.back_number_fees for each color individually
                        gender_element.colors.forEach((color) => {
                            if (
                                color.name_and_number_json &&
                                Array.isArray(color.name_and_number_json)
                            ) {
                                const nameAndNumbers =
                                    color.name_and_number_json.filter(
                                        (nn) =>
                                            nn.number !== null &&
                                            nn.number !== undefined &&
                                            nn.number.toString().trim() !== ""
                                    );
                                const selectedNameNumber =
                                    color.selected_name_number || {};
                                const backSelected =
                                    selectedNameNumber.back || {};
                                if (backSelected.number === true) {
                                    const colorBackNumberCount =
                                        nameAndNumbers.length;
                                    color.back_number_fees =
                                        colorBackNumberCount * numberFeePerItem;
                                }
                            }
                        });
                    }

                    // Left number fee - separate row in run charge breakdown
                    if (leftNumberCount > 0 && hasLeft) {
                        gender_element.total_left_number_fees =
                            leftNumberCount * numberFeePerItem;
                        if (gender_element.total_left_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_left_number_fees;
                            detailsForRunCharge.push({
                                name: "Left Number Fee",
                                value: parseFloat(
                                    gender_element.total_left_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: leftNumberCount
                            });
                        }
                    }

                    // Right number fee - separate row in run charge breakdown
                    if (rightNumberCount > 0 && hasRight) {
                        gender_element.total_right_number_fees =
                            rightNumberCount * numberFeePerItem;
                        if (gender_element.total_right_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_right_number_fees;
                            detailsForRunCharge.push({
                                name: "Right Number Fee",
                                value: parseFloat(
                                    gender_element.total_right_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: rightNumberCount
                            });
                        }
                    }
                }
            }
            if (gender_element.total_front_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Front Number Decor Up Fee",
                    value: gender_element.total_front_number_decor_up_fees
                });
            }
            if (gender_element.total_front_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Front Name Decor Up Fee",
                    value: gender_element.total_front_name_decor_up_fees
                });
            }
            if (gender_element.total_back_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Name Decor Up Fee",
                    value: gender_element.total_back_name_decor_up_fees
                });
            }
            if (gender_element.total_back_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Number Decor Up Fee",
                    value: gender_element.total_back_number_decor_up_fees
                });
            }
            if (gender_element.total_left_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_left_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Left Name Decor Up Fee",
                    value: gender_element.total_left_name_decor_up_fees
                });
            }
            if (gender_element.total_left_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_left_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Left Number Decor Up Fee",
                    value: gender_element.total_left_number_decor_up_fees
                });
            }
            if (gender_element.total_right_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_right_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Right Name Decor Up Fee",
                    value: gender_element.total_right_name_decor_up_fees
                });
            }
            if (gender_element.total_right_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_right_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Right Number Decor Up Fee",
                    value: gender_element.total_right_number_decor_up_fees
                });
            }

            // Final Total Run Charge
            gender_element.total_color_fee = parseFloat(
                gender_element.total_color_fee.toFixed(2)
            );

            // Setup Fee & Other Services
            const masterServicePricing = activeService.master_service;
            if (
                masterServicePricing &&
                total_group_quantity > 0 &&
                gender_element.total_decoration_colors > 0
            ) {
                const feeStructure = masterServicePricing.fee_structure;
                const setupFeeColor1 = parseFloat(
                    masterServicePricing.setup_fee_color1 || 0
                );
                const setupFeeMulticolor = parseFloat(
                    masterServicePricing.setup_fee_multicolor || 0
                );
                gender_element.per_color_setup_cost = setupFeeColor1;
                if (feeStructure == "1") {
                    this.setup_fee = parseFloat(
                        (
                            setupFeeColor1 *
                            gender_element.total_decoration_colors
                        ).toFixed(2)
                    );
                } else if (feeStructure == "2") {
                    if (gender_element.total_decoration_colors === 1) {
                        this.setup_fee = parseFloat(setupFeeColor1.toFixed(2));
                    } else if (gender_element.total_decoration_colors > 1) {
                        this.setup_fee = parseFloat(
                            setupFeeMulticolor.toFixed(2)
                        );
                    }
                }
                gender_element.total_setup_fee = this.setup_fee;
                if (this.setup_fee > 0)
                    this.setup_fee_applied_gender_index = index;
            }

            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            // preDiscountTotal (include patch cost + patch additional services rollup_fee_id = 9)
            const patchCostVal = parseFloat(this.patchCost) || 0;
            const patchAdditionalTotal =
                patchCostVal > 0
                    ? this.getPatchAdditionalServicesTotal(total_group_quantity)
                    : 0;
            const preDiscountTotal = parseFloat(
                (
                    gender_element.subtotal + // Base item costs
                    gender_element.total_color_fee + // run charges
                    gender_element.total_setup_fee + // Setup fee
                    gender_element.total_design_fee + // Design fee
                    otherServicesTotal +
                    patchCostVal +
                    patchAdditionalTotal
                ) // other services
                    .toFixed(2)
            );

            // Discount calculation removed - no longer applying overall discount
            gender_element.total_discount_value = 0;

            // Final Total Cost
            gender_element.total_cost = parseFloat(preDiscountTotal.toFixed(2));

            // Breakdown Data Set Karein
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: gender_element.total_setup_fee,
                totalCost: gender_element.total_cost,
                totalDiscount: 0,
                designFee: gender_element.total_design_fee,
                runChargeDetails: detailsForRunCharge,
                patchCost: patchCostVal,
                patchSlabQuantity: this.patchSlabQuantity || 0,
                patchCostDetails: Array.isArray(this.patchCostDetails) ? this.patchCostDetails : [],
                patchAdditionalServicesTotal: patchAdditionalTotal
            };

            this.$forceUpdate();
        },

        getDarkLightFees(color) {
            const activeService = this.activeDecorationService;
            // Check if color object and active service exist
            if (color && activeService) {
                // Use price_dark and price_light directly from the active service
                if (color.category == "Dark") {
                    return parseFloat(activeService.price_dark || 0);
                } else if (color.category == "Light") {
                    return parseFloat(activeService.price_light || 0);
                }
            }
            // Return 0 if color category doesn't match or data is missing
            return 0;
        },

        calculateEmbroideryPricing(index) {
            const activeService = this.activeDecorationService;
            if (!activeService) {
                console.error(
                    "calculateEmbroideryPricing: activeDecorationService is missing."
                );
                return;
            }

            let gender_element = this.genderGroups[index];
            if (!gender_element) {
                console.error(
                    "calculateEmbroideryPricing: gender_element is missing."
                );
                return;
            }

            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            // Reset all gender-level totals
            gender_element.total_discount_value = 0; // Promotional Discount
            gender_element.total_qty = 0;
            gender_element.total_cost = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_setup_fee = 0;
            gender_element.subtotal = 0; // Item total (after decoration discount)
            gender_element.total_design_fee = 0;
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_left_name_fees = 0;
            gender_element.total_left_number_fees = 0;
            gender_element.total_right_name_fees = 0;
            gender_element.total_right_number_fees = 0;
            gender_element.total_front_number_decor_up_fees = 0;
            gender_element.total_front_name_decor_up_fees = 0;
            gender_element.total_back_name_decor_up_fees = 0;
            gender_element.total_back_number_decor_up_fees = 0;
            gender_element.total_left_name_decor_up_fees = 0;
            gender_element.total_left_number_decor_up_fees = 0;
            gender_element.total_right_name_decor_up_fees = 0;
            gender_element.total_right_number_decor_up_fees = 0;
            gender_element.total_non_standard_fees = 0;
            gender_element.total_decoration_colors = 0;
            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;

            let detailsForRunCharge = [];

            // Track total decoration colors count for setup fee calculation
            let total_decoration_colors_count = 0;

            if (gender_element["colors"]) {
                // Get tier price and discount ONCE
                let single_location_price = this.getDecorationPrice();
                let decoration_discount_percentage =
                    this.getDecorationDiscount();

                gender_element["colors"].forEach((selected_color_obj) => {
                    // Reset color-level totals
                    selected_color_obj.total_qty_gender_wise = 0;
                    selected_color_obj.subtotal = 0;
                    selected_color_obj.total_cost_gender_wise = 0;
                    selected_color_obj.total_design_fee = 0;

                    // Loop through each size
                    selected_color_obj["unique_sizes"].forEach((size) => {
                        // Store current tier's price and discount on the size object
                        size.single_location_price = single_location_price;
                        size.decoration_discount_percentage =
                            decoration_discount_percentage;

                        let base_price =
                            size.price_base || this.product.price_base || 0;
                        const activeService = this.activeDecorationService;
                        let markup_percentage = activeService
                            ? activeService.markup_percentage
                            : this.product.price_markup_percentage || 0;
                        let mark_up_cost =
                            (base_price * markup_percentage) / 100;
                        size.markup_price = mark_up_cost;
                        let color_category_price =
                            this.getDarkLightFees(selected_color_obj);
                        size.ink_price = color_category_price;

                        let decoration_discount_amount =
                            (parseFloat(size.single_location_price) *
                                parseFloat(
                                    size.decoration_discount_percentage
                                )) /
                            100;
                        let discounted_decoration_price =
                            parseFloat(size.single_location_price) -
                            decoration_discount_amount;

                        size.cost =
                            parseFloat(base_price) +
                            parseFloat(mark_up_cost) +
                            parseFloat(color_category_price || 0) +
                            discounted_decoration_price;

                        // Calculate totals only if quantity exists
                        if (size.quantity && size.quantity > 0) {
                            size.total_cost =
                                this.icPriceFormat(size.cost, true) *
                                parseInt(size.quantity);
                            selected_color_obj.subtotal += parseFloat(
                                size.total_cost
                            );
                            selected_color_obj.total_cost_gender_wise +=
                                parseFloat(size.total_cost);
                            selected_color_obj.total_qty_gender_wise +=
                                parseInt(size.quantity);
                        } else {
                            size.total_cost = 0;
                        }
                    });

                    // Aggregate design fee
                    gender_element.total_design_fee += parseFloat(
                        selected_color_obj.total_design_fee || 0
                    );
                    // Note: Name and number fees are now calculated from VendorOtherServices below
                    gender_element.total_front_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.front_number_decor_up_fees || 0
                        );
                    gender_element.total_front_name_decor_up_fees += parseFloat(
                        selected_color_obj.front_name_decor_up_fees || 0
                    );
                    gender_element.total_back_name_decor_up_fees += parseFloat(
                        selected_color_obj.back_name_decor_up_fees || 0
                    );
                    gender_element.total_back_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.back_number_decor_up_fees || 0
                        );
                    gender_element.total_left_name_decor_up_fees += parseFloat(
                        selected_color_obj.left_name_decor_up_fees || 0
                    );
                    gender_element.total_left_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.left_number_decor_up_fees || 0
                        );
                    gender_element.total_right_name_decor_up_fees += parseFloat(
                        selected_color_obj.right_name_decor_up_fees || 0
                    );
                    gender_element.total_right_number_decor_up_fees +=
                        parseFloat(
                            selected_color_obj.right_number_decor_up_fees || 0
                        );

                    // Aggregate up to the gender level
                    gender_element.subtotal += parseFloat(
                        selected_color_obj.subtotal
                    );
                    gender_element.total_qty += parseFloat(
                        selected_color_obj.total_qty_gender_wise
                    );
                });
            }

            // Calculate decoration fee using calcImprintLocationByGender (Old Embroidery Logic)
            const runChargeResult = this.calcImprintLocationByGender();
            const total_decoration_fee = parseFloat(
                runChargeResult.totalCalculatedDecorationFee || 0
            );
            total_decoration_colors_count = runChargeResult.total_colors || 0;
            gender_element.total_decoration_colors =
                total_decoration_colors_count;

            // Add location run charge to total_color_fee
            if (total_decoration_fee > 0) {
                gender_element.total_color_fee += total_decoration_fee;
                detailsForRunCharge.push({
                    name: "Location(s) Run Charge",
                    value: parseFloat(total_decoration_fee.toFixed(2))
                });
            }

            // Vendor Color Upcharges - Specialty Colors (stock = true AND upcharge > 0)
            let vendorColorUpcharge = 0;
            let customColorUpcharge = 0;
            if (this.allDecorationColors && total_group_quantity > 0) {
                for (const [flip, colorHexCodes] of Object.entries(
                    this.allDecorationColors
                )) {
                    if (colorHexCodes) {
                        colorHexCodes.forEach((hexCode) => {
                            if (!hexCode) return;
                            const vendorColor = this.vendorColors.find(
                                (color) =>
                                    color.color_value.toLowerCase() ===
                                    (typeof hexCode === "string"
                                        ? hexCode.toLowerCase()
                                        : hexCode.hex.toLowerCase())
                            );
                            if (vendorColor && vendorColor.decor_upcharge) {
                                const upcharge = parseFloat(
                                    vendorColor.decor_upcharge || 0
                                );
                                const stock =
                                    vendorColor.stock === true ||
                                    vendorColor.stock === 1;

                                if (upcharge > 0) {
                                    if (stock) {
                                        // Specialty Color: stock = true AND upcharge > 0
                                        vendorColorUpcharge +=
                                            upcharge *
                                            parseInt(total_group_quantity);
                                    } else {
                                        // Custom Color: stock = false AND upcharge > 0
                                        customColorUpcharge +=
                                            upcharge *
                                            parseInt(total_group_quantity);
                                    }
                                }
                            }
                        });
                    }
                }
            }
            if (vendorColorUpcharge > 0) {
                vendorColorUpcharge = parseFloat(
                    vendorColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += vendorColorUpcharge;
                detailsForRunCharge.push({
                    name: "Specialty Color",
                    value: vendorColorUpcharge
                });
            }

            // Custom Colors (stock = false AND upcharge > 0)
            if (customColorUpcharge > 0) {
                customColorUpcharge = parseFloat(
                    customColorUpcharge.toFixed(2)
                );
                gender_element.total_color_fee += customColorUpcharge;
                detailsForRunCharge.push({
                    name: "Custom Color",
                    value: customColorUpcharge
                });
            }

            // Custom Color Fee - Get from VendorOtherServices
            const serviceName = activeService
                ? (activeService.name || "").toLowerCase()
                : "";
            const decorationType =
                activeService && activeService.master_service
                    ? activeService.master_service.decoration_type
                    : 2; // Default to 2 (Embroidery) for calculateEmbroideryPricing

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decorationType,
                serviceName
            );

            // Get unique non-standard color count
            let uniqueNonStandardColorCount =
                this.getUniqueNonStandardColorCount();

            // Calculate mix fee: unique non-standard color count × fee per color (NO quantity multiplication)
            let calculatedMixFee = 0;
            if (
                colorMixFeePerColor !== null &&
                uniqueNonStandardColorCount > 0
            ) {
                calculatedMixFee =
                    uniqueNonStandardColorCount * colorMixFeePerColor;
            }

            gender_element.total_non_standard_fees = calculatedMixFee;
            if (gender_element.total_non_standard_fees > 0) {
                const mixFeeToAdd = parseFloat(
                    gender_element.total_non_standard_fees.toFixed(2)
                );
                gender_element.total_color_fee += mixFeeToAdd;

                // Use "Custom Color Thread Fee" for embroidery (decoration_type == 2), "Custom Color Ink Fee" for print
                const mixFeeLabel =
                    decorationType == 2
                        ? "Custom Color Thread Fee"
                        : "Custom Color Ink Fee";

                detailsForRunCharge.push({
                    name: mixFeeLabel,
                    value: mixFeeToAdd,
                    mixColorCount: uniqueNonStandardColorCount,
                    unitPrice: colorMixFeePerColor || 0,
                    quantity: total_group_quantity
                });
            }

            // Name and Number Fees - Get from VendorOtherServices
            // Only apply if front/back has decorations, calculate based on actual name/number count per location
            const nameFeePerItem = this.getNameFeeFromVendorServices();
            const numberFeePerItem = this.getNumberFeeFromVendorServices();

            // Initialize fees to 0
            gender_element.total_front_name_fees = 0;
            gender_element.total_back_name_fees = 0;
            gender_element.total_front_number_fees = 0;
            gender_element.total_back_number_fees = 0;
            gender_element.total_left_name_fees = 0;
            gender_element.total_left_number_fees = 0;
            gender_element.total_right_name_fees = 0;
            gender_element.total_right_number_fees = 0;

            // Initialize color-level fees to 0
            gender_element.colors.forEach((color) => {
                color.front_number_fees = 0;
                color.front_name_fees = 0;
                color.back_name_fees = 0;
                color.back_number_fees = 0;
                color.left_name_fees = 0;
                color.left_number_fees = 0;
                color.right_name_fees = 0;
                color.right_number_fees = 0;
            });

            // Count actual names and numbers per location (front, back, left, right) - separate counts
            const {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount,
                leftNameCount,
                leftNumberCount,
                rightNameCount,
                rightNumberCount
            } = this.countNamesAndNumbersByLocation(this.active_gender_index);

            // Check which imprint locations have decorations
            const { hasFront, hasBack, hasLeft, hasRight } =
                this.hasFrontOrBackDecoration(this.active_gender_index);

            // Only calculate fees if there are actual names/numbers added (count > 0)
            if (
                frontNameCount > 0 ||
                backNameCount > 0 ||
                frontNumberCount > 0 ||
                backNumberCount > 0 ||
                leftNameCount > 0 ||
                leftNumberCount > 0 ||
                rightNameCount > 0 ||
                rightNumberCount > 0
            ) {
                // Front name fee
                if (nameFeePerItem !== null && frontNameCount > 0 && hasFront) {
                    gender_element.total_front_name_fees =
                        frontNameCount * nameFeePerItem;
                    if (gender_element.total_front_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_front_name_fees;
                        detailsForRunCharge.push({
                            name: "Front Name Fee",
                            value: parseFloat(
                                gender_element.total_front_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: frontNameCount
                        });
                    }
                }

                // Back name fee
                if (nameFeePerItem !== null && backNameCount > 0 && hasBack) {
                    gender_element.total_back_name_fees =
                        backNameCount * nameFeePerItem;
                    if (gender_element.total_back_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_back_name_fees;
                        detailsForRunCharge.push({
                            name: "Back Name Fee",
                            value: parseFloat(
                                gender_element.total_back_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: backNameCount
                        });
                    }
                }

                // Left name fee - separate row in run charge breakdown
                if (nameFeePerItem !== null && leftNameCount > 0 && hasLeft) {
                    gender_element.total_left_name_fees =
                        leftNameCount * nameFeePerItem;
                    if (gender_element.total_left_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_left_name_fees;
                        detailsForRunCharge.push({
                            name: "Left Name Fee",
                            value: parseFloat(
                                gender_element.total_left_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: leftNameCount
                        });
                    }
                }

                // Right name fee - separate row in run charge breakdown
                if (nameFeePerItem !== null && rightNameCount > 0 && hasRight) {
                    gender_element.total_right_name_fees =
                        rightNameCount * nameFeePerItem;
                    if (gender_element.total_right_name_fees > 0) {
                        gender_element.total_color_fee +=
                            gender_element.total_right_name_fees;
                        detailsForRunCharge.push({
                            name: "Right Name Fee",
                            value: parseFloat(
                                gender_element.total_right_name_fees.toFixed(2)
                            ),
                            unitPrice: nameFeePerItem,
                            quantity: rightNameCount
                        });
                    }
                }

                // Calculate number fees per location (front, back, left, right)
                if (numberFeePerItem !== null) {
                    // Front number fee
                    if (frontNumberCount > 0 && hasFront) {
                        gender_element.total_front_number_fees =
                            frontNumberCount * numberFeePerItem;
                        if (gender_element.total_front_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_front_number_fees;
                            detailsForRunCharge.push({
                                name: "Front Number Fee",
                                value: parseFloat(
                                    gender_element.total_front_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: frontNumberCount
                            });
                        }
                    }

                    // Back number fee - only if numbers are added for back
                    if (backNumberCount > 0 && hasBack) {
                        gender_element.total_back_number_fees =
                            backNumberCount * numberFeePerItem;
                        if (gender_element.total_back_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_back_number_fees;
                            detailsForRunCharge.push({
                                name: "Back Number Fee",
                                value: parseFloat(
                                    gender_element.total_back_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: backNumberCount
                            });
                        }
                        // Update color.back_number_fees for each color individually
                        gender_element.colors.forEach((color) => {
                            if (
                                color.name_and_number_json &&
                                Array.isArray(color.name_and_number_json)
                            ) {
                                const nameAndNumbers =
                                    color.name_and_number_json.filter(
                                        (nn) =>
                                            nn.number !== null &&
                                            nn.number !== undefined &&
                                            nn.number.toString().trim() !== ""
                                    );
                                const selectedNameNumber =
                                    color.selected_name_number || {};
                                const backSelected =
                                    selectedNameNumber.back || {};
                                if (backSelected.number === true) {
                                    const colorBackNumberCount =
                                        nameAndNumbers.length;
                                    color.back_number_fees =
                                        colorBackNumberCount * numberFeePerItem;
                                }
                            }
                        });
                    }

                    // Left number fee - separate row in run charge breakdown
                    if (leftNumberCount > 0 && hasLeft) {
                        gender_element.total_left_number_fees =
                            leftNumberCount * numberFeePerItem;
                        if (gender_element.total_left_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_left_number_fees;
                            detailsForRunCharge.push({
                                name: "Left Number Fee",
                                value: parseFloat(
                                    gender_element.total_left_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: leftNumberCount
                            });
                        }
                    }

                    // Right number fee - separate row in run charge breakdown
                    if (rightNumberCount > 0 && hasRight) {
                        gender_element.total_right_number_fees =
                            rightNumberCount * numberFeePerItem;
                        if (gender_element.total_right_number_fees > 0) {
                            gender_element.total_color_fee +=
                                gender_element.total_right_number_fees;
                            detailsForRunCharge.push({
                                name: "Right Number Fee",
                                value: parseFloat(
                                    gender_element.total_right_number_fees.toFixed(
                                        2
                                    )
                                ),
                                unitPrice: numberFeePerItem,
                                quantity: rightNumberCount
                            });
                        }
                    }
                }
                // Update color.front_number_fees and color.back_name_fees for each color individually
                gender_element.colors.forEach((color) => {
                    if (
                        color.name_and_number_json &&
                        Array.isArray(color.name_and_number_json)
                    ) {
                        // Front number fees
                        if (
                            numberFeePerItem !== null &&
                            frontNumberCount > 0 &&
                            hasFront
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.number !== null &&
                                        nn.number !== undefined &&
                                        nn.number.toString().trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.number === true) {
                                const colorFrontNumberCount =
                                    nameAndNumbers.length;
                                color.front_number_fees =
                                    colorFrontNumberCount * numberFeePerItem;
                            }
                        }
                        // Front name fees
                        if (
                            nameFeePerItem !== null &&
                            frontNameCount > 0 &&
                            hasFront
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.name &&
                                        typeof nn.name === "string" &&
                                        nn.name.trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.name === true) {
                                const colorFrontNameCount =
                                    nameAndNumbers.length;
                                color.front_name_fees =
                                    colorFrontNameCount * nameFeePerItem;
                            }
                        }
                        // Back name fees
                        if (
                            nameFeePerItem !== null &&
                            backNameCount > 0 &&
                            hasBack
                        ) {
                            const nameAndNumbers =
                                color.name_and_number_json.filter(
                                    (nn) =>
                                        nn.name &&
                                        typeof nn.name === "string" &&
                                        nn.name.trim() !== ""
                                );
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.name === true) {
                                const colorBackNameCount =
                                    nameAndNumbers.length;
                                color.back_name_fees =
                                    colorBackNameCount * nameFeePerItem;
                            }
                        }
                    } else if (
                        color.name_and_number_json &&
                        typeof color.name_and_number_json === "object"
                    ) {
                        const nnJson = color.name_and_number_json;
                        const selectedNameNumber =
                            color.selected_name_number || {};
                        // Front name (object format)
                        if (
                            nameFeePerItem !== null &&
                            frontNameCount > 0 &&
                            hasFront &&
                            nnJson.front &&
                            Array.isArray(nnJson.front)
                        ) {
                            const frontNames = nnJson.front.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.name === true) {
                                color.front_name_fees =
                                    frontNames.length * nameFeePerItem;
                            }
                        }
                        // Front number (object format)
                        if (
                            numberFeePerItem !== null &&
                            frontNumberCount > 0 &&
                            hasFront &&
                            nnJson.front &&
                            Array.isArray(nnJson.front)
                        ) {
                            const frontNumbers = nnJson.front.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const frontSelected =
                                selectedNameNumber.front || {};
                            if (frontSelected.number === true) {
                                color.front_number_fees =
                                    frontNumbers.length * numberFeePerItem;
                            }
                        }
                        // Back name (object format)
                        if (
                            nameFeePerItem !== null &&
                            backNameCount > 0 &&
                            hasBack &&
                            nnJson.back &&
                            Array.isArray(nnJson.back)
                        ) {
                            const backNames = nnJson.back.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.name === true) {
                                color.back_name_fees =
                                    backNames.length * nameFeePerItem;
                            }
                        }
                        // Back number (object format)
                        if (
                            numberFeePerItem !== null &&
                            backNumberCount > 0 &&
                            hasBack &&
                            nnJson.back &&
                            Array.isArray(nnJson.back)
                        ) {
                            const backNumbers = nnJson.back.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const backSelected = selectedNameNumber.back || {};
                            if (backSelected.number === true) {
                                color.back_number_fees =
                                    backNumbers.length * numberFeePerItem;
                            }
                        }
                        if (
                            nameFeePerItem !== null &&
                            leftNameCount > 0 &&
                            hasLeft &&
                            nnJson.left &&
                            Array.isArray(nnJson.left)
                        ) {
                            const leftNames = nnJson.left.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const leftSelected = selectedNameNumber.left || {};
                            if (leftSelected.name === true) {
                                color.left_name_fees =
                                    leftNames.length * nameFeePerItem;
                            }
                        }
                        if (
                            numberFeePerItem !== null &&
                            leftNumberCount > 0 &&
                            hasLeft &&
                            nnJson.left &&
                            Array.isArray(nnJson.left)
                        ) {
                            const leftNumbers = nnJson.left.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const leftSelected = selectedNameNumber.left || {};
                            if (leftSelected.number === true) {
                                color.left_number_fees =
                                    leftNumbers.length * numberFeePerItem;
                            }
                        }
                        if (
                            nameFeePerItem !== null &&
                            rightNameCount > 0 &&
                            hasRight &&
                            nnJson.right &&
                            Array.isArray(nnJson.right)
                        ) {
                            const rightNames = nnJson.right.filter(
                                (nn) =>
                                    nn.name &&
                                    typeof nn.name === "string" &&
                                    nn.name.trim() !== ""
                            );
                            const rightSelected =
                                selectedNameNumber.right || {};
                            if (rightSelected.name === true) {
                                color.right_name_fees =
                                    rightNames.length * nameFeePerItem;
                            }
                        }
                        if (
                            numberFeePerItem !== null &&
                            rightNumberCount > 0 &&
                            hasRight &&
                            nnJson.right &&
                            Array.isArray(nnJson.right)
                        ) {
                            const rightNumbers = nnJson.right.filter(
                                (nn) =>
                                    nn.number !== null &&
                                    nn.number !== undefined &&
                                    nn.number.toString().trim() !== ""
                            );
                            const rightSelected =
                                selectedNameNumber.right || {};
                            if (rightSelected.number === true) {
                                color.right_number_fees =
                                    rightNumbers.length * numberFeePerItem;
                            }
                        }
                    }
                });
            } else {
                // Reset fees to 0 if no names/numbers
                gender_element.colors.forEach((color) => {
                    color.front_number_fees = 0;
                    color.front_name_fees = 0;
                    color.back_name_fees = 0;
                    color.back_number_fees = 0;
                    color.left_name_fees = 0;
                    color.left_number_fees = 0;
                    color.right_name_fees = 0;
                    color.right_number_fees = 0;
                });
            }

            // Front Number Decor Up Fee
            if (gender_element.total_front_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_front_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Front Number Decor Up Fee",
                    value: gender_element.total_front_number_decor_up_fees
                });
            }

            // Back Name Decor Up Fee
            if (gender_element.total_back_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Name Decor Up Fee",
                    value: gender_element.total_back_name_decor_up_fees
                });
            }

            // Back Number Decor Up Fee
            if (gender_element.total_back_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_back_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Back Number Decor Up Fee",
                    value: gender_element.total_back_number_decor_up_fees
                });
            }
            if (gender_element.total_left_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_left_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Left Name Decor Up Fee",
                    value: gender_element.total_left_name_decor_up_fees
                });
            }
            if (gender_element.total_left_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_left_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Left Number Decor Up Fee",
                    value: gender_element.total_left_number_decor_up_fees
                });
            }
            if (gender_element.total_right_name_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_right_name_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Right Name Decor Up Fee",
                    value: gender_element.total_right_name_decor_up_fees
                });
            }
            if (gender_element.total_right_number_decor_up_fees > 0) {
                gender_element.total_color_fee +=
                    gender_element.total_right_number_decor_up_fees;
                detailsForRunCharge.push({
                    name: "Right Number Decor Up Fee",
                    value: gender_element.total_right_number_decor_up_fees
                });
            }

            // Final Total Run Charge
            gender_element.total_color_fee = parseFloat(
                gender_element.total_color_fee.toFixed(2)
            );

            // Setup Fee calculation (similar to ProductDetails calculateSetupFee)
            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty,
                total_decoration_colors_count
            );

            // Other Services Total
            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            // preDiscountTotal (include patch cost + patch additional services rollup_fee_id = 9)
            const patchCostVal = parseFloat(this.patchCost) || 0;
            const patchAdditionalTotal =
                patchCostVal > 0
                    ? this.getPatchAdditionalServicesTotal(total_group_quantity)
                    : 0;
            const preDiscountTotal =
                gender_element.subtotal +
                gender_element.total_color_fee +
                this.setup_fee +
                gender_element.total_design_fee +
                otherServicesTotal +
                patchCostVal +
                patchAdditionalTotal;

            // Discount calculation removed - no longer applying overall discount
            gender_element.total_discount_value = 0;

            // Final Total Cost
            gender_element.total_cost = parseFloat(preDiscountTotal.toFixed(2));
            gender_element.total_setup_fee = this.setup_fee;
            if (this.setup_fee > 0) {
                this.setup_fee_applied_gender_index = index;
            }

            // Breakdown Data Set
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: gender_element.total_setup_fee,
                totalCost: gender_element.total_cost,
                totalDiscount: 0,
                designFee: gender_element.total_design_fee,
                runChargeDetails: detailsForRunCharge,
                patchCost: patchCostVal,
                patchSlabQuantity: this.patchSlabQuantity || 0,
                patchCostDetails: Array.isArray(this.patchCostDetails) ? this.patchCostDetails : [],
                patchAdditionalServicesTotal: patchAdditionalTotal
            };

            this.$forceUpdate();
        },

        calculateSetupFee(activeService, totalQuantity, totalColors) {
            if (
                !activeService ||
                !activeService.master_service ||
                totalQuantity <= 0
            ) {
                return 0;
            }

            const pricing = activeService.master_service;
            const feeStructure = pricing.fee_structure;
            let calculatedFee = 0;

            if (feeStructure == "1") {
                calculatedFee =
                    parseFloat(pricing.setup_fee_color1 || 0) * totalColors;
            } else if (feeStructure == "2") {
                if (totalColors === 1) {
                    calculatedFee = parseFloat(pricing.setup_fee_color1 || 0);
                } else if (totalColors > 1) {
                    calculatedFee = parseFloat(
                        pricing.setup_fee_multicolor || 0
                    );
                }
            }
            return parseFloat(calculatedFee.toFixed(2));
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        showBreakupCharges(gender) {
            if (
                this.setup_fee_applied_gender_index >= 0 &&
                gender.total_setup_fee > 0
            ) {
                return true;
            } else if (gender.total_discount_value > 0) {
                return true;
            } else if (gender.total_design_fee > 0) {
                return true;
            } else if (gender.total_color_fee > 0) {
                return true;
            } else if (gender.total_name_number_fees > 0) {
                return true;
            } else if (this.totalNonStandardFees > 0) {
                return true;
            }

            return true;
        },

        disableImprintLocations(disableColors = true) {
            this.disable_imprint_locations = disableColors;
        },

        getAllMarkupTiers(decoration_type, decoration_price_template) {
            return new Promise((resolve, reject) => {
                const params = {
                    decoration_id: decoration_type,
                    template_id: decoration_price_template
                };
                ApiService.query("/get-markup-tiers", { params })
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },

        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },
        // Calculate estimated date with holidays
        // calculateEstimatedDateWithHolidays(baseDate, daysToAdd) {
        //     // Start from base date (today)
        //     let currentDate = new Date(baseDate);
        //     currentDate.setHours(0, 0, 0, 0);
        //     let daysAdded = 0;

        //     // Get holidays from product or use empty array
        //     const holidays =
        //         this.product && this.product.holidays
        //             ? Array.isArray(this.product.holidays)
        //                 ? this.product.holidays
        //                 : []
        //             : [];

        //     // Convert holidays to Date objects for comparison
        //     const holidayDates = holidays.map((h) => {
        //         const d = new Date(h);
        //         d.setHours(0, 0, 0, 0);
        //         return d;
        //     });

        //     // Add days one by one, skipping holidays
        //     while (daysAdded < daysToAdd) {
        //         currentDate.setDate(currentDate.getDate() + 1);

        //         // Check if current date is a holiday
        //         const currentDateOnly = new Date(currentDate);
        //         currentDateOnly.setHours(0, 0, 0, 0);

        //         const isHoliday = holidayDates.some((h) => {
        //             return h.getTime() === currentDateOnly.getTime();
        //         });

        //         // Only count non-holiday days
        //         if (!isHoliday) {
        //             daysAdded++;
        //         }
        //         // If it's a holiday, we just continue to the next day without incrementing daysAdded
        //     }

        //     // Ensure final date is not a holiday (add extra days if needed)
        //     let finalDateOnly = new Date(currentDate);
        //     finalDateOnly.setHours(0, 0, 0, 0);
        //     while (
        //         holidayDates.some(
        //             (h) => h.getTime() === finalDateOnly.getTime()
        //         )
        //     ) {
        //         currentDate.setDate(currentDate.getDate() + 1);
        //         finalDateOnly = new Date(currentDate);
        //         finalDateOnly.setHours(0, 0, 0, 0);
        //     }

        //     return currentDate;
        // },
        calculateEstimatedDateWithHolidays(baseDate, daysToAdd) {
            // Helper: get YYYY-MM-DD date string in New York timezone
            // This makes holiday comparison universal across all timezones
            var toNYDateString = function(date) {
                return new Intl.DateTimeFormat("en-CA", {
                    timeZone: "America/New_York",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }).format(date);
            };

            // Get holidays from product or use empty array
            var holidays =
                this.product && this.product.holidays
                    ? Array.isArray(this.product.holidays)
                        ? this.product.holidays
                        : []
                    : [];

            // Build a Set of NY holiday date strings
            // API returns "YYYY-MM-DD" strings — treat them as NY calendar dates directly
            // (no Date parsing needed, avoids UTC-shift problem entirely)
            var holidaySet = new Set(
                holidays.map(function(h) {
                    if (typeof h === "string" && /^\d{4}-\d{2}-\d{2}$/.test(h)) {
                        return h; // Already a NY calendar date string, use as-is
                    }
                    return toNYDateString(new Date(h)); // Fallback for other formats
                })
            );

            // Start from base date
            var currentDate = new Date(baseDate);
            var daysAdded = 0;

            // Add days one by one, skipping holidays (compared in NY timezone)
            while (daysAdded < daysToAdd) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (!holidaySet.has(toNYDateString(currentDate))) {
                    daysAdded++;
                }
            }

            // Ensure final date is not a holiday (push forward if needed)
            while (holidaySet.has(toNYDateString(currentDate))) {
                currentDate.setDate(currentDate.getDate() + 1);
            }

            return currentDate;
        },

    // Ensure final date not holiday
  
        // Format rush date for display
        formatRushDateForDisplay(date) {
            if (!date) return "--";
            const d = new Date(date);
            const monthNames = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];
            const month = monthNames[d.getMonth()];
            const day = d.getDate();
            const year = d.getFullYear();
            return `${month} ${day}, ${year}`;
        }
    }
};
</script>
<style>
/* Apply readonly style to the input when the v-select is disabled */
.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
    background-color: transparent !important;
}
.color-itmes-main {
    min-height: 48vh;
    max-height: 48vh;
    overflow-y: auto;
}
@media (max-width: 1700px) {
    .color-itmes-main {
        min-height: 55vh;
        max-height: 55vh;
    }
}
.design_studio_up.product_details_update_v3
    .right_section_main
    .right_section
    .popup_right_section
    .popup_dropdown
    .left-chest-
    .select_color
    .owl-carousel
    .owl-stage-outer
    .owl-stage
    .owl-item {
    min-width: 170px !important;
}

.drop_product.dropdown-menu {
    z-index: 9999 !important;
}

.selected-color-box {
    margin-right: 8px;
}
.colors_qty_header {
    padding-bottom: 10px;
}
.mix-color-badge {
    margin-right: 8px;
    padding: 2px 6px;
    background: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 11px;
}

.color-fee-display {
    margin-left: 10px;
    white-space: nowrap;
    font-size: 14px;
    color: #2b2b2b;
}

.mix-color-label {
    margin-right: 8px;
}

.select_color:first-child .color-fee-display span {
    margin-top: 40px;
}

/* Moved from inline styles */
.validation-error-text {
    color: red;
}

.label-pointer {
    cursor: pointer;
}

.flex-1 {
    flex: 1;
}

.color-box-margin {
    margin-right: 8px;
}

.mix-color-indicator {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 3px;
    vertical-align: middle;
}

.fee-display-margin {
    margin-left: auto;
    margin-right: 8px;
}

/* Color box tooltip styling */
.color-box-tooltip {
    position: relative;
    display: inline-block;
    margin-right: 8px;
    cursor: pointer;
}

.color-box-tooltip:hover::after {
    content: attr(data-hex);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10000;
    margin-bottom: 5px;
    pointer-events: none;
}

.color-box-tooltip:hover::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #333;
    margin-bottom: 0;
    z-index: 10000;
    pointer-events: none;
}
.select_color .v-select {
    min-width: 140px;
}

.number-input {
    padding-left: 5px !important;
}

/* Colors And Qty Details Section */
.colors_qty_details_section {
    margin-top: 16px;
}

.colors_qty_title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
    margin: 0 0 8px 0;
    line-height: 1.2;
}

.colors_qty_note {
    font-size: 14px;
    color: #666;
    margin: 0;
    line-height: 1.4;
    padding-top: 0px !important;
    text-align: left !important;
}

/* Color Configuration Section */
.color_config_section {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-top: 16px;
    background-color: #fff;
}

.color_config_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
}

.color_swatch_name {
    display: flex;
    align-items: center;
    gap: 12px;
}

.color_swatch {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #d0d0d0;
    flex-shrink: 0;
}

.color_name_text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.collapse_icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.color_config_content {
    padding: 0px 16px 16px 16px;
}

/* Size and Qty Section */
.size_qty_section {
    margin-top: 0;
    padding: 12px 8px;
    background-color: #f4f4f4;
    border-radius: 4px;
}

.size_qty_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
}

.size_qty_title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.right_sec_design_studio_t_shirt.direction_block .delete_color_btn {
    background: transparent !important;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    border: none !important;
}

.right_sec_design_studio_t_shirt.direction_block .delete_color_btn img {
    width: 16px;
    height: 16px;
}

.right_sec_design_studio_t_shirt.direction_block .delete_color_btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}

.size_qty_table {
    width: 100%;
}

.size_price_row {
    display: flex;
    gap: 0px;
    background-color: #fff;
}

.size_price_item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0px;
    border: 1px solid #bebebe4d;
}

.size_label {
    font-size: 12px;
    font-weight: 600;
    color: #414141;
    margin-bottom: 4px;
}

.price_label {
    font-size: 12px;
    color: #1d6cb5;
    font-weight: 600;
}

.size_qty_input_row {
    display: flex;
    gap: 0px;
}

.size_qty_input_item {
    flex: 1;
}

.qty_input {
    width: 100%;
    padding: 14px 8px;
    border: 1px solid #bebebe4d;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    text-decoration: underline;
}

.qty_input:focus {
    outline: none;
    border-color: #0079c1;
}

/* Print Area Configuration Section */
.print_area_config_section {
    margin-top: 24px;
}

.print_area_item {
    border-bottom: 1px solid #e0e0e0;
    padding: 6px;
    background: #fff;
}

.print_area_item:last-child {
    border-bottom: none;
}

.print_area_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;
}

.print_area_label {
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: #121212;
    margin: 0;
}

.print_area_header .vs__search {
    height: auto;
    padding: 0px !important;
    border-bottom: none !important;
}

.print_area_header .vs__actions {
    border-bottom: none !important;
    padding-top: 0px !important;
}

.print_area_header .vs__dropdown-menu {
    max-width: 140px;
    width: 100%;
    min-width: 140px;
}

.print_area_header .vs__selected-options {
    width: 100%;
    max-width: 120px;
    justify-content: flex-start;
}

.print_area_controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.color_count_select {
    min-width: 95px;
    margin: 0;
}

.right_sec_design_studio_t_shirt.direction_block .add_remove_color_btn {
    width: 24px !important;
    height: 24px !important;
    border-radius: 50%;
    background-color: #0079c1;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    border: none !important;
}

.right_sec_design_studio_t_shirt.direction_block .add_remove_color_btn svg {
    width: 24px;
    height: 24px;
    stroke: #fff;
}

.add_remove_color_btn {
    width: 24px !important;
    height: 24px !important;
    border-radius: 50%;
    background-color: #0079c1;
    border: none !important;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    position: relative;
    z-index: 10;
    pointer-events: auto !important;
}

.add_remove_color_btn:hover {
    background-color: #0066a3;
}

.add_remove_color_btn svg {
    pointer-events: none;
}

.print_area_content {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0 8px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 6px;
    transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1),
        opacity 0.25s ease-out 0.05s, padding 0.35s cubic-bezier(0.4, 0, 0.2, 1),
        border-color 0.25s ease-out 0.05s,
        margin 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.print_area_content.show {
    max-height: 800px;
    /* Adjust based on your content height */
    opacity: 1;
    padding: 12px 8px;
    border-color: #bebebe66;
    transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
        opacity 0.3s ease-in 0.1s, padding 0.4s cubic-bezier(0.4, 0, 0.2, 1),
        border-color 0.3s ease-in 0.1s, margin 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.thread_color_item {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.thread_color_label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    min-width: 80px;
    margin: 0;
}

.thread_color_item {
    margin-bottom: 0px;
}

.thread_color_item .thread_color_select {
    flex: 1;
    max-width: 33.33%;
}

.thread_color_item .thread_color_select .v-select {
    width: 100%;
    margin-bottom: 6px;
}

.thread_color_item .thread_color_select .v-select .vs__selected span {
    font-size: 12px;
    color: #121212;
    font-weight: 500;
    line-height: 12px;
}
.thread_color_item .thread_color_select .v-select.vs--disabled {
    background: #f4f4f4;
}
.thread_color_item .thread_color_select .v-select.vs--disabled .vs__search {
    border-bottom: none !important;
}
.thread_color_item .thread_color_select .v-select.vs--disabled .vs__actions {
    border-bottom: none !important;
}

.thread_color_item
    .thread_color_select
    .v-select
    .vs__selected
    .imprint_color_box {
    width: 10px;
    height: 10px;
    margin-top: 0px;
    margin-right: 4px;
    margin-right: 8px;
    vertical-align: middle;
    border: 1px solid grey;
}

.thread_color_item .thread_color_select .v-select .vs__selected {
    padding-left: 5px;
    top: 5px;
}

.thread_color_item .thread_color_select .v-select input {
    height: 24px;
    padding: 5px !important;
}

.thread_color_item .thread_color_select .v-select input::placeholder {
    font-size: 12px;
}

.thread_color_item .thread_color_select .v-select .vs__actions {
    padding-top: 0px !important;
}
.thread_color_item .thread_color_label span {
    font-size: 12px;
    color: #121212;
    font-weight: 500;
    line-height: 14px;
}
</style>
